(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRegister("671Hv", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("gUszs")).then(()=>parcelRequire('iBegA'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $c048296b89085e65$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL('EVgbq'), JSON.parse("[\"EVgbq\",\"index.04d1cd95.js\",\"d9irE\",\"konsens.b49e7e7e.svg\",\"gUszs\",\"es5.4dc23260.js\"]"));

var $09ec739d0d47b71c$exports = {};
!function(t) {
    "use strict";
    function e(t, e, r) {
        return r.a = t, r.f = e, r;
    }
    function F2(t) {
        return e(2, t, function(e) {
            return function(r) {
                return t(e, r);
            };
        });
    }
    function F3(t) {
        return e(3, t, function(e) {
            return function(r) {
                return function(n) {
                    return t(e, r, n);
                };
            };
        });
    }
    function F4(t) {
        return e(4, t, function(e) {
            return function(r) {
                return function(n) {
                    return function(a) {
                        return t(e, r, n, a);
                    };
                };
            };
        });
    }
    function F5(t) {
        return e(5, t, function(e) {
            return function(r) {
                return function(n) {
                    return function(a) {
                        return function(u) {
                            return t(e, r, n, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(t) {
        return e(6, t, function(e) {
            return function(r) {
                return function(n) {
                    return function(a) {
                        return function(u) {
                            return function(o) {
                                return t(e, r, n, a, u, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(t) {
        return e(7, t, function(e) {
            return function(r) {
                return function(n) {
                    return function(a) {
                        return function(u) {
                            return function(o) {
                                return function(i) {
                                    return t(e, r, n, a, u, o, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(t, e, r) {
        return 2 === t.a ? t.f(e, r) : t(e)(r);
    }
    function A3(t, e, r, n) {
        return 3 === t.a ? t.f(e, r, n) : t(e)(r)(n);
    }
    function A4(t, e, r, n, a) {
        return 4 === t.a ? t.f(e, r, n, a) : t(e)(r)(n)(a);
    }
    function A5(t, e, r, n, a, u) {
        return 5 === t.a ? t.f(e, r, n, a, u) : t(e)(r)(n)(a)(u);
    }
    function A6(t, e, r, n, a, u, o) {
        return 6 === t.a ? t.f(e, r, n, a, u, o) : t(e)(r)(n)(a)(u)(o);
    }
    function A7(t, e, r, n, a, u, o, i) {
        return 7 === t.a ? t.f(e, r, n, a, u, o, i) : t(e)(r)(n)(a)(u)(o)(i);
    }
    var r = F3(function(t, e, r) {
        for(var n = Array(t), a = 0; t > a; a++)n[a] = r(e + a);
        return n;
    }), n = F2(function(t, e) {
        for(var r = Array(t), n = 0; t > n && e.b; n++)r[n] = e.a, e = e.b;
        return r.length = n, s(r, e);
    });
    function a(t) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + t + ".md");
    }
    function u(t, e) {
        for(var r, n = [], a = o(t, e, 0, n); a && (r = n.pop()); a = o(r.a, r.b, 0, n));
        return a;
    }
    function o(t, e, r, n) {
        if (t === e) return !0;
        if ("object" != typeof t || null === t || null === e) return "function" == typeof t && a(5), !1;
        if (r > 100) return n.push(s(t, e)), !0;
        for(var u in 0 > t.$ && (t = Be(t), e = Be(e)), t)if (!o(t[u], e[u], r + 1, n)) return !1;
        return !0;
    }
    var i = F2(u);
    function c(t, e, r) {
        if ("object" != typeof t) return t === e ? 0 : e > t ? -1 : 1;
        if (void 0 === t.$) return (r = c(t.a, e.a)) || (r = c(t.b, e.b)) ? r : c(t.c, e.c);
        for(; t.b && e.b && !(r = c(t.a, e.a)); t = t.b, e = e.b);
        return r || (t.b ? 1 : e.b ? -1 : 0);
    }
    var f = F2(function(t, e) {
        var r = c(t, e);
        return 0 > r ? Le : r ? ze : Me;
    });
    function s(t, e) {
        return {
            a: t,
            b: e
        };
    }
    function l(t, e) {
        var r = {};
        for(var n in t)r[n] = t[n];
        for(var n in e)r[n] = e[n];
        return r;
    }
    function b(t, e) {
        if ("string" == typeof t) return t + e;
        if (!t.b) return e;
        var r = p(t.a, e);
        t = t.b;
        for(var n = r; t.b; t = t.b)n = n.b = p(t.a, e);
        return r;
    }
    var d = {
        $: 0
    };
    function p(t, e) {
        return {
            $: 1,
            a: t,
            b: e
        };
    }
    var g = F2(p);
    function x(t) {
        for(var e = d, r = t.length; r--;)e = p(t[r], e);
        return e;
    }
    function m(t) {
        for(var e = []; t.b; t = t.b)e.push(t.a);
        return e;
    }
    var h = F3(function(t, e, r) {
        for(var n = []; e.b && r.b; e = e.b, r = r.b)n.push(A2(t, e.a, r.a));
        return x(n);
    }), w = F2(function(t, e) {
        return x(m(e).sort(function(e, r) {
            return c(t(e), t(r));
        }));
    }), v = F2(function(t, e) {
        return t + e;
    }), y = F2(function(t, e) {
        var r = e % t;
        return 0 === t ? a(11) : r > 0 && 0 > t || 0 > r && t > 0 ? r + t : r;
    }), k = Math.ceil, $ = Math.floor, C = Math.round, _ = Math.log, J = isNaN, j = F2(function(t, e) {
        return t + e;
    }), B = F3(function(t, e, r) {
        for(var n = r.length; n--;){
            var a = r[n], u = r.charCodeAt(n);
            56320 > u || u > 57343 || (a = r[--n] + a), e = A2(t, a, e);
        }
        return e;
    }), M = F2(function(t, e) {
        return e.split(t);
    }), z = F2(function(t, e) {
        return e.join(t);
    }), L = F3(function(t, e, r) {
        return r.slice(t, e);
    }), A = F2(function(t, e) {
        for(var r = e.length; r--;){
            var n = e[r], a = e.charCodeAt(r);
            if (56320 > a || a > 57343 || (n = e[--r] + n), !t(n)) return !1;
        }
        return !0;
    }), P = F2(function(t, e) {
        return e.indexOf(t) > -1;
    }), D = F2(function(t, e) {
        return 0 === e.indexOf(t);
    }), N = F2(function(t, e) {
        return e.length >= t.length && e.lastIndexOf(t) === e.length - t.length;
    }), S = F2(function(t, e) {
        var r = t.length;
        if (1 > r) return d;
        for(var n = 0, a = []; (n = e.indexOf(t, n)) > -1;)a.push(n), n += r;
        return x(a);
    });
    function I(t) {
        return t + "";
    }
    function R(t) {
        return {
            $: 2,
            b: t
        };
    }
    var E = R(function(t) {
        return "number" != typeof t ? rt("an INT", t) : t > -2147483647 && 2147483647 > t && (0 | t) === t ? Se(t) : !isFinite(t) || t % 1 ? rt("an INT", t) : Se(t);
    }), T = R(function(t) {
        return "boolean" == typeof t ? Se(t) : rt("a BOOL", t);
    }), H = R(function(t) {
        return "number" == typeof t ? Se(t) : rt("a FLOAT", t);
    }), F = R(function(t) {
        return Se(t);
    }), V = R(function(t) {
        return "string" == typeof t ? Se(t) : t instanceof String ? Se(t + "") : rt("a STRING", t);
    }), Z = F2(function(t, e) {
        return {
            $: 6,
            d: t,
            b: e
        };
    });
    function q(t, e) {
        return {
            $: 9,
            f: t,
            g: e
        };
    }
    var U = F2(function(t, e) {
        return {
            $: 10,
            b: e,
            h: t
        };
    }), Q = F2(function(t, e) {
        return q(t, [
            e
        ]);
    }), O = F3(function(t, e, r) {
        return q(t, [
            e,
            r
        ]);
    }), G = F5(function(t, e, r, n, a) {
        return q(t, [
            e,
            r,
            n,
            a
        ]);
    }), W = F6(function(t, e, r, n, a, u) {
        return q(t, [
            e,
            r,
            n,
            a,
            u
        ]);
    }), Y = F2(function(t, e) {
        return K(t, e);
    });
    function K(t, e) {
        switch(t.$){
            case 2:
                return t.b(e);
            case 5:
                return null === e ? Se(t.c) : rt("null", e);
            case 3:
                return tt(e) ? X(t.b, e, x) : rt("a LIST", e);
            case 4:
                return tt(e) ? X(t.b, e, et) : rt("an ARRAY", e);
            case 6:
                var r = t.d;
                if ("object" != typeof e || null === e || !(r in e)) return rt("an OBJECT with a field named `" + r + "`", e);
                var n = K(t.b, e[r]);
                return Br(n) ? n : Ae(A2(De, r, n.a));
            case 7:
                var a = t.e;
                return tt(e) ? e.length > a ? (n = K(t.b, e[a]), Br(n) ? n : Ae(A2(Ne, a, n.a))) : rt("a LONGER array. Need index " + a + " but only see " + e.length + " entries", e) : rt("an ARRAY", e);
            case 8:
                if ("object" != typeof e || null === e || tt(e)) return rt("an OBJECT", e);
                var u = d;
                for(var o in e)if (e.hasOwnProperty(o)) {
                    if (n = K(t.b, e[o]), !Br(n)) return Ae(A2(De, o, n.a));
                    u = p(s(o, n.a), u);
                }
                return Se(nr(u));
            case 9:
                for(var i = t.f, c = t.g, f = 0; c.length > f; f++){
                    if (n = K(c[f], e), !Br(n)) return n;
                    i = i(n.a);
                }
                return Se(i);
            case 10:
                return n = K(t.b, e), Br(n) ? K(t.h(n.a), e) : n;
            case 11:
                for(var l = d, b = t.g; b.b; b = b.b){
                    if (n = K(b.a, e), Br(n)) return n;
                    l = p(n.a, l);
                }
                return Ae(Ie(nr(l)));
            case 1:
                return Ae(A2(Pe, t.a, e));
            case 0:
                return Se(t.a);
        }
    }
    function X(t, e, r) {
        for(var n = e.length, a = Array(n), u = 0; n > u; u++){
            var o = K(t, e[u]);
            if (!Br(o)) return Ae(A2(Ne, u, o.a));
            a[u] = o.a;
        }
        return Se(r(a));
    }
    function tt(t) {
        return Array.isArray(t) || "undefined" != typeof FileList && t instanceof FileList;
    }
    function et(t) {
        return A2(jr, t.length, function(e) {
            return t[e];
        });
    }
    function rt(t, e) {
        return Ae(A2(Pe, "Expecting " + t, e));
    }
    function nt(t, e) {
        if (t === e) return !0;
        if (t.$ !== e.$) return !1;
        switch(t.$){
            case 0:
            case 1:
                return t.a === e.a;
            case 2:
                return t.b === e.b;
            case 5:
                return t.c === e.c;
            case 3:
            case 4:
            case 8:
                return nt(t.b, e.b);
            case 6:
                return t.d === e.d && nt(t.b, e.b);
            case 7:
                return t.e === e.e && nt(t.b, e.b);
            case 9:
                return t.f === e.f && at(t.g, e.g);
            case 10:
                return t.h === e.h && nt(t.b, e.b);
            case 11:
                return at(t.g, e.g);
        }
    }
    function at(t, e) {
        var r = t.length;
        if (r !== e.length) return !1;
        for(var n = 0; r > n; n++)if (!nt(t[n], e[n])) return !1;
        return !0;
    }
    var ut = F2(function(t, e) {
        return JSON.stringify(e, null, t) + "";
    });
    function ot(t) {
        return t;
    }
    var it = F3(function(t, e, r) {
        return r[t] = e, r;
    });
    function ct(t) {
        return {
            $: 0,
            a: t
        };
    }
    function ft(t) {
        return {
            $: 2,
            b: t,
            c: null
        };
    }
    var st = F2(function(t, e) {
        return {
            $: 3,
            b: t,
            d: e
        };
    }), lt = F2(function(t, e) {
        return {
            $: 4,
            b: t,
            d: e
        };
    }), bt = 0;
    function dt(t) {
        var e = {
            $: 0,
            e: bt++,
            f: t,
            g: null,
            h: []
        };
        return xt(e), e;
    }
    var pt = !1, gt = [];
    function xt(t) {
        if (gt.push(t), !pt) {
            for(pt = !0; t = gt.shift();)mt(t);
            pt = !1;
        }
    }
    function mt(t) {
        for(; t.f;){
            var e = t.f.$;
            if (0 === e || 1 === e) {
                for(; t.g && t.g.$ !== e;)t.g = t.g.i;
                if (!t.g) return;
                t.f = t.g.b(t.f.a), t.g = t.g.i;
            } else {
                if (2 === e) return void (t.f.c = t.f.b(function(e) {
                    t.f = e, xt(t);
                }));
                if (5 === e) {
                    if (0 === t.h.length) return;
                    t.f = t.f.b(t.h.shift());
                } else t.g = {
                    $: 3 === e ? 0 : 1,
                    b: t.f.b,
                    i: t.g
                }, t.f = t.f.d;
            }
        }
    }
    var ht = {};
    function wt(t, e) {
        var r = {
            g: e,
            h: void 0
        }, n = t.c, a = t.d, u = t.e, o = t.f;
        function i(t) {
            return A2(st, i, {
                $: 5,
                b: function(e) {
                    var i = e.a;
                    return 0 === e.$ ? A3(a, r, i, t) : u && o ? A4(n, r, i.i, i.j, t) : A3(n, r, u ? i.i : i.j, t);
                }
            });
        }
        return r.h = dt(A2(st, i, t.b));
    }
    var vt = F2(function(t, e) {
        return ft(function(r) {
            t.g(e), r(ct(0));
        });
    });
    function yt(t) {
        return function(e) {
            return {
                $: 1,
                k: t,
                l: e
            };
        };
    }
    function kt(t) {
        return {
            $: 2,
            m: t
        };
    }
    var $t = F2(function(t, e) {
        return {
            $: 3,
            n: t,
            o: e
        };
    }), Ct = [], _t = !1;
    function Jt(t, e, r) {
        if (Ct.push({
            p: t,
            q: e,
            r: r
        }), !_t) {
            _t = !0;
            for(var n; n = Ct.shift();)jt(n.p, n.q, n.r);
            _t = !1;
        }
    }
    function jt(t, e, r) {
        var n, a = {};
        for(var u in Bt(!0, e, a, null), Bt(!1, r, a, null), t)(n = t[u]).h.push({
            $: "fx",
            a: a[u] || {
                i: d,
                j: d
            }
        }), xt(n);
    }
    function Bt(t, e, r, n) {
        switch(e.$){
            case 1:
                var a = e.k, u = function(t, e, r, n) {
                    function a(t) {
                        for(var e = r; e; e = e.t)t = e.s(t);
                        return t;
                    }
                    return A2(t ? ht[e].e : ht[e].f, a, n);
                }(t, a, n, e.l);
                return void (r[a] = function(t, e, r) {
                    return r = r || {
                        i: d,
                        j: d
                    }, t ? r.i = p(e, r.i) : r.j = p(e, r.j), r;
                }(t, u, r[a]));
            case 2:
                for(var o = e.m; o.b; o = o.b)Bt(t, o.a, r, n);
                return;
            case 3:
                return void Bt(t, e.o, r, {
                    s: e.n,
                    t: n
                });
        }
    }
    function Mt(t) {
        ht[t] && a(3);
    }
    function zt(t, e) {
        return Mt(t), ht[t] = {
            e: Lt,
            u: e,
            a: At
        }, yt(t);
    }
    var Lt = F2(function(t, e) {
        return e;
    });
    function At(t) {
        var e = [], r = ht[t].u, n = ft(function(t) {
            var e = setTimeout(function() {
                t(ct(0));
            }, 0);
            return function() {
                clearTimeout(e);
            };
        });
        return ht[t].b = n, ht[t].c = F3(function(t, a) {
            for(; a.b; a = a.b)for(var u = e, o = r(a.a), i = 0; u.length > i; i++)u[i](o);
            return n;
        }), {
            subscribe: function(t) {
                e.push(t);
            },
            unsubscribe: function(t) {
                var r = (e = e.slice()).indexOf(t);
                0 > r || e.splice(r, 1);
            }
        };
    }
    var Pt = F2(function(t, e) {
        return function(r) {
            return t(e(r));
        };
    });
    var Dt = "undefined" != typeof document ? document : {};
    function Nt(t, e) {
        t.appendChild(e);
    }
    function St(t) {
        return {
            $: 0,
            a: t
        };
    }
    var It = F2(function(t, e) {
        return F2(function(r, n) {
            for(var a = [], u = 0; n.b; n = n.b){
                var o = n.a;
                u += o.b || 0, a.push(o);
            }
            return u += a.length, {
                $: 1,
                c: e,
                d: Gt(r),
                e: a,
                f: t,
                b: u
            };
        });
    }), Rt = It(void 0);
    F2(function(t, e) {
        return F2(function(r, n) {
            for(var a = [], u = 0; n.b; n = n.b){
                var o = n.a;
                u += o.b.b || 0, a.push(o);
            }
            return u += a.length, {
                $: 2,
                c: e,
                d: Gt(r),
                e: a,
                f: t,
                b: u
            };
        });
    })(void 0);
    var Et, Tt = F2(function(t, e) {
        return {
            $: 4,
            j: t,
            k: e,
            b: 1 + (e.b || 0)
        };
    }), Ht = F2(function(t, e) {
        return {
            $: "a0",
            n: t,
            o: e
        };
    }), Ft = F2(function(t, e) {
        return {
            $: "a1",
            n: t,
            o: e
        };
    }), Vt = F2(function(t, e) {
        return {
            $: "a2",
            n: t,
            o: e
        };
    }), Zt = F2(function(t, e) {
        return {
            $: "a3",
            n: t,
            o: e
        };
    }), qt = F3(function(t, e, r) {
        return {
            $: "a4",
            n: e,
            o: {
                f: t,
                o: r
            }
        };
    }), Ut = /^script$/i, Qt = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, Ot = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Gt(t) {
        for(var e = {}; t.b; t = t.b){
            var r = t.a, n = r.$, a = r.n, u = r.o;
            if ("a2" !== n) {
                var o = e[n] || (e[n] = {});
                "a3" === n && "class" === a ? Wt(o, a, u) : o[a] = u;
            } else "className" === a ? Wt(e, a, u) : e[a] = u;
        }
        return e;
    }
    function Wt(t, e, r) {
        var n = t[e];
        t[e] = n ? n + " " + r : r;
    }
    function Yt(t, e) {
        var r = t.$;
        if (5 === r) return Yt(t.k || (t.k = t.m()), e);
        if (0 === r) return Dt.createTextNode(t.a);
        if (4 === r) {
            for(var n = t.k, a = t.j; 4 === n.$;)"object" != typeof a ? a = [
                a,
                n.j
            ] : a.push(n.j), n = n.k;
            var u = {
                j: a,
                p: e
            };
            return (o = Yt(n, u)).elm_event_node_ref = u, o;
        }
        if (3 === r) return Kt(o = t.h(t.g), e, t.d), o;
        var o = t.f ? Dt.createElementNS(t.f, t.c) : Dt.createElement(t.c);
        Kt(o, e, t.d);
        for(var i = t.e, c = 0; i.length > c; c++)Nt(o, Yt(1 === r ? i[c] : i[c].b, e));
        return o;
    }
    function Kt(t, e, r) {
        for(var n in r){
            var a = r[n];
            "a1" === n ? Xt(t, a) : "a0" === n ? re(t, e, a) : "a3" === n ? te(t, a) : "a4" === n ? ee(t, a) : ("value" !== n && "checked" !== n || t[n] !== a) && (t[n] = a);
        }
    }
    function Xt(t, e) {
        var r = t.style;
        for(var n in e)r[n] = e[n];
    }
    function te(t, e) {
        for(var r in e){
            var n = e[r];
            void 0 !== n ? t.setAttribute(r, n) : t.removeAttribute(r);
        }
    }
    function ee(t, e) {
        for(var r in e){
            var n = e[r], a = n.f, u = n.o;
            void 0 !== u ? t.setAttributeNS(a, r, u) : t.removeAttributeNS(a, r);
        }
    }
    function re(t, e, r) {
        var n = t.elmFs || (t.elmFs = {});
        for(var a in r){
            var u = r[a], o = n[a];
            if (u) {
                if (o) {
                    if (o.q.$ === u.$) {
                        o.q = u;
                        continue;
                    }
                    t.removeEventListener(a, o);
                }
                o = ne(e, u), t.addEventListener(a, o, Et && {
                    passive: 2 > Pr(u)
                }), n[a] = o;
            } else t.removeEventListener(a, o), n[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Et = !0;
            }
        }));
    } catch (t) {}
    function ne(t, e) {
        function r(e) {
            var n = r.q, a = K(n.a, e);
            if (Br(a)) {
                for(var u, o = Pr(n), i = a.a, c = o ? 3 > o ? i.a : i.v : i, f = 1 == o ? i.b : 3 == o && i.ak, s = (f && e.stopPropagation(), (2 == o ? i.b : 3 == o && i.ae) && e.preventDefault(), t); u = s.j;){
                    if ("function" == typeof u) c = u(c);
                    else for(var l = u.length; l--;)c = u[l](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return r.q = e, r;
    }
    function ae(t, e) {
        return t.$ == e.$ && nt(t.a, e.a);
    }
    function ue(t, e, r, n) {
        var a = {
            $: e,
            r: r,
            s: n,
            t: void 0,
            u: void 0
        };
        return t.push(a), a;
    }
    function oe(t, e, r, n) {
        if (t !== e) {
            var a = t.$, u = e.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void ue(r, 0, n, e);
                e = function(t) {
                    for(var e = t.e, r = e.length, n = Array(r), a = 0; r > a; a++)n[a] = e[a].b;
                    return {
                        $: 1,
                        c: t.c,
                        d: t.d,
                        e: n,
                        f: t.f,
                        b: t.b
                    };
                }(e), u = 1;
            }
            switch(u){
                case 5:
                    for(var o = t.l, i = e.l, c = o.length, f = c === i.length; f && c--;)f = o[c] === i[c];
                    if (f) return void (e.k = t.k);
                    e.k = e.m();
                    var s = [];
                    return oe(t.k, e.k, s, 0), void (s.length > 0 && ue(r, 1, n, s));
                case 4:
                    for(var l = t.j, b = e.j, d = !1, p = t.k; 4 === p.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        p.j
                    ] : l.push(p.j), p = p.k;
                    for(var g = e.k; 4 === g.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        g.j
                    ] : b.push(g.j), g = g.k;
                    return d && l.length !== b.length ? void ue(r, 0, n, e) : ((d ? function(t, e) {
                        for(var r = 0; t.length > r; r++)if (t[r] !== e[r]) return !1;
                        return !0;
                    }(l, b) : l === b) || ue(r, 2, n, b), void oe(p, g, r, n + 1));
                case 0:
                    return void (t.a !== e.a && ue(r, 3, n, e.a));
                case 1:
                    return void ie(t, e, r, n, fe);
                case 2:
                    return void ie(t, e, r, n, se);
                case 3:
                    if (t.h !== e.h) return void ue(r, 0, n, e);
                    var x = ce(t.d, e.d);
                    x && ue(r, 4, n, x);
                    var m = e.i(t.g, e.g);
                    return void (m && ue(r, 5, n, m));
            }
        }
    }
    function ie(t, e, r, n, a) {
        if (t.c === e.c && t.f === e.f) {
            var u = ce(t.d, e.d);
            u && ue(r, 4, n, u), a(t, e, r, n);
        } else ue(r, 0, n, e);
    }
    function ce(t, e, r) {
        var n;
        for(var a in t)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in e) {
                var u = t[a], o = e[a];
                u === o && "value" !== a && "checked" !== a || "a0" === r && ae(u, o) || ((n = n || {})[a] = o);
            } else (n = n || {})[a] = r ? "a1" === r ? "" : "a0" === r || "a3" === r ? void 0 : {
                f: t[a].f,
                o: void 0
            } : "string" == typeof t[a] ? "" : null;
        } else {
            var i = ce(t[a], e[a] || {}, a);
            i && ((n = n || {})[a] = i);
        }
        for(var c in e)c in t || ((n = n || {})[c] = e[c]);
        return n;
    }
    function fe(t, e, r, n) {
        var a = t.e, u = e.e, o = a.length, i = u.length;
        o > i ? ue(r, 6, n, {
            v: i,
            i: o - i
        }) : i > o && ue(r, 7, n, {
            v: o,
            e: u
        });
        for(var c = i > o ? o : i, f = 0; c > f; f++){
            var s = a[f];
            oe(s, u[f], r, ++n), n += s.b || 0;
        }
    }
    function se(t, e, r, n) {
        for(var a = [], u = {}, o = [], i = t.e, c = e.e, f = i.length, s = c.length, l = 0, b = 0, d = n; f > l && s > b;){
            var p = (J = i[l]).a, g = (j = c[b]).a, x = J.b, m = j.b, h = void 0, w = void 0;
            if (p !== g) {
                var v = i[l + 1], y = c[b + 1];
                if (v) {
                    var k = v.a, $ = v.b;
                    w = g === k;
                }
                if (y) {
                    var C = y.a, _ = y.b;
                    h = p === C;
                }
                if (h && w) oe(x, _, a, ++d), be(u, a, p, m, b, o), d += x.b || 0, de(u, a, p, $, ++d), d += $.b || 0, l += 2, b += 2;
                else if (h) d++, be(u, a, g, m, b, o), oe(x, _, a, d), d += x.b || 0, l += 1, b += 2;
                else if (w) de(u, a, p, x, ++d), d += x.b || 0, oe($, m, a, ++d), d += $.b || 0, l += 2, b += 1;
                else {
                    if (!v || k !== C) break;
                    de(u, a, p, x, ++d), be(u, a, g, m, b, o), d += x.b || 0, oe($, _, a, ++d), d += $.b || 0, l += 2, b += 2;
                }
            } else oe(x, m, a, ++d), d += x.b || 0, l++, b++;
        }
        for(; f > l;){
            var J;
            d++, de(u, a, (J = i[l]).a, x = J.b, d), d += x.b || 0, l++;
        }
        for(; s > b;){
            var j, B = B || [];
            be(u, a, (j = c[b]).a, j.b, void 0, B), b++;
        }
        (a.length > 0 || o.length > 0 || B) && ue(r, 8, n, {
            w: a,
            x: o,
            y: B
        });
    }
    var le = "_elmW6BL";
    function be(t, e, r, n, a, u) {
        var o = t[r];
        if (!o) return u.push({
            r: a,
            A: o = {
                c: 0,
                z: n,
                r: a,
                s: void 0
            }
        }), void (t[r] = o);
        if (1 === o.c) {
            u.push({
                r: a,
                A: o
            }), o.c = 2;
            var i = [];
            return oe(o.z, n, i, o.r), o.r = a, void (o.s.s = {
                w: i,
                A: o
            });
        }
        be(t, e, r + le, n, a, u);
    }
    function de(t, e, r, n, a) {
        var u = t[r];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var o = [];
                return oe(n, u.z, o, a), void ue(e, 9, a, {
                    w: o,
                    A: u
                });
            }
            de(t, e, r + le, n, a);
        } else {
            var i = ue(e, 9, a, void 0);
            t[r] = {
                c: 1,
                z: n,
                r: a,
                s: i
            };
        }
    }
    function pe(t, e, r, n) {
        ge(t, e, r, 0, 0, e.b, n);
    }
    function ge(t, e, r, n, a, u, o) {
        for(var i = r[n], c = i.r; c === a;){
            var f = i.$;
            if (1 === f) pe(t, e.k, i.s, o);
            else if (8 === f) i.t = t, i.u = o, (s = i.s.w).length > 0 && ge(t, e, s, 0, a, u, o);
            else if (9 === f) {
                i.t = t, i.u = o;
                var s, l = i.s;
                l && (l.A.s = t, (s = l.w).length > 0 && ge(t, e, s, 0, a, u, o));
            } else i.t = t, i.u = o;
            if (!(i = r[++n]) || (c = i.r) > u) return n;
        }
        var b = e.$;
        if (4 === b) {
            for(var d = e.k; 4 === d.$;)d = d.k;
            return ge(t, d, r, n, a + 1, u, t.elm_event_node_ref);
        }
        for(var p = e.e, g = t.childNodes, x = 0; p.length > x; x++){
            a++;
            var m = 1 === b ? p[x] : p[x].b, h = a + (m.b || 0);
            if (!(a > c || c > h || (i = r[n = ge(g[x], m, r, n, a, h, o)]) && (c = i.r) <= u)) return n;
            a = h;
        }
        return n;
    }
    function xe(t, e) {
        for(var r = 0; e.length > r; r++){
            var n = e[r], a = n.t, u = me(a, n);
            a === t && (t = u);
        }
        return t;
    }
    function me(t, e) {
        switch(e.$){
            case 0:
                return function(t, e, r) {
                    var n = t.parentNode, a = Yt(e, r);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = t.elm_event_node_ref), n && a !== t && n.replaceChild(a, t), a;
                }(t, e.s, e.u);
            case 4:
                return Kt(t, e.u, e.s), t;
            case 3:
                return t.replaceData(0, t.length, e.s), t;
            case 1:
                return xe(t, e.s);
            case 2:
                return t.elm_event_node_ref ? t.elm_event_node_ref.j = e.s : t.elm_event_node_ref = {
                    j: e.s,
                    p: e.u
                }, t;
            case 6:
                for(var r = e.s, n = 0; r.i > n; n++)t.removeChild(t.childNodes[r.v]);
                return t;
            case 7:
                for(var u = (r = e.s).e, o = t.childNodes[n = r.v]; u.length > n; n++)t.insertBefore(Yt(u[n], e.u), o);
                return t;
            case 9:
                if (!(r = e.s)) return t.parentNode.removeChild(t), t;
                var i = r.A;
                return void 0 !== i.r && t.parentNode.removeChild(t), i.s = xe(t, r.w), t;
            case 8:
                return function(t, e) {
                    var r = e.s, n = function(t, e) {
                        if (t) {
                            for(var r = Dt.createDocumentFragment(), n = 0; t.length > n; n++){
                                var a = t[n].A;
                                Nt(r, 2 === a.c ? a.s : Yt(a.z, e.u));
                            }
                            return r;
                        }
                    }(r.y, e);
                    t = xe(t, r.w);
                    for(var a = r.x, u = 0; a.length > u; u++){
                        var o = a[u], i = o.A, c = 2 === i.c ? i.s : Yt(i.z, e.u);
                        t.insertBefore(c, t.childNodes[o.r]);
                    }
                    return n && Nt(t, n), t;
                }(t, e);
            case 5:
                return e.s(t);
            default:
                a(10);
        }
    }
    function he(t) {
        if (3 === t.nodeType) return St(t.textContent);
        if (1 !== t.nodeType) return St("");
        for(var e = d, r = t.attributes, n = r.length; n--;){
            var a = r[n];
            e = p(A2(Zt, a.name, a.value), e);
        }
        var u = t.tagName.toLowerCase(), o = d, i = t.childNodes;
        for(n = i.length; n--;)o = p(he(i[n]), o);
        return A3(Rt, u, e, o);
    }
    var we = F4(function(t, e, r, n) {
        return function(t, e, r, n, u, o) {
            var i = A2(Y, t, e ? e.flags : void 0);
            Br(i) || a(2);
            var c = {}, f = r(i.a), s = f.a, l = o(d, s), b = function(t, e) {
                var r;
                for(var n in ht){
                    var a = ht[n];
                    a.a && ((r = r || {})[n] = a.a(n, e)), t[n] = wt(a, e);
                }
                return r;
            }(c, d);
            function d(t, e) {
                var r = A2(n, t, s);
                l(s = r.a, e), Jt(c, r.b, u(s));
            }
            return Jt(c, f.b, u(s)), b ? {
                ports: b
            } : {};
        }(e, n, t.ci, t.dH, t.dy, function(e, r) {
            var a = t.dK, u = n.node, o = he(u);
            return function(t, e) {
                e(t);
                var r = 0;
                function n() {
                    r = 1 === r ? 0 : (ve(n), e(t), 1);
                }
                return function(a, u) {
                    t = a, u ? (e(t), 2 === r && (r = 1)) : (0 === r && ve(n), r = 2);
                };
            }(r, function(t) {
                var r = a(t), n = function(t, e) {
                    var r = [];
                    return oe(t, e, r, 0), r;
                }(o, r);
                u = function(t, e, r, n) {
                    return 0 === r.length ? t : (pe(t, e, r, n), xe(t, r));
                }(u, o, n, e), o = r;
            });
        });
    }), ve = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(t) {
        return setTimeout(t, 1e3 / 60);
    });
    var ye = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    });
    var ke = F2(function(t, e) {
        return function(t, e) {
            return ft(function(r) {
                ve(function() {
                    var n = document.getElementById(t);
                    r(n ? ct(e(n)) : {
                        $: 1,
                        a: Nr(t)
                    });
                });
            });
        }(e, function(e) {
            return e[t](), 0;
        });
    }), $e = F2(function(t, e) {
        var r;
        return r = function() {
            return ye.scroll(t, e), 0;
        }, ft(function(t) {
            ve(function() {
                t(ct(r()));
            });
        });
    }), Ce = F2(function(t, e) {
        var r = "g";
        t.cu && (r += "m"), t.bt && (r += "i");
        try {
            return Ee(RegExp(e, r));
        } catch (t) {
            return Te;
        }
    }), _e = F4(function(t, e, r, n) {
        var a = 0;
        return n.replace(e, function(e) {
            if (a++ >= t) return e;
            for(var n = arguments.length - 3, u = Array(n); n > 0;){
                var o = arguments[n];
                u[--n] = o ? Ee(o) : Te;
            }
            return r(A4(Uc, e, arguments[arguments.length - 2], a, x(u)));
        });
    }), Je = g, je = F3(function(t, e, r) {
        for(;;){
            if (-2 === r.$) return e;
            var n = r.d, a = t, u = A3(t, r.b, r.c, A3(je, t, e, r.e));
            t = a, e = u, r = n;
        }
    }), Be = function(t) {
        return A3(je, F3(function(t, e, r) {
            return A2(Je, s(t, e), r);
        }), d, t);
    }, Me = 1, ze = 2, Le = 0, Ae = function(t) {
        return {
            $: 1,
            a: t
        };
    }, Pe = F2(function(t, e) {
        return {
            $: 3,
            a: t,
            b: e
        };
    }), De = F2(function(t, e) {
        return {
            $: 0,
            a: t,
            b: e
        };
    }), Ne = F2(function(t, e) {
        return {
            $: 1,
            a: t,
            b: e
        };
    }), Se = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Ie = function(t) {
        return {
            $: 2,
            a: t
        };
    }, Re = v, Ee = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Te = {
        $: 1
    }, He = A, Fe = ut, Ve = I, Ze = F2(function(t, e) {
        return A2(z, t, m(e));
    }), qe = F2(function(t, e) {
        return x(A2(M, t, e));
    }), Ue = function(t) {
        return A2(Ze, "\n    ", A2(qe, "\n", t));
    }, Qe = F3(function(t, e, r) {
        for(;;){
            if (!r.b) return e;
            var n = r.b, a = t, u = A2(t, r.a, e);
            t = a, e = u, r = n;
        }
    }), Oe = function(t) {
        return A3(Qe, F2(function(t, e) {
            return e + 1;
        }), 0, t);
    }, Ge = h, We = F3(function(t, e, r) {
        for(;;){
            if (c(t, e) >= 1) return r;
            var n = t, a = e - 1, u = A2(Je, e, r);
            t = n, e = a, r = u;
        }
    }), Ye = F2(function(t, e) {
        return A3(We, t, e, d);
    }), Ke = F2(function(t, e) {
        return A3(Ge, t, A2(Ye, 0, Oe(e) - 1), e);
    }), Xe = function(t) {
        var e = t.charCodeAt(0);
        return 55296 > e || e > 56319 ? e : 1024 * (e - 55296) + t.charCodeAt(1) - 56320 + 65536;
    }, tr = function(t) {
        var e = Xe(t);
        return e >= 97 && 122 >= e;
    }, er = function(t) {
        var e = Xe(t);
        return 90 >= e && e >= 65;
    }, rr = function(t) {
        return tr(t) || er(t) || function(t) {
            var e = Xe(t);
            return 57 >= e && e >= 48;
        }(t);
    }, nr = function(t) {
        return A3(Qe, Je, d, t);
    }, ar = function(t) {
        var e = t.charCodeAt(0);
        return isNaN(e) ? Te : Ee(55296 > e || e > 56319 ? s(t[0], t.slice(1)) : s(t[0] + t[1], t.slice(2)));
    }, ur = F2(function(t, e) {
        return "\n\n(" + Ve(t + 1) + ") " + Ue(or(e));
    }), or = function(t) {
        return A2(ir, t, d);
    }, ir = F2(function(t, e) {
        t: for(;;)switch(t.$){
            case 0:
                var r = t.a, n = t.b, a = function() {
                    var t = ar(r);
                    if (1 === t.$) return !1;
                    var e, n = t.a, a = n.b;
                    return (tr(e = n.a) || er(e)) && A2(He, rr, a);
                }();
                t = n, e = A2(Je, a ? "." + r : "['" + r + "']", e);
                continue t;
            case 1:
                n = t.b;
                var u = "[" + Ve(t.a) + "]";
                t = n, e = A2(Je, u, e);
                continue t;
            case 2:
                var o = t.a;
                if (o.b) {
                    if (o.b.b) {
                        var i = (e.b ? "The Json.Decode.oneOf at json" + A2(Ze, "", nr(e)) : "Json.Decode.oneOf") + " failed in the following " + Ve(Oe(o)) + " ways:";
                        return A2(Ze, "\n\n", A2(Je, i, A2(Ke, ur, o)));
                    }
                    t = n = o.a;
                    continue t;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (e.b ? " at json" + A2(Ze, "", nr(e)) : "!");
            default:
                var c = t.a, f = t.b;
                return (i = e.b ? "Problem with the value at json" + A2(Ze, "", nr(e)) + ":\n\n    " : "Problem with the given value:\n\n") + Ue(A2(Fe, 4, f)) + "\n\n" + c;
        }
    }), cr = 32, fr = F4(function(t, e, r, n) {
        return {
            $: 0,
            a: t,
            b: e,
            c: r,
            d: n
        };
    }), sr = [], lr = k, br = F2(function(t, e) {
        return _(e) / _(t);
    }), dr = lr(A2(br, 2, cr)), pr = A4(fr, 0, dr, sr, sr), gr = r, xr = F2(function(t, e) {
        return e(t);
    }), mr = i, hr = $, wr = function(t) {
        return t.length;
    }, vr = F2(function(t, e) {
        return c(t, e) > 0 ? t : e;
    }), yr = n, kr = F2(function(t, e) {
        for(;;){
            var r = A2(yr, cr, t), n = r.b, a = A2(Je, {
                $: 0,
                a: r.a
            }, e);
            if (!n.b) return nr(a);
            t = n, e = a;
        }
    }), $r = function(t) {
        return t.a;
    }, Cr = F2(function(t, e) {
        for(;;){
            var r = lr(e / cr);
            if (1 === r) return A2(yr, cr, t).a;
            t = A2(kr, t, d), e = r;
        }
    }), _r = F2(function(t, e) {
        if (e.e) {
            var r = e.e * cr, n = hr(A2(br, cr, r - 1)), a = t ? nr(e.i) : e.i, u = A2(Cr, a, e.e);
            return A4(fr, wr(e.g) + r, A2(vr, 5, n * dr), u, e.g);
        }
        return A4(fr, wr(e.g), dr, sr, e.g);
    }), Jr = F5(function(t, e, r, n, a) {
        for(;;){
            if (0 > e) return A2(_r, !1, {
                i: n,
                e: r / cr | 0,
                g: a
            });
            var u = {
                $: 1,
                a: A3(gr, cr, e, t)
            };
            e -= cr, n = A2(Je, u, n);
        }
    }), jr = F2(function(t, e) {
        if (t > 0) {
            var r = t % cr;
            return A5(Jr, e, t - r - cr, t, d, A3(gr, r, t - r, e));
        }
        return pr;
    }), Br = function(t) {
        return !t.$;
    }, Mr = U, zr = Q, Lr = O, Ar = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Pr = function(t) {
        switch(t.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Dr = function(t) {
        return t;
    }, Nr = Dr, Sr = F6(function(t, e, r, n, a, u) {
        return {
            av: u,
            aA: e,
            aI: n,
            aN: r,
            aS: t,
            aT: a
        };
    }), Ir = P, Rr = function(t) {
        return t.length;
    }, Er = L, Tr = F2(function(t, e) {
        return 1 > t ? e : A3(Er, t, Rr(e), e);
    }), Hr = S, Fr = function(t) {
        return "" === t;
    }, Vr = F2(function(t, e) {
        return 1 > t ? "" : A3(Er, 0, t, e);
    }), Zr = function(t) {
        for(var e = 0, r = t.charCodeAt(0), n = 43 == r || 45 == r ? 1 : 0, a = n; t.length > a; ++a){
            var u = t.charCodeAt(a);
            if (48 > u || u > 57) return Te;
            e = 10 * e + u - 48;
        }
        return a == n ? Te : Ee(45 == r ? -e : e);
    }, qr = F5(function(t, e, r, n, a) {
        if (Fr(a) || A2(Ir, "@", a)) return Te;
        var u = A2(Hr, ":", a);
        if (u.b) {
            if (u.b.b) return Te;
            var o = u.a, i = Zr(A2(Tr, o + 1, a));
            if (1 === i.$) return Te;
            var c = i;
            return Ee(A6(Sr, t, A2(Vr, o, a), c, e, r, n));
        }
        return Ee(A6(Sr, t, a, Te, e, r, n));
    }), Ur = F4(function(t, e, r, n) {
        if (Fr(n)) return Te;
        var a = A2(Hr, "/", n);
        if (a.b) {
            var u = a.a;
            return A5(qr, t, A2(Tr, u, n), e, r, A2(Vr, u, n));
        }
        return A5(qr, t, "/", e, r, n);
    }), Qr = F3(function(t, e, r) {
        if (Fr(r)) return Te;
        var n = A2(Hr, "?", r);
        if (n.b) {
            var a = n.a;
            return A4(Ur, t, Ee(A2(Tr, a + 1, r)), e, A2(Vr, a, r));
        }
        return A4(Ur, t, Te, e, r);
    }), Or = F2(function(t, e) {
        if (Fr(e)) return Te;
        var r = A2(Hr, "#", e);
        if (r.b) {
            var n = r.a;
            return A3(Qr, t, Ee(A2(Tr, n + 1, e)), A2(Vr, n, e));
        }
        return A3(Qr, t, Te, e);
    }), Gr = D, Wr = ct, Yr = Wr(0), Kr = F4(function(t, e, r, n) {
        if (n.b) {
            var a = n.a, u = n.b;
            if (u.b) {
                var o = u.a, i = u.b;
                if (i.b) {
                    var c = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(t, a, A2(t, o, A2(t, c, A2(t, f.a, r > 500 ? A3(Qe, t, e, nr(s)) : A4(Kr, t, e, r + 1, s)))));
                    }
                    return A2(t, a, A2(t, o, A2(t, c, e)));
                }
                return A2(t, a, A2(t, o, e));
            }
            return A2(t, a, e);
        }
        return e;
    }), Xr = F3(function(t, e, r) {
        return A4(Kr, t, e, 0, r);
    }), tn = F2(function(t, e) {
        return A3(Xr, F2(function(e, r) {
            return A2(Je, t(e), r);
        }), d, e);
    }), en = st, rn = F2(function(t, e) {
        return A2(en, function(e) {
            return Wr(t(e));
        }, e);
    }), nn = F3(function(t, e, r) {
        return A2(en, function(e) {
            return A2(en, function(r) {
                return Wr(A2(t, e, r));
            }, r);
        }, e);
    }), an = vt, un = F2(function(t, e) {
        var r = e;
        return function(t) {
            return ft(function(e) {
                e(ct(dt(t)));
            });
        }(A2(en, an(t), r));
    });
    ht.Task = {
        b: Yr,
        c: F3(function(t, e) {
            var r;
            return A2(rn, function() {
                return 0;
            }, (r = A2(tn, un(t), e), A3(Xr, nn(Je), Wr(d), r)));
        }),
        d: F3(function() {
            return Wr(0);
        }),
        e: F2(function(t, e) {
            return A2(rn, t, e);
        }),
        f: undefined
    };
    var on, cn, fn, sn, ln, bn, dn, pn = yt("Task"), gn = F2(function(t, e) {
        return pn(A2(rn, t, e));
    }), xn = we, mn = Z, hn = H, wn = function(t) {
        return {
            $: 9,
            a: t
        };
    }, vn = function(t) {
        return {
            $: 7,
            a: t
        };
    }, yn = {
        $: 1
    }, kn = {
        $: 0
    }, $n = {
        $: 0
    }, Cn = function(t) {
        return {
            $: 2,
            a: t
        };
    }, _n = kt, Jn = F2(function(t, e) {
        return {
            F: t,
            o: e
        };
    }), jn = ot, Bn = function(t) {
        return A3(Qe, F2(function(t, e) {
            return A3(it, t.a, t.b, e);
        }), {}, t);
    }, Mn = zt("toJS", function(t) {
        return Bn(x([
            s("tag", jn(t.F)),
            s("value", t.o)
        ]));
    }), zn = function(t) {
        return Mn(A2(Jn, "GetQuestion", jn(t)));
    }, Ln = F2(function(t, e) {
        return {
            $: 0,
            a: t,
            b: e
        };
    }), An = Ln, Pn = ft(function(t) {
        t(ct(A2(An, -(new Date).getTimezoneOffset(), d)));
    }), Dn = F2(function(t, e) {
        return {
            $: 0,
            a: t,
            b: e
        };
    }), Nn = function(t) {
        var e = t.b;
        return A2(Dn, 1664525 * t.a + e >>> 0, e);
    }, Sn = function(t) {
        var e = Nn(A2(Dn, 0, 1013904223));
        return Nn(A2(Dn, e.a + t >>> 0, e.b));
    }, In = $t, Rn = Dr, En = _n(d), Tn = C, Hn = {
        $: 2
    }, Fn = F5(function(t, e, r, n, a) {
        return {
            y: n,
            z: r,
            x: e,
            o: a,
            B: t
        };
    }), Vn = function(t) {
        return t.b && ("" !== t.a || t.b.b) ? A2(Je, t.a, Vn(t.b)) : d;
    }, Zn = F2(function(t, e) {
        return Ee(1 === e.$ ? x([
            t
        ]) : A2(Je, t, e.a));
    }), qn = function(t) {
        try {
            return Ee(decodeURIComponent(t));
        } catch (t) {
            return Te;
        }
    }, Un = f, Qn = F2(function(t, e) {
        t: for(;;){
            if (-2 === e.$) return Te;
            var r = e.c, n = e.d, a = e.e;
            switch(A2(Un, t, e.b)){
                case 0:
                    e = n;
                    continue t;
                case 1:
                    return Ee(r);
                default:
                    e = a;
                    continue t;
            }
        }
    }), On = F5(function(t, e, r, n, a) {
        return {
            $: -1,
            a: t,
            b: e,
            c: r,
            d: n,
            e: a
        };
    }), Gn = {
        $: -2
    }, Wn = F5(function(t, e, r, n, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== n.$ || n.a || -1 !== n.d.$ || n.d.a) return A5(On, t, e, r, n, a);
            var u = n.d;
            return o = n.e, A5(On, 0, n.b, n.c, A5(On, 1, u.b, u.c, u.d, u.e), A5(On, 1, e, r, o, a));
        }
        var o, i = a.b, c = a.c, f = a.d, s = a.e;
        return -1 !== n.$ || n.a ? A5(On, t, i, c, A5(On, 0, e, r, n, f), s) : A5(On, 0, e, r, A5(On, 1, n.b, n.c, n.d, o = n.e), A5(On, 1, i, c, f, s));
    }), Yn = F3(function(t, e, r) {
        if (-2 === r.$) return A5(On, 0, t, e, Gn, Gn);
        var n = r.a, a = r.b, u = r.c, o = r.d, i = r.e;
        switch(A2(Un, t, a)){
            case 0:
                return A5(Wn, n, a, u, A3(Yn, t, e, o), i);
            case 1:
                return A5(On, n, a, e, o, i);
            default:
                return A5(Wn, n, a, u, o, A3(Yn, t, e, i));
        }
    }), Kn = F3(function(t, e, r) {
        var n = A3(Yn, t, e, r);
        return -1 !== n.$ || n.a ? n : A5(On, 1, n.b, n.c, n.d, n.e);
    }), Xn = function(t) {
        if (-1 === t.$ && -1 === t.d.$ && -1 === t.e.$) {
            if (-1 !== t.e.d.$ || t.e.d.a) {
                var e = t.d, r = t.e;
                return o = r.b, i = r.c, n = r.d, s = r.e, A5(On, 1, t.b, t.c, A5(On, 0, e.b, e.c, e.d, e.e), A5(On, 0, o, i, n, s));
            }
            var n, a = t.d, u = t.e, o = u.b, i = u.c, c = (n = u.d).d, f = n.e, s = u.e;
            return A5(On, 0, n.b, n.c, A5(On, 1, t.b, t.c, A5(On, 0, a.b, a.c, a.d, a.e), c), A5(On, 1, o, i, f, s));
        }
        return t;
    }, ta = function(t) {
        if (-1 === t.$ && -1 === t.d.$ && -1 === t.e.$) {
            if (-1 !== t.d.d.$ || t.d.d.a) {
                var e = t.d, r = t.e;
                return f = r.b, s = r.c, l = r.d, b = r.e, A5(On, 1, n = t.b, a = t.c, A5(On, 0, e.b, e.c, e.d, i = e.e), A5(On, 0, f, s, l, b));
            }
            var n = t.b, a = t.c, u = t.d, o = u.d, i = u.e, c = t.e, f = c.b, s = c.c, l = c.d, b = c.e;
            return A5(On, 0, u.b, u.c, A5(On, 1, o.b, o.c, o.d, o.e), A5(On, 1, n, a, i, A5(On, 0, f, s, l, b)));
        }
        return t;
    }, ea = F7(function(t, e, r, n, a, u, o) {
        if (-1 !== u.$ || u.a) {
            t: for(;;){
                if (-1 === o.$ && 1 === o.a) {
                    if (-1 === o.d.$) {
                        if (1 === o.d.a) return ta(e);
                        break t;
                    }
                    return ta(e);
                }
                break t;
            }
            return e;
        }
        return A5(On, r, u.b, u.c, u.d, A5(On, 0, n, a, u.e, o));
    }), ra = function(t) {
        if (-1 === t.$ && -1 === t.d.$) {
            var e = t.a, r = t.b, n = t.c, a = t.d, u = a.d, o = t.e;
            if (1 === a.a) {
                if (-1 !== u.$ || u.a) {
                    var i = Xn(t);
                    if (-1 === i.$) {
                        var c = i.e;
                        return A5(Wn, i.a, i.b, i.c, ra(i.d), c);
                    }
                    return Gn;
                }
                return A5(On, e, r, n, ra(a), o);
            }
            return A5(On, e, r, n, ra(a), o);
        }
        return Gn;
    }, na = F2(function(t, e) {
        if (-2 === e.$) return Gn;
        var r = e.a, n = e.b, a = e.c, u = e.d, o = e.e;
        if (0 > c(t, n)) {
            if (-1 === u.$ && 1 === u.a) {
                var i = u.d;
                if (-1 !== i.$ || i.a) {
                    var f = Xn(e);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(Wn, f.a, f.b, f.c, A2(na, t, f.d), s);
                    }
                    return Gn;
                }
                return A5(On, r, n, a, A2(na, t, u), o);
            }
            return A5(On, r, n, a, A2(na, t, u), o);
        }
        return A2(aa, t, A7(ea, t, e, r, n, a, u, o));
    }), aa = F2(function(t, e) {
        if (-1 === e.$) {
            var r = e.a, n = e.b, a = e.c, o = e.d, i = e.e;
            if (u(t, n)) {
                var c = function(t) {
                    for(;;){
                        if (-1 !== t.$ || -1 !== t.d.$) return t;
                        t = t.d;
                    }
                }(i);
                return -1 === c.$ ? A5(Wn, r, c.b, c.c, o, ra(i)) : Gn;
            }
            return A5(Wn, r, n, a, o, A2(na, t, i));
        }
        return Gn;
    }), ua = F2(function(t, e) {
        var r = A2(na, t, e);
        return -1 !== r.$ || r.a ? r : A5(On, 1, r.b, r.c, r.d, r.e);
    }), oa = F3(function(t, e, r) {
        var n = e(A2(Qn, t, r));
        return n.$ ? A2(ua, t, r) : A3(Kn, t, n.a, r);
    }), ia = F2(function(t, e) {
        var r = A2(qe, "=", t);
        if (r.b && r.b.b && !r.b.b.b) {
            var n = r.b.a, a = qn(r.a);
            if (1 === a.$) return e;
            var u = a.a, o = qn(n);
            return 1 === o.$ ? e : A3(oa, u, Zn(o.a), e);
        }
        return e;
    }), ca = Gn, fa = F2(function(t, e) {
        var r;
        return function(t) {
            t: for(;;){
                if (t.b) {
                    var e = t.a, r = e.x;
                    if (r.b) {
                        if ("" !== r.a || r.b.b) {
                            t = t.b;
                            continue t;
                        }
                        return Ee(e.o);
                    }
                    return Ee(e.o);
                }
                return Te;
            }
        }(t(A5(Fn, d, function(t) {
            var e = A2(qe, "/", t);
            return Vn(e.b && "" === e.a ? e.b : e);
        }(e.aI), 1 === (r = e.aT).$ ? ca : A3(Xr, ia, ca, A2(qe, "&", r.a)), e.av, Dr)));
    }), sa = function(t) {
        return {
            $: 1,
            a: t
        };
    }, la = {
        $: 0
    }, ba = F2(function(t, e) {
        return A5(Fn, e.B, e.x, e.z, e.y, t(e.o));
    }), da = F2(function(t, e) {
        var r = e;
        return function(e) {
            var n = e.B, a = e.x, u = e.z, o = e.y;
            return A2(tn, ba(e.o), r(A5(Fn, n, a, u, o, t)));
        };
    }), pa = F2(function(t, e) {
        return e.b ? A3(Xr, Je, e, t) : t;
    }), ga = F2(function(t, e) {
        return A3(Xr, pa, d, A2(tn, t, e));
    }), xa = F2(function(t, e) {
        return function(t) {
            var r = t.B, n = t.x, a = t.z, u = t.y, o = t.o;
            if (n.b) {
                var i = n.a, c = n.b, f = e(i);
                if (f.$) return d;
                var s = f.a;
                return x([
                    A5(Fn, A2(Je, i, r), c, a, u, o(s))
                ]);
            }
            return d;
        };
    }), ma = A2(xa, "STRING", Ee), ha = function(t) {
        return x([
            t
        ]);
    }, wa = (on = x([
        A2(da, la, ha),
        A2(da, sa, ma)
    ]), function(t) {
        return A2(ga, function(e) {
            return e(t);
        }, on);
    }), va = F2(function(t, e) {
        return e.$ ? t : e.a;
    }), ya = A2(Ln, 0, d), ka = E, $a = V, Ca = kt, _a = function(t) {
        return {
            $: 8,
            a: t
        };
    }, Ja = function(t) {
        return {
            $: 0,
            a: t
        };
    }, ja = function(t) {
        return {
            $: 5,
            a: t
        };
    }, Ba = function(t) {
        return {
            $: 3,
            a: t
        };
    }, Ma = function(t) {
        return {
            $: 1,
            a: t
        };
    }, za = function(t) {
        return {
            $: 4,
            a: t
        };
    }, La = {
        $: 3
    }, Aa = {
        $: 2
    }, Pa = function(t) {
        return {
            $: 11,
            a: t
        };
    }, Da = function(t) {
        return {
            $: 9,
            a: t
        };
    }, Na = function(t) {
        return {
            $: 7,
            a: t
        };
    }, Sa = function(t) {
        return {
            $: 6,
            a: t
        };
    }, Ia = function(t) {
        return {
            $: 1,
            a: t
        };
    }, Ra = function(t) {
        return {
            $: 2,
            a: t
        };
    }, Ea = function(t) {
        return {
            $: 8,
            a: t
        };
    }, Ta = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Ha = function(t) {
        return {
            $: 5,
            a: t
        };
    }, Fa = function(t) {
        return {
            $: 4,
            a: t
        };
    }, Va = {
        $: 6
    }, Za = {
        $: 6
    }, qa = Y, Ua = function(t) {
        return {
            $: 3,
            b: t
        };
    }, Qa = F2(function(t, e) {
        return e.$ ? Ae(e.a) : Se(t(e.a));
    }), Oa = F2(function(t, e) {
        return e.$ ? Ae(t(e.a)) : Se(e.a);
    }), Ga = F2(function(t, e) {
        return {
            aR: t,
            aU: e
        };
    }), Wa = F2(function(t, e) {
        return e.$ ? Te : Ee(t(e.a));
    }), Ya = F2(function(t, e) {
        return e.$ ? Te : t(e.a);
    }), Ka = function(t) {
        return {
            $: 11,
            g: t
        };
    }, Xa = F, tu = F2(function(t, e) {
        return A2(Mr, function(r) {
            return A2(qa, A2(mn, t, Xa), r).$ ? Ar(Te) : A2(zr, Ee, A2(mn, t, e));
        }, Xa);
    }), eu = F2(function(t, e) {
        return A2(zr, Ya(Dr), A2(tu, t, function(t) {
            var e;
            return Ka(x([
                (e = Te, {
                    $: 5,
                    c: e
                }),
                A2(zr, Ee, t)
            ]));
        }(e)));
    }), ru = A3(Lr, Ga, A2(zr, Wa(Rn), A2(eu, "proposalsEndedAt", ka)), A2(zr, Wa(Rn), A2(eu, "ratingEndedAt", ka))), nu = F5(function(t, e, r, n, a) {
        return {
            P: e,
            k: n,
            aB: t,
            ck: a,
            h: r
        };
    }), au = T, uu = W, ou = A6(uu, nu, A2(mn, "id", $a), A2(zr, Rn, A2(mn, "createdAt", ka)), A2(mn, "title", $a), A2(eu, "description", $a), A2(mn, "isExcluded", au)), iu = function(t) {
        return {
            $: 0,
            a: t
        };
    }, cu = function(t) {
        return {
            $: 1,
            a: t
        };
    }, fu = function(t) {
        return {
            $: 2,
            a: t
        };
    }, su = Lr(xr), lu = F4(function(t, e, r, n) {
        return {
            bn: e,
            P: n,
            c$: r,
            c2: t
        };
    }), bu = G, du = A5(bu, lu, A2(mn, "proposalId", $a), A2(mn, "author", $a), A2(mn, "points", ka), A2(zr, Rn, A2(mn, "createdAt", ka))), pu = A2(su, A2(eu, "phaseCodePublic", $a), A2(su, A2(mn, "ratings", Ua(du)), A2(su, A2(mn, "proposals", Ua(ou)), A2(su, A2(eu, "description", $a), A2(su, A2(mn, "author", $a), A2(su, A2(mn, "title", $a), A2(su, A2(zr, Wa(Rn), A2(eu, "ratingEndedAt", ka)), A2(su, A2(zr, Wa(Rn), A2(eu, "proposalsEndedAt", ka)), A2(su, A2(zr, Rn, A2(mn, "expiresAt", ka)), A2(su, A2(zr, Rn, A2(mn, "createdAt", ka)), A2(su, A2(mn, "id", $a), Ar(function(t) {
        return function(e) {
            return function(r) {
                return function(n) {
                    return function(a) {
                        return function(u) {
                            return function(o) {
                                return function(i) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    bn: o,
                                                    P: e,
                                                    k: i,
                                                    bT: r,
                                                    aB: t,
                                                    cQ: s,
                                                    c6: c,
                                                    aR: n,
                                                    aU: a,
                                                    aW: f,
                                                    h: u
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), gu = F3(function(t, e, r) {
        return A2(Mr, function(t) {
            return e(t) ? r : {
                $: 1,
                a: "Check failed with input"
            };
        }, t);
    }), xu = (cn = A2(mn, "phase", $a), fn = F2(function(t, e) {
        return u(t, e);
    }), Ka(x([
        A2(zr, iu, A3(gu, cn, fn("PROPOSAL"), pu)),
        A2(zr, cu, A3(gu, cn, fn("RATING"), pu)),
        A2(zr, fu, A3(gu, cn, fn("RESULT"), pu))
    ]))), mu = function(t) {
        var e = function() {
            switch(t.F){
                case "GoToNotFound":
                    return Se(Aa);
                case "ReceivedError":
                    return A2(Oa, Ja, A2(Qa, vn, A2(Qa, Da, A2(qa, $a, t.o))));
                case "QuestionDeleted":
                    return Se(_a(Va));
                case "ReceivedQuestion":
                    return A2(Oa, Ma, A2(Qa, vn, A2(Qa, Fa, A2(qa, xu, t.o))));
                case "ReceivedPublishedProposal":
                    return A2(Oa, Ba, A2(Qa, vn, A2(Qa, Ta, A2(qa, ou, t.o))));
                case "ReceivedNewProposals":
                    return A2(Oa, Ba, A2(Qa, vn, A2(Qa, Ia, A2(qa, Ua(ou), t.o))));
                case "ReceivedPublishedRating":
                    return A2(Oa, za, A2(Qa, vn, A2(Qa, Ha, A2(qa, Ua(du), t.o))));
                case "ReceivedNewRatings":
                    return A2(Oa, Ba, A2(Qa, vn, A2(Qa, Ra, A2(qa, Ua(du), t.o))));
                case "DeletedQuestion":
                    return Se(vn(La));
                case "ReceivedHashedPhaseCode":
                    return A2(Oa, ja, A2(Qa, vn, A2(Qa, Sa, A2(qa, $a, t.o))));
                case "ReceivedHashedDeleteCode":
                    return A2(Oa, ja, A2(Qa, vn, A2(Qa, Na, A2(qa, $a, t.o))));
                case "ReceivedPhaseChange":
                    return A2(Oa, Ma, A2(Qa, vn, A2(Qa, Ea, A2(qa, ru, t.o))));
                default:
                    return Ae(Za);
            }
        }();
        if (!e.$) return e.a;
        var r = e.a;
        switch(r.$){
            case 6:
                return Pa("decodeJSMessage: unknown tag " + t.F);
            case 0:
                return Pa("DecodeErrorMessageError: " + or(r.a));
            case 1:
                return Pa("DecodeQuestionError: " + or(r.a));
            case 2:
                return Pa("DecodeProposalsError: " + or(r.a));
            case 5:
                return Pa("DecodeHashError: " + or(r.a));
            default:
                return Pa("decodeJSMessage: parsing error with tag " + t.F);
        }
    }, hu = (sn = "fromJS", ln = A2(Mr, function(t) {
        return A2(Mr, function(e) {
            return Ar({
                F: e,
                o: t
            });
        }, A2(mn, "tag", $a));
    }, A2(mn, "value", Xa)), Mt(sn), ht[sn] = {
        f: Pt,
        u: ln,
        a: function(t, e) {
            var r = d, n = ht[t].u, u = ct(null);
            return ht[t].b = u, ht[t].c = F3(function(t, e) {
                return r = e, u;
            }), {
                send: function(t) {
                    var u = A2(Y, n, t);
                    Br(u) || a(4);
                    for(var o = u.a, i = r; i.b; i = i.b)e(i.a(o));
                }
            };
        }
    }, yt(sn)), wu = function(t) {
        return {
            $: 1,
            a: t
        };
    }, vu = function(t) {
        return {
            $: 3,
            a: t
        };
    }, yu = {
        $: 8
    }, ku = {
        $: 10
    }, $u = {
        $: 5
    }, Cu = function(t) {
        return {
            $: 7,
            a: t
        };
    }, _u = {
        $: 2
    }, Ju = F2(function(t, e) {
        return {
            k: e,
            h: t
        };
    }), ju = {
        $: 3
    }, Bu = {
        $: 4
    }, Mu = F2(function(t, e) {
        return {
            $: 3,
            a: t,
            b: e
        };
    }), zu = {
        $: 2
    }, Lu = {
        $: 9
    }, Au = F2(function(t, e) {
        return {
            $: 4,
            a: t,
            b: e
        };
    }), Pu = {
        $: 11
    }, Du = F2(function(t, e) {
        return {
            $: 5,
            a: t,
            b: e
        };
    }), Nu = {
        $: 12
    }, Su = {
        $: 0
    }, Iu = function(t) {
        return {
            $: 10,
            a: t
        };
    }, Ru = F2(function(t, e) {
        return A3(Qe, function(t) {
            return F2(function(e, r) {
                return r.push(t(e)), r;
            });
        }(t), [], e);
    }), Eu = zt("copyToClipboard", function(t) {
        var e = t.b;
        return A2(Ru, Dr, x([
            jn(t.a),
            jn(e)
        ]));
    }), Tu = function(t) {
        var e = t.b;
        return Mn(A2(Jn, "DeleteQuestion", Bn(x([
            s("questionId", jn(t.a)),
            s("phaseCode", jn(e))
        ]))));
    }, Hu = ot, Fu = zt("disableScrolling", Hu), Vu = ca, Zu = function(t) {
        return Mn(A2(Jn, "ExcludeProposal", Bn(x([
            s("questionId", jn(t.D)),
            s("proposalId", jn(t.c2)),
            s("isExcluded", Hu(t.ck))
        ]))));
    }, qu = F3(function(t, e, r) {
        var n = t(e);
        return n.$ ? r : A2(Je, n.a, r);
    }), Uu = F2(function(t, e) {
        return A3(Xr, qu(t), d, e);
    }), Qu = {
        $: 0
    }, Ou = F3(function(t, e, r) {
        return t(e(r));
    }), Gu = lt, Wu = F2(function(t, e) {
        return pn(A2(Gu, A2(Ou, A2(Ou, Wr, t), Ae), A2(en, A2(Ou, A2(Ou, Wr, t), Se), e)));
    }), Yu = function(t) {
        switch(t.$){
            case 0:
                return "title-input";
            case 1:
                return "main-button";
            case 2:
                return "modal-button";
            default:
                return t.a;
        }
    }, Ku = ke("focus"), Xu = function(t) {
        var e = Yu(t);
        return A2(Wu, function() {
            return Qu;
        }, Ku(e));
    }, to = function(t) {
        return A3(Qe, F2(function(t, e) {
            return A3(Kn, t.a, t.b, e);
        }), ca, t);
    }, eo = function(t) {
        var e = t.b;
        return Mn(A2(Jn, "GoToRatingPhase", Bn(x([
            s("questionId", jn(t.a)),
            s("phaseCode", jn(e))
        ]))));
    }, ro = function(t) {
        var e = t.b;
        return Mn(A2(Jn, "GoToResultPhase", Bn(x([
            s("questionId", jn(t.a)),
            s("phaseCode", jn(e))
        ]))));
    }, no = F2(function(t, e) {
        return A3(Kn, t, 0, e);
    }), ao = function(t) {
        return !t;
    }, uo = (bn = Rn, ft(function(t) {
        t(ct(bn(Date.now())));
    })), oo = F2(function(t, e) {
        return s(t, e);
    }), io = function(t) {
        return t.trim();
    }, co = F2(function(t, e) {
        return Mn(A2(Jn, "PostNewProposal", Bn(b(x([
            s("questionId", jn(e)),
            s("title", jn(io(t.h)))
        ]), "" !== t.k ? x([
            s("description", jn(io(t.k)))
        ]) : d))));
    }), fo = function(t) {
        var e;
        return Mn(A2(Jn, "PostNewQuestion", Bn(b(x([
            s("title", jn(io(t.h))),
            s("author", jn(io(t.bn)))
        ]), b("" !== t.k ? x([
            s("description", jn(io(t.k)))
        ]) : d, (e = t.cP).$ || "" === e.a ? d : x([
            s("phaseCode", jn(e.a))
        ]))))));
    }, so = F3(function(t, e, r) {
        var n = r.b;
        return A2(Ru, Dr, x([
            t(r.a),
            e(n)
        ]));
    }), lo = ot, bo = F2(function(t, e) {
        if (-2 === e.$) return Gn;
        var r = e.b, n = e.d, a = e.e;
        return A5(On, e.a, r, A2(t, r, e.c), A2(bo, t, n), A2(bo, t, a));
    }), po = function(t) {
        return t.toLowerCase();
    }, go = F2(function(t, e) {
        return Mn(A2(Jn, "PostRatings", Bn(x([
            s("questionId", jn(e)),
            s("author", jn(io(po(t.dI)))),
            s("ratings", A2(Ru, A2(so, jn, lo), Be(A2(bo, F2(function(t, e) {
                return e.a;
            }), t.dJ))))
        ]))));
    }), xo = zt("pressedFoundErrorButton", jn), mo = F2(function(t, e) {
        return A2(ua, t, e);
    }), ho = {
        $: 1
    }, wo = $e, vo = A2(gn, function() {
        return ho;
    }, A2(wo, 0, 0)), yo = zt("selectText", jn), ko = zt("showToast", jn), $o = function(t) {
        return Mn(A2(Jn, "SubscribeToNewProposals", jn(t)));
    }, Co = function(t) {
        return Mn(A2(Jn, "SubscribeToNewRatings", jn(t)));
    }, _o = function(t) {
        return Mn(A2(Jn, "SubscribeToPhaseChanges", jn(t)));
    }, Jo = function(t) {
        return Mn(A2(Jn, "UnsubscribeFromNewProposals", jn(t)));
    }, jo = function(t) {
        return Mn(A2(Jn, "UnsubscribeFromNewRatings", jn(t)));
    }, Bo = function(t) {
        return Mn(A2(Jn, "UnsubscribeFromPhaseChanges", jn(t)));
    }, Mo = zt("updateTitle", jn), zo = zt("updateUrl", jn), Lo = F2(function(t, e) {
        var r, n, a, o, i = s(e.aJ, t);
        t: for(;;){
            e: for(;;){
                r: for(;;){
                    n: for(;;){
                        a: for(;;){
                            u: for(;;){
                                o: for(;;){
                                    i: for(;;){
                                        c: for(;;){
                                            f: for(;;){
                                                s: for(;;){
                                                    l: for(;;){
                                                        b: for(;;){
                                                            d: for(;;){
                                                                p: for(;;){
                                                                    g: for(;;){
                                                                        x: for(;;){
                                                                            m: for(;;)switch(i.b.$){
                                                                                case 11:
                                                                                    return s(e, Mn(A2(Jn, "LogError", jn(i.b.a))));
                                                                                case 2:
                                                                                    return s(l(e, {
                                                                                        aJ: $n
                                                                                    }), En);
                                                                                case 9:
                                                                                    return s(l(e, {
                                                                                        dD: i.b.a
                                                                                    }), En);
                                                                                case 10:
                                                                                    return s(l(e, {
                                                                                        aa: i.b.a
                                                                                    }), En);
                                                                                case 8:
                                                                                    switch(i.b.a.$){
                                                                                        case 1:
                                                                                            switch(i.a.$){
                                                                                                case 0:
                                                                                                    break t;
                                                                                                case 1:
                                                                                                    break d;
                                                                                                case 2:
                                                                                                    break p;
                                                                                                case 3:
                                                                                                    var c = i.a, f = c.a, d = c.b, p = i.b.a.a, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(g, wu({
                                                                                                            Q: "",
                                                                                                            R: "",
                                                                                                            cQ: f.cQ,
                                                                                                            D: p
                                                                                                        }), d))
                                                                                                    }), _n(x([
                                                                                                        Xu(_u),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                                case 4:
                                                                                                    var m = i.a;
                                                                                                    return f = m.a, d = m.b, p = i.b.a.a, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(g, wu({
                                                                                                            Q: "",
                                                                                                            R: "",
                                                                                                            cQ: f.cQ,
                                                                                                            D: p
                                                                                                        }), d))
                                                                                                    }), _n(x([
                                                                                                        Xu(_u),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                                default:
                                                                                                    var h = i.a;
                                                                                                    return f = h.a, d = h.b, p = i.b.a.a, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Du, f, A2(g, wu({
                                                                                                            Q: "",
                                                                                                            R: "",
                                                                                                            cQ: f.cQ,
                                                                                                            D: p
                                                                                                        }), d))
                                                                                                    }), _n(x([
                                                                                                        Xu(_u),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                            }
                                                                                        case 6:
                                                                                            switch(i.a.$){
                                                                                                case 0:
                                                                                                    break t;
                                                                                                case 1:
                                                                                                    break d;
                                                                                                case 2:
                                                                                                    break p;
                                                                                                case 3:
                                                                                                    var w = i.a;
                                                                                                    return f = w.a, d = w.b, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(g, zu, d))
                                                                                                    }), Fu(!0));
                                                                                                case 4:
                                                                                                    var v = i.a;
                                                                                                    return f = v.a, d = v.b, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(g, zu, d))
                                                                                                    }), Fu(!0));
                                                                                                default:
                                                                                                    var y = i.a;
                                                                                                    return f = y.a, d = y.b, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Du, f, A2(g, zu, d))
                                                                                                    }), Fu(!0));
                                                                                            }
                                                                                        case 8:
                                                                                            switch(i.a.$){
                                                                                                case 0:
                                                                                                    break t;
                                                                                                case 1:
                                                                                                    break d;
                                                                                                case 2:
                                                                                                    return d = i.a.a, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: Cn(A2(g, kn, d))
                                                                                                    }), Fu(!1));
                                                                                                case 3:
                                                                                                    var k = i.a;
                                                                                                    return f = k.a, d = k.b, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(g, kn, d))
                                                                                                    }), Fu(!1));
                                                                                                case 4:
                                                                                                    var $ = i.a;
                                                                                                    return f = $.a, d = $.b, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(g, kn, d))
                                                                                                    }), Fu(!1));
                                                                                                default:
                                                                                                    var C = i.a;
                                                                                                    return f = C.a, d = C.b, g = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Du, f, A2(g, kn, d))
                                                                                                    }), Fu(!1));
                                                                                            }
                                                                                        case 4:
                                                                                            if (0 === i.a.$) break t;
                                                                                            break e;
                                                                                        case 5:
                                                                                            if (0 === i.a.$) break t;
                                                                                            break n;
                                                                                        case 2:
                                                                                            if (0 === i.a.$) break t;
                                                                                            break a;
                                                                                        case 3:
                                                                                            if (0 === i.a.$) break t;
                                                                                            break u;
                                                                                        case 9:
                                                                                            if (0 === i.a.$) break t;
                                                                                            break o;
                                                                                        case 0:
                                                                                            if (0 === i.a.$) break t;
                                                                                            break i;
                                                                                        default:
                                                                                            if (0 === i.a.$) break t;
                                                                                            break c;
                                                                                    }
                                                                                case 3:
                                                                                    switch(i.a.$){
                                                                                        case 0:
                                                                                            break t;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            f = i.a.a;
                                                                                            var _ = i.b.a;
                                                                                            switch(_.$){
                                                                                                case 0:
                                                                                                    return s(l(e, {
                                                                                                        aJ: Cn({
                                                                                                            bn: f.bn,
                                                                                                            k: f.k,
                                                                                                            cs: f.cs,
                                                                                                            cP: f.cP,
                                                                                                            h: A = _.a
                                                                                                        })
                                                                                                    }), En);
                                                                                                case 1:
                                                                                                    return s(l(e, {
                                                                                                        aJ: Cn({
                                                                                                            bn: f.bn,
                                                                                                            k: D = _.a,
                                                                                                            cs: f.cs,
                                                                                                            cP: f.cP,
                                                                                                            h: f.h
                                                                                                        })
                                                                                                    }), En);
                                                                                                case 2:
                                                                                                    return s(l(e, {
                                                                                                        aJ: Cn({
                                                                                                            bn: _.a,
                                                                                                            k: f.k,
                                                                                                            cs: f.cs,
                                                                                                            cP: f.cP,
                                                                                                            h: f.h
                                                                                                        })
                                                                                                    }), En);
                                                                                                case 3:
                                                                                                    return s(l(e, {
                                                                                                        aJ: Cn({
                                                                                                            bn: f.bn,
                                                                                                            k: f.k,
                                                                                                            cs: f.cs,
                                                                                                            cP: _.a ? Ee("") : Te,
                                                                                                            h: f.h
                                                                                                        })
                                                                                                    }), En);
                                                                                                case 4:
                                                                                                    return s(l(e, {
                                                                                                        aJ: Cn({
                                                                                                            bn: f.bn,
                                                                                                            k: f.k,
                                                                                                            cs: f.cs,
                                                                                                            cP: Ee(I = _.a),
                                                                                                            h: f.h
                                                                                                        })
                                                                                                    }), En);
                                                                                                case 5:
                                                                                                    return s(e, _n(x([
                                                                                                        A2(In, vn, fo(f))
                                                                                                    ])));
                                                                                                default:
                                                                                                    return s(l(e, {
                                                                                                        aJ: Cn({
                                                                                                            bn: f.bn,
                                                                                                            k: f.k,
                                                                                                            cs: ju,
                                                                                                            cP: f.cP,
                                                                                                            h: f.h
                                                                                                        })
                                                                                                    }), Fu(!0));
                                                                                            }
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                                case 4:
                                                                                    switch(i.a.$){
                                                                                        case 0:
                                                                                            break t;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            var J = i.a, j = (f = J.a, d = J.b, i.b.a);
                                                                                            switch(j.$){
                                                                                                case 7:
                                                                                                    return s(e, _n(x([
                                                                                                        A2(In, vn, A2(co, d.cy, f.aB)),
                                                                                                        Fu(!1)
                                                                                                    ])));
                                                                                                case 8:
                                                                                                    var B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(B, $u, d))
                                                                                                    }), Fu(!0));
                                                                                                case 9:
                                                                                                    return B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(B, Bu, d))
                                                                                                    }), Fu(!0));
                                                                                                case 3:
                                                                                                    var M = j.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(no, t, e.ad)
                                                                                                        });
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(z, M, d))
                                                                                                    }), Fu(!0));
                                                                                                case 4:
                                                                                                    return M = j.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(mo, t, e.ad)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(z, M, d))
                                                                                                    }), _n(x([
                                                                                                        Fu(!1),
                                                                                                        Xu(vu(M))
                                                                                                    ])));
                                                                                                case 1:
                                                                                                    var L = F2(function(t, e) {
                                                                                                        return A2(Mu, t, l(d, {
                                                                                                            ds: e
                                                                                                        }));
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(L, f, !0)
                                                                                                    }), _n(x([
                                                                                                        Xu(Su),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                                case 2:
                                                                                                    return L = F2(function(t, e) {
                                                                                                        return A2(Mu, t, l(d, {
                                                                                                            ds: e
                                                                                                        }));
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(L, f, !1)
                                                                                                    }), Fu(!1));
                                                                                                case 5:
                                                                                                    var A = j.a, P = F2(function(t, e) {
                                                                                                        return A2(Mu, t, l(d, {
                                                                                                            cy: e
                                                                                                        }));
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(P, f, A2(Ju, A, d.cy.k))
                                                                                                    }), En);
                                                                                                case 6:
                                                                                                    var D = j.a;
                                                                                                    return P = F2(function(t, e) {
                                                                                                        return A2(Mu, t, l(d, {
                                                                                                            cy: e
                                                                                                        }));
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(P, f, A2(Ju, d.cy.h, D))
                                                                                                    }), En);
                                                                                                case 10:
                                                                                                    return M = j.a, B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(B, (a = M, {
                                                                                                            $: 6,
                                                                                                            a: a
                                                                                                        }), d))
                                                                                                    }), En);
                                                                                                case 11:
                                                                                                    return M = j.a, B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(B, Cu(M), d))
                                                                                                    }), En);
                                                                                                case 12:
                                                                                                    M = j.a;
                                                                                                    var N = A2(tn, function(t) {
                                                                                                        return u(t.aB, M) ? l(t, {
                                                                                                            ck: !0
                                                                                                        }) : t;
                                                                                                    }, d.c6), S = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            c6: t
                                                                                                        });
                                                                                                    });
                                                                                                    return z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(mo, t, e.ad)
                                                                                                        });
                                                                                                    }), B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(B, kn, A2(z, M, A2(S, N, d))))
                                                                                                    }), _n(x([
                                                                                                        Fu(!1),
                                                                                                        A2(In, vn, Zu({
                                                                                                            ck: !0,
                                                                                                            c2: M,
                                                                                                            D: f.aB
                                                                                                        }))
                                                                                                    ])));
                                                                                                case 13:
                                                                                                    return M = j.a, N = A2(tn, function(t) {
                                                                                                        return u(t.aB, M) ? l(t, {
                                                                                                            ck: !1
                                                                                                        }) : t;
                                                                                                    }, d.c6), S = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            c6: t
                                                                                                        });
                                                                                                    }), z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(mo, t, e.ad)
                                                                                                        });
                                                                                                    }), B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(B, kn, A2(z, M, A2(S, N, d))))
                                                                                                    }), _n(x([
                                                                                                        Fu(!1),
                                                                                                        A2(In, vn, Zu({
                                                                                                            ck: !1,
                                                                                                            c2: M,
                                                                                                            D: f.aB
                                                                                                        }))
                                                                                                    ])));
                                                                                                case 14:
                                                                                                    var I = j.a, R = F2(function(t, e) {
                                                                                                        return A2(Mu, t, l(d, {
                                                                                                            cP: e
                                                                                                        }));
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(R, f, I)
                                                                                                    }), Mn(A2(Jn, "HashPhaseCode", jn(I))));
                                                                                                case 0:
                                                                                                    var E = F2(function(t, e) {
                                                                                                        return A2(Mu, t, l(d, {
                                                                                                            cl: e
                                                                                                        }));
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(E, f, !1)
                                                                                                    }), En);
                                                                                                case 15:
                                                                                                    return B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Mu, f, A2(B, yu, d))
                                                                                                    }), _n(x([
                                                                                                        Xu(_u),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                                default:
                                                                                                    return s(e, _n(x([
                                                                                                        Fu(!1),
                                                                                                        A2(In, vn, eo(s(f.aB, d.cP)))
                                                                                                    ])));
                                                                                            }
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                                case 5:
                                                                                    switch(i.a.$){
                                                                                        case 0:
                                                                                            break t;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            var T = i.a, H = (f = T.a, d = T.b, i.b.a);
                                                                                            switch(H.$){
                                                                                                case 0:
                                                                                                    return M = H.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(no, t, e.ad)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(z, M, d))
                                                                                                    }), _n(x([
                                                                                                        Xu(Su),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                                case 1:
                                                                                                    var F = H.a;
                                                                                                    return M = H.b, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: F.$ ? A2(mo, t, e.ad) : A2(no, F.a, A2(mo, t, e.ad))
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(z, M, d))
                                                                                                    }), 1 === F.$ ? Fu(!1) : En);
                                                                                                case 2:
                                                                                                    var V = H.a;
                                                                                                    return M = H.b, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: V.$ ? A2(mo, t, e.ad) : A2(no, V.a, A2(mo, t, e.ad))
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(z, M, d))
                                                                                                    }), 1 === V.$ ? Fu(!1) : En);
                                                                                                case 3:
                                                                                                    return M = H.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(mo, t, e.ad)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(z, M, d))
                                                                                                    }), Fu(!1));
                                                                                                case 13:
                                                                                                    return B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(B, ku, d))
                                                                                                    }), _n(x([
                                                                                                        Xu(_u),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                                case 12:
                                                                                                    return B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(B, Lu, d))
                                                                                                    }), _n(x([
                                                                                                        Xu(_u),
                                                                                                        Fu(!0)
                                                                                                    ])));
                                                                                                case 14:
                                                                                                    return s(e, _n(x([
                                                                                                        Xu(_u),
                                                                                                        A2(In, vn, A2(go, d, f.aB)),
                                                                                                        A2(gn, Iu, uo)
                                                                                                    ])));
                                                                                                case 15:
                                                                                                    return I = H.a, R = F2(function(t, e) {
                                                                                                        return A2(Au, t, l(d, {
                                                                                                            cP: e
                                                                                                        }));
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(R, f, I)
                                                                                                    }), Mn(A2(Jn, "HashPhaseCode", jn(I))));
                                                                                                case 16:
                                                                                                    return s(e, _n(x([
                                                                                                        Fu(!1),
                                                                                                        A2(In, vn, ro(s(f.aB, d.cP)))
                                                                                                    ])));
                                                                                                case 6:
                                                                                                    M = H.a;
                                                                                                    var Z = H.b, q = F3(function(t, e, r) {
                                                                                                        return l(t, {
                                                                                                            dJ: A3(Kn, e, r, t.dJ)
                                                                                                        });
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(Au, f, A3(q, d, M, s(Z, Ee(Z))))
                                                                                                    }), En);
                                                                                                case 7:
                                                                                                case 8:
                                                                                                    return M = H.a, Z = H.b, q = F3(function(t, e, r) {
                                                                                                        return l(t, {
                                                                                                            dJ: A3(Kn, e, r, t.dJ)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A3(q, d, M, Z))
                                                                                                    }), En);
                                                                                                case 9:
                                                                                                    var U = H.a, Q = F2(function(t, e) {
                                                                                                        return l(t, {
                                                                                                            dI: e
                                                                                                        });
                                                                                                    });
                                                                                                    return s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(Q, d, U))
                                                                                                    }), En);
                                                                                                case 10:
                                                                                                    return B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(B, $u, d))
                                                                                                    }), Fu(!0));
                                                                                                case 4:
                                                                                                    return M = H.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(no, t, e.ad)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(z, M, d))
                                                                                                    }), Fu(!0));
                                                                                                case 5:
                                                                                                    return M = H.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(mo, t, e.ad)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(z, M, d))
                                                                                                    }), _n(x([
                                                                                                        Fu(!1),
                                                                                                        Xu(vu(M))
                                                                                                    ])));
                                                                                                default:
                                                                                                    return B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Au, f, A2(B, Bu, d))
                                                                                                    }), Fu(!0));
                                                                                            }
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                                case 7:
                                                                                    switch(i.a.$){
                                                                                        case 0:
                                                                                            break t;
                                                                                        case 1:
                                                                                            switch(i.b.a.$){
                                                                                                case 7:
                                                                                                    break r;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    break d;
                                                                                            }
                                                                                        case 2:
                                                                                            switch(i.b.a.$){
                                                                                                case 7:
                                                                                                    break r;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    break p;
                                                                                            }
                                                                                        case 3:
                                                                                            switch(i.b.a.$){
                                                                                                case 7:
                                                                                                    break r;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    var O = i.a;
                                                                                                    switch(f = O.a, d = O.b, (X = i.b.a).$){
                                                                                                        case 0:
                                                                                                            var G = X.a;
                                                                                                            return S = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    c6: t
                                                                                                                });
                                                                                                            }), L = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    ds: t
                                                                                                                });
                                                                                                            }), s(l(e, {
                                                                                                                aJ: A2(Mu, f, A2(L, !1, (n = A2(S, A2(Je, G, d.c6), d), l(n, {
                                                                                                                    cy: A2(Ju, "", "")
                                                                                                                }))))
                                                                                                            }), En);
                                                                                                        case 1:
                                                                                                            var W = X.a;
                                                                                                            return S = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    c6: t
                                                                                                                });
                                                                                                            }), s(l(e, {
                                                                                                                aJ: A2(Mu, f, A2(S, W, d))
                                                                                                            }), En);
                                                                                                        case 6:
                                                                                                            var Y = X.a, K = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    aK: t
                                                                                                                });
                                                                                                            });
                                                                                                            return s(l(e, {
                                                                                                                aJ: A2(Mu, f, A2(K, Y, d))
                                                                                                            }), En);
                                                                                                        default:
                                                                                                            return s(e, En);
                                                                                                    }
                                                                                            }
                                                                                        case 4:
                                                                                            switch(i.b.a.$){
                                                                                                case 7:
                                                                                                    break r;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    var X, tt = i.a;
                                                                                                    switch(f = tt.a, d = tt.b, (X = i.b.a).$){
                                                                                                        case 5:
                                                                                                            var et = X.a, rt = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    cN: b(e.cN, t)
                                                                                                                });
                                                                                                            }), nt = (B = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    cs: t
                                                                                                                });
                                                                                                            }), F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    ca: t
                                                                                                                });
                                                                                                            }));
                                                                                                            return s(l(e, {
                                                                                                                aJ: A2(Au, f, A2(nt, !0, A2(B, kn, A2(rt, et, d))))
                                                                                                            }), Fu(!1));
                                                                                                        case 2:
                                                                                                            var at = X.a;
                                                                                                            return rt = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    cN: t
                                                                                                                });
                                                                                                            }), s(l(e, {
                                                                                                                aJ: A2(Au, f, A2(rt, at, d))
                                                                                                            }), En);
                                                                                                        case 6:
                                                                                                            return Y = X.a, K = F2(function(t, e) {
                                                                                                                return l(e, {
                                                                                                                    aK: t
                                                                                                                });
                                                                                                            }), s(l(e, {
                                                                                                                aJ: A2(Au, f, A2(K, Y, d))
                                                                                                            }), En);
                                                                                                        default:
                                                                                                            return s(e, En);
                                                                                                    }
                                                                                            }
                                                                                        default:
                                                                                            switch(i.b.a.$){
                                                                                                case 7:
                                                                                                    break r;
                                                                                                case 3:
                                                                                                    break f;
                                                                                                case 4:
                                                                                                    break s;
                                                                                                case 8:
                                                                                                    break l;
                                                                                                case 9:
                                                                                                    break b;
                                                                                                default:
                                                                                                    break m;
                                                                                            }
                                                                                    }
                                                                                case 6:
                                                                                    switch(i.a.$){
                                                                                        case 0:
                                                                                            break t;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            var ut = i.a, ot = (f = ut.a, d = ut.b, i.b.a);
                                                                                            switch(ot.$){
                                                                                                case 0:
                                                                                                    return M = ot.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(no, t, e.ad)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Du, f, A2(z, M, d))
                                                                                                    }), Fu(!0));
                                                                                                case 1:
                                                                                                    return M = ot.a, z = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            ad: A2(mo, t, e.ad)
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Du, f, A2(z, M, d))
                                                                                                    }), Fu(!1));
                                                                                                default:
                                                                                                    return B = F2(function(t, e) {
                                                                                                        return l(e, {
                                                                                                            cs: t
                                                                                                        });
                                                                                                    }), s(l(e, {
                                                                                                        aJ: A2(Du, f, A2(B, $u, d))
                                                                                                    }), Fu(!0));
                                                                                            }
                                                                                    }
                                                                                default:
                                                                                    switch(i.a.$){
                                                                                        case 0:
                                                                                            break t;
                                                                                        case 1:
                                                                                            break d;
                                                                                        case 2:
                                                                                            break p;
                                                                                        case 3:
                                                                                            break g;
                                                                                        case 4:
                                                                                            break x;
                                                                                        default:
                                                                                            break m;
                                                                                    }
                                                                            }
                                                                            return s(e, En);
                                                                        }
                                                                        return s(e, En);
                                                                    }
                                                                    return s(e, En);
                                                                }
                                                                return s(e, En);
                                                            }
                                                            return s(e, En);
                                                        }
                                                        var it = i.b.a.a;
                                                        return s(e, ko(A2(Ir, "proposals_title_question_id_key", it) ? e.J.bi.c7 : A2(Ir, "ratings_proposal_id_question_id_author_key", it) ? e.J.bi.dk : A2(Ir, "title length", it) ? e.J.bi.dG : A2(Ir, "description length", it) ? e.J.bi.bG : e.J.bi.b6));
                                                    }
                                                    var ct = i.b.a.a;
                                                    switch((dt = i.a).$){
                                                        case 3:
                                                            f = dt.a, d = dt.b, g = F2(function(t, e) {
                                                                return l(e, {
                                                                    cs: t
                                                                });
                                                            });
                                                            var ft = (o = void 0, 1 === (o = s(ct.aR, ct.aU)).b.$ ? 1 === o.a.$ ? kn : Pu : Nu);
                                                            return s(l(e, {
                                                                aJ: A2(Mu, f, A2(g, ft, d))
                                                            }), Fu(!!ft.$));
                                                        case 4:
                                                            return f = dt.a, d = dt.b, g = F2(function(t, e) {
                                                                return l(e, {
                                                                    cs: t
                                                                });
                                                            }), ft = (r = s(ct.aR, ct.aU)).a.$ || r.b.$ ? kn : Nu, s(l(e, {
                                                                aJ: A2(Au, f, A2(g, ft, d))
                                                            }), Fu(!!ft.$));
                                                        case 5:
                                                            return s(e, A2(In, vn, Bo((st = dt.a).aB)));
                                                        default:
                                                            return s(e, En);
                                                    }
                                                }
                                                var st, lt = 2 === (dt = i.a).$;
                                                switch((st = i.b.a.a).$){
                                                    case 0:
                                                        return s(l(e, {
                                                            aJ: A2(Mu, f = st.a, {
                                                                cl: lt,
                                                                cs: kn,
                                                                cy: A2(Ju, "", ""),
                                                                ad: Vu,
                                                                cP: "",
                                                                aK: "",
                                                                c6: f.c6,
                                                                ds: !1,
                                                                ah: !1
                                                            })
                                                        }), _n(x(lt ? [
                                                            zo("/" + f.aB),
                                                            Xu(Su),
                                                            Mo(f.h),
                                                            vo,
                                                            Fu(!1),
                                                            A2(In, vn, _o(f.aB)),
                                                            A2(In, vn, $o(f.aB))
                                                        ] : [
                                                            Mo(f.h),
                                                            Fu(!1),
                                                            A2(In, vn, _o(f.aB)),
                                                            A2(In, vn, $o(f.aB))
                                                        ])));
                                                    case 1:
                                                        var bt = to(A2(tn, function(t) {
                                                            return A2(oo, t.aB, s(0, Te));
                                                        }, A2(Uu, function(t) {
                                                            return t.ck ? Te : Ee(t);
                                                        }, (f = st.a).c6)));
                                                        return s(l(e, {
                                                            aJ: A2(Au, f, {
                                                                ca: !1,
                                                                cs: kn,
                                                                ad: Vu,
                                                                cN: f.aW,
                                                                cP: "",
                                                                aK: "",
                                                                ah: !1,
                                                                dI: "",
                                                                dJ: bt
                                                            })
                                                        }), _n(x([
                                                            vo,
                                                            Mo(f.h),
                                                            Fu(!1),
                                                            A2(In, vn, Jo(f.aB)),
                                                            A2(In, vn, Co(f.aB)),
                                                            A2(In, vn, _o(f.aB))
                                                        ])));
                                                    default:
                                                        return s(l(e, {
                                                            aJ: A2(Du, f = st.a, {
                                                                cs: kn,
                                                                ad: Vu,
                                                                ah: !1
                                                            })
                                                        }), _n(x([
                                                            vo,
                                                            Mo(f.h),
                                                            Fu(!1),
                                                            A2(In, vn, Jo(f.aB)),
                                                            A2(In, vn, jo(f.aB))
                                                        ])));
                                                }
                                            }
                                            return s(e, _n(x([
                                                zo(e.I.dL)
                                            ])));
                                        }
                                        return s(e, A2(In, vn, zn(p = i.b.a.a)));
                                    }
                                    var dt = i.a, pt = F3(function(t, e, r) {
                                        return A2(t, e, l(r, {
                                            ah: !r.ah
                                        }));
                                    }), gt = function(t) {
                                        return Fu(!t.ah);
                                    };
                                    switch(dt.$){
                                        case 3:
                                            return s(l(e, {
                                                aJ: A3(pt, Mu, f = dt.a, d = dt.b)
                                            }), gt(d));
                                        case 4:
                                            return s(l(e, {
                                                aJ: A3(pt, Au, f = dt.a, d = dt.b)
                                            }), gt(d));
                                        case 5:
                                            return s(l(e, {
                                                aJ: A3(pt, Du, f = dt.a, d = dt.b)
                                            }), gt(d));
                                        default:
                                            return s(e, En);
                                    }
                                }
                                return s(e, xo(p = i.b.a.a));
                            }
                            var xt = i.b.a;
                            return s(e, Eu(s(xt.a, xt.b)));
                        }
                        return s(e, yo(i.b.a.a));
                    }
                    var mt = i.b.a;
                    return s(e, _n(x([
                        A2(In, vn, Tu(s(p = mt.a, I = mt.b))),
                        Fu(!1)
                    ])));
                }
                dt = i.a;
                var ht = i.b.a.a, wt = F2(function(t, e) {
                    return l(e, {
                        R: t
                    });
                });
                switch(B = F2(function(t, e) {
                    var r;
                    return l(e, {
                        cs: (r = e.cs, 1 === r.$ ? wu(A2(wt, t, r.a)) : e.cs)
                    });
                }), dt.$){
                    case 3:
                        return s(l(e, {
                            aJ: A2(Mu, f = dt.a, A2(B, ht, d = dt.b))
                        }), En);
                    case 4:
                        return s(l(e, {
                            aJ: A2(Au, f = dt.a, A2(B, ht, d = dt.b))
                        }), En);
                    case 5:
                        return s(l(e, {
                            aJ: A2(Du, f = dt.a, A2(B, ht, d = dt.b))
                        }), En);
                    default:
                        return s(e, En);
                }
            }
            dt = i.a;
            var vt = i.b.a.a, yt = F2(function(t, e) {
                return l(e, {
                    Q: t
                });
            });
            switch(B = F2(function(t, e) {
                var r;
                return l(e, {
                    cs: (r = e.cs, 1 === r.$ ? wu(A2(yt, t, r.a)) : e.cs)
                });
            }), dt.$){
                case 3:
                    return s(l(e, {
                        aJ: A2(Mu, f = dt.a, A2(B, vt, d = dt.b))
                    }), Mn(A2(Jn, "HashDeleteCode", jn(vt))));
                case 4:
                    return s(l(e, {
                        aJ: A2(Au, f = dt.a, A2(B, vt, d = dt.b))
                    }), Mn(A2(Jn, "HashDeleteCode", jn(vt))));
                case 5:
                    return s(l(e, {
                        aJ: A2(Du, f = dt.a, A2(B, vt, d = dt.b))
                    }), Mn(A2(Jn, "HashDeleteCode", jn(vt))));
                default:
                    return s(e, En);
            }
        }
        return s(e, En);
    }), Ao = Zt("class"), Po = F2(function(t, e) {
        return A3(Xr, F2(function(e, r) {
            return t(e) ? A2(Je, e, r) : r;
        }), d, e);
    }), Do = function(t) {
        return t.b;
    }, No = function(t) {
        return Ao(A2(Ze, " ", A2(tn, $r, A2(Po, Do, t))));
    }, So = Zt("d"), Io = Zt("fill-rule"), Ro = It("http://www.w3.org/2000/svg"), Eo = Ro("path"), To = Ro("svg"), Ho = Zt("viewBox"), Fo = A2(qt, "http://www.w3.org/XML/1998/namespace", "xml:space"), Vo = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M6.22 3.22a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 010-1.06z")
            ]), d)
        ]));
    }), Zo = F2(function(t, e) {
        return A2(Vt, t, jn(e));
    }), qo = Zo("className"), Uo = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zM8 0a8 8 0 100 16A8 8 0 008 0zm.5 4.75a.75.75 0 00-1.5 0v3.5a.75.75 0 00.471.696l2.5 1a.75.75 0 00.557-1.392L8.5 7.742V4.75z")
            ]), d)
        ]));
    }), Qo = Zt("fill"), Oo = Zt("preserveAspectRatio"), Go = function(t) {
        return A2(To, x([
            Ao(t),
            Qo("none"),
            Fo("http://www.w3.org/2000/svg"),
            Ho("0 0 320 6"),
            Oo("none")
        ]), x([
            A2(Eo, x([
                So("M0 0h320v2.5S298 6 252.5 6s-93-6-138.5-6S0 6 0 6V0Z")
            ]), d)
        ]));
    }, Wo = F2(function(t, e) {
        return e ? x([
            Go("absolute w-full max-h-3 left-0 bottom-full z-10 rotate-180 translate-y-px " + t)
        ]) : d;
    }), Yo = Rt("div"), Ko = F3(function(t, e, r) {
        var n = " py-14 xl:py-20";
        return t ? A2(Yo, x([
            qo(n)
        ]), r) : A2(Yo, x([
            qo("relative bg-grey-100" + n)
        ]), b(r, A2(Wo, "fill-grey-100", e)));
    }), Xo = Rt("a"), ti = function(t) {
        return qo(A2(Ze, " ", A2(tn, $r, A2(Po, Do, t))));
    }, ei = function(t) {
        var e;
        return A2(Zo, "href", Qt.test(e = t) ? "" : e);
    }, ri = Rt("li"), ni = Rt("p"), ai = St, ui = ai, oi = Rt("ul"), ii = F3(function(t, e, r) {
        return x([
            A2(oi, x([
                qo("flex flex-col w-full max-w-screen-xl mb-8 mx-auto px-6 gap-6 text-center text-base md:flex-row md:justify-start md:gap-16 lg:px-14")
            ]), x([
                A2(ri, d, x([
                    A2(Xo, x([
                        ei(t.dL + "/faq/"),
                        qo("underline-offset-2 hover:underline")
                    ]), x([
                        ui(e.bX)
                    ]))
                ])),
                A2(ri, d, x([
                    A2(Xo, x([
                        ei(t.dL + "/privacy-policy/"),
                        qo("underline-offset-2 hover:underline")
                    ]), x([
                        ui(e.c1)
                    ]))
                ])),
                A2(ri, d, x([
                    A2(Xo, x([
                        ei(t.dL + "/terms-of-use/"),
                        qo("underline-offset-2 hover:underline")
                    ]), x([
                        ui(e.dC)
                    ]))
                ])),
                A2(ri, d, x([
                    A2(Xo, x([
                        ei(t.dL + "/legal-notice/"),
                        qo("underline-offset-2 hover:underline")
                    ]), x([
                        ui(e.cn)
                    ]))
                ]))
            ])),
            A2(Yo, x([
                qo("flex flex-col w-full max-w-screen-xl mx-auto px-6 gap-6 text-center text-base md:flex-row-reverse md:justify-between md:gap-16 lg:px-14")
            ]), x([
                A2(ni, x([
                    qo("font-serif font-bold italic"),
                    ti(x([
                        s("text-grey-400", 1 === r),
                        s("text-primary-600 selection:bg-white", !r)
                    ]))
                ]), x([
                    ui(e.bB)
                ])),
                A2(ni, x([
                    ti(x([
                        s("text-grey-400", 1 === r),
                        s("text-primary-600 selection:bg-white", !r)
                    ]))
                ]), x([
                    ui(e.bA)
                ]))
            ]))
        ]);
    }), ci = Rt("h1"), fi = F2(function(t, e) {
        return {
            $: 3,
            a: t,
            b: e
        };
    }), si = Rt("button"), li = Rt("details"), bi = Zo("id"), di = Zt("clip-rule"), pi = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Qo("none"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                di("evenodd"),
                So("M9.53691 4.54326C9.67528 4.4 9.8408 4.28572 10.0238 4.20711C10.2068 4.12849 10.4036 4.08712 10.6028 4.08538C10.802 4.08365 10.9995 4.12161 11.1838 4.19703C11.3682 4.27245 11.5357 4.38383 11.6765 4.52467C11.8173 4.66551 11.9287 4.83298 12.0041 5.01733C12.0796 5.20167 12.1175 5.39919 12.1158 5.59836C12.1141 5.79753 12.0727 5.99436 11.9941 6.17737C11.9154 6.36037 11.8012 6.52589 11.6579 6.66426L9.40791 8.91426C9.12662 9.19547 8.74516 9.35344 8.34741 9.35344C7.94966 9.35344 7.5682 9.19547 7.28691 8.91426C7.14546 8.77764 6.95601 8.70205 6.75936 8.70375C6.56271 8.70546 6.3746 8.78434 6.23555 8.9234C6.09649 9.06245 6.01761 9.25056 6.01591 9.44721C6.0142 9.64386 6.08979 9.83331 6.22641 9.97476C6.78899 10.5372 7.55192 10.8531 8.34741 10.8531C9.1429 10.8531 9.90583 10.5372 10.4684 9.97476L12.7184 7.72476C13.2649 7.15895 13.5673 6.40115 13.5604 5.61456C13.5536 4.82797 13.2381 4.07553 12.6819 3.5193C12.1256 2.96308 11.3732 2.64757 10.5866 2.64074C9.80002 2.6339 9.04222 2.93629 8.47641 3.48276L7.35141 4.60776C7.27978 4.67695 7.22264 4.7597 7.18334 4.85121C7.14403 4.94271 7.12334 5.04113 7.12247 5.14071C7.12161 5.24029 7.14058 5.33905 7.17829 5.43123C7.21601 5.5234 7.2717 5.60714 7.34211 5.67756C7.41253 5.74798 7.49627 5.80367 7.58844 5.84138C7.68062 5.87909 7.77938 5.89806 7.87896 5.8972C7.97855 5.89633 8.07696 5.87564 8.16846 5.83634C8.25997 5.79703 8.34273 5.73989 8.41191 5.66826L9.53691 4.54326ZM5.78691 8.29326C6.0682 8.01205 6.44967 7.85408 6.84741 7.85408C7.24516 7.85408 7.62662 8.01205 7.90791 8.29326C7.9771 8.36489 8.05985 8.42203 8.15136 8.46134C8.24286 8.50064 8.34128 8.52133 8.44086 8.5222C8.54044 8.52306 8.6392 8.50409 8.73138 8.46638C8.82355 8.42867 8.90729 8.37298 8.97771 8.30256C9.04813 8.23214 9.10382 8.1484 9.14153 8.05623C9.17924 7.96405 9.19821 7.86529 9.19735 7.76571C9.19648 7.66612 9.17579 7.56771 9.13649 7.47621C9.09718 7.3847 9.04004 7.30195 8.96841 7.23276C8.40583 6.67035 7.6429 6.3544 6.84741 6.3544C6.05192 6.3544 5.28899 6.67035 4.72641 7.23276L2.47641 9.48276C2.18988 9.7595 1.96133 10.0905 1.80411 10.4565C1.64688 10.8226 1.56412 11.2162 1.56066 11.6146C1.5572 12.0129 1.6331 12.4079 1.78395 12.7766C1.93479 13.1453 2.15755 13.4803 2.43923 13.7619C2.7209 14.0436 3.05586 14.2664 3.42455 14.4172C3.79324 14.5681 4.18828 14.644 4.58661 14.6405C4.98495 14.637 5.37861 14.5543 5.74462 14.3971C6.11064 14.2398 6.44167 14.0113 6.71841 13.7248L7.84341 12.5998C7.91504 12.5306 7.97218 12.4478 8.01149 12.3563C8.05079 12.2648 8.07148 12.1664 8.07235 12.0668C8.07321 11.9672 8.05424 11.8685 8.01653 11.7763C7.97882 11.6841 7.92313 11.6004 7.85271 11.53C7.78229 11.4595 7.69855 11.4039 7.60638 11.3661C7.5142 11.3284 7.41544 11.3095 7.31586 11.3103C7.21628 11.3112 7.11786 11.3319 7.02636 11.3712C6.93485 11.4105 6.8521 11.4676 6.78291 11.5393L5.65791 12.6643C5.51954 12.8075 5.35402 12.9218 5.17102 13.0004C4.98801 13.079 4.79118 13.1204 4.59201 13.1221C4.39284 13.1239 4.19532 13.0859 4.01098 13.0105C3.82664 12.9351 3.65916 12.8237 3.51832 12.6829C3.37748 12.542 3.2661 12.3745 3.19068 12.1902C3.11526 12.0058 3.07731 11.8083 3.07904 11.6092C3.08077 11.41 3.12215 11.2132 3.20076 11.0302C3.27937 10.8471 3.39365 10.6816 3.53691 10.5433L5.78691 8.29326Z")
            ]), d)
        ]));
    }), gi = Zo("alt"), xi = Rt("img"), mi = function(t) {
        var e;
        return A2(Zo, "src", Ot.test(e = t) ? "" : e);
    }, hi = Zo("title"), wi = function(t) {
        return A2(Xo, x([
            qo("block outline-none focus-visible:ring-4 focus-visible:ring-primary-300 focus-visible:ring-offset-8 focus-visible:rounded-full"),
            ei(t.dL),
            hi("go to website")
        ]), x([
            A2(xi, x([
                qo("w-20 sm:w-24 md:w-32"),
                mi(t.co),
                gi("konsens")
            ]), d)
        ]));
    }, vi = Ht, yi = F2(function(t, e) {
        return A2(vi, t, {
            $: 0,
            a: e
        });
    }), ki = function(t) {
        return A2(yi, "click", Ar(t));
    }, $i = function(t) {
        return "flex items-center gap-1 py-1.5 px-3 text-sm font-semibold shadow-md rounded-full transition-all md:text-base outline-none focus-visible:ring-4 focus-visible:ring-offset-4 focus-visible:ring-primary-600" + function() {
            switch(t){
                case 0:
                    return " text-black bg-white hover:bg-black hover:text-white hover:fill-white";
                case 1:
                    return " text-black bg-primary-300 hover:bg-black hover:text-white hover:fill-white";
                default:
                    return " text-white bg-black hover:bg-white hover:text-black hover:fill-black";
            }
        }();
    }, Ci = Rt("span"), _i = Rt("summary"), Ji = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z")
            ]), d)
        ]));
    }), ji = Zo("type"), Bi = Ro("clipPath"), Mi = Zt("clip-path"), zi = Ro("defs"), Li = Ro("g"), Ai = Zt("height"), Pi = Zt("id"), Di = Ro("rect"), Ni = Zt("width"), Si = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Qo("currentColor")
        ]), x([
            A2(Li, x([
                Mi("url(#clip0_3015_4435)")
            ]), x([
                A2(Eo, x([
                    So("M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM5.78 8.75C5.90674 10.2287 6.37319 11.6581 7.143 12.927C7.398 13.353 7.685 13.759 8 14.142C8.245 13.846 8.551 13.437 8.857 12.927C9.62681 11.6581 10.0933 10.2287 10.22 8.75H5.78ZM10.22 7.25C10.0933 5.77131 9.62681 4.34185 8.857 3.073C8.55 2.563 8.245 2.154 8 1.858C7.68436 2.24101 7.39789 2.64715 7.143 3.073C6.37319 4.34185 5.90674 5.77131 5.78 7.25H10.22ZM4.276 8.75H1.543C1.69169 10.0247 2.214 11.227 3.04424 12.2056C3.87447 13.1843 4.97556 13.8955 6.209 14.25C6.086 14.069 5.969 13.885 5.857 13.698C5.142 12.506 4.42 10.824 4.276 8.75ZM1.543 7.25H4.276C4.42 5.176 5.142 3.494 5.856 2.302C5.976 2.105 6.093 1.921 6.209 1.75C4.97556 2.10445 3.87447 2.81573 3.04424 3.79436C2.214 4.77299 1.69169 5.97528 1.543 7.25ZM11.724 8.75C11.58 10.824 10.858 12.506 10.144 13.698C10.024 13.895 9.907 14.079 9.791 14.25C11.0244 13.8955 12.1255 13.1843 12.9558 12.2056C13.786 11.227 14.3083 10.0247 14.457 8.75H11.724ZM14.457 7.25C14.3083 5.97528 13.786 4.77299 12.9558 3.79436C12.1255 2.81573 11.0244 2.10445 9.791 1.75C9.914 1.931 10.031 2.115 10.144 2.302C10.858 3.494 11.58 5.176 11.724 7.25H14.457Z")
                ]), d)
            ])),
            A2(zi, d, x([
                A2(Bi, x([
                    Pi("clip0_3015_4435")
                ]), x([
                    A2(Di, x([
                        Ni("16"),
                        Ai("16"),
                        Qo("white")
                    ]), d)
                ]))
            ]))
        ]));
    }), Ii = F2(function(t, e) {
        return A2(Yo, x([
            qo("flex justify-between items-center m-4 my-6 h-8 xs:m-6 sm:mx-8 md:h-9 md:my-10 lg:my-12 lg:mb-14")
        ]), x([
            A2(Yo, x([
                qo("flex items-center gap-6 h-9")
            ]), x([
                A2(Yo, x([
                    qo("-translate-y-0.5")
                ]), x([
                    wi(t)
                ])),
                A2(li, x([
                    qo("group relative")
                ]), x([
                    A2(_i, x([
                        qo("flex gap-1 font-semibold items-center text-base text-gray-400 cursor-pointer uppercase [&::-webkit-details-marker]:hidden")
                    ]), x([
                        A2(Si, "w-4 h-4", d),
                        ui("ES"),
                        A2(Vo, "w-4 h-4 fill-gray-400 rotate-90 transition-transform group-open:-rotate-90", d)
                    ])),
                    A2(Yo, x([
                        qo("absolute top-8 flex flex-col bg-white rounded-xl shadow-md text-lg w-40 z-10 overflow-hidden")
                    ]), x([
                        A2(Xo, x([
                            ei(t.bj + "/" + A2(va, "", A2(Wa, function(t) {
                                return t.D;
                            }, e))),
                            qo("inline-flex items-center gap-2 pl-10 pr-4 pt-3 pb-2 hover:bg-gray-50")
                        ]), x([
                            ui("English")
                        ])),
                        A2(Xo, x([
                            ei(t.bk + "/" + A2(va, "", A2(Wa, function(t) {
                                return t.D;
                            }, e))),
                            qo("inline-flex items-center gap-2 pl-10 pr-4 py-2 hover:bg-gray-50")
                        ]), x([
                            ui("Deutsch")
                        ])),
                        A2(Xo, x([
                            ei(t.bl + "/" + A2(va, "", A2(Wa, function(t) {
                                return t.D;
                            }, e))),
                            qo("inline-flex items-center gap-2 px-4 pt-2 pb-3 text-gray-400 hover:bg-gray-50")
                        ]), x([
                            A2(Ji, "w-4 h-4 fill-gray-400", d),
                            ui("Espa\xf1ol")
                        ]))
                    ]))
                ]))
            ])),
            function() {
                if (e.$) return ui("");
                var r = e.a;
                return A2(Yo, x([
                    bi("copy-link-button"),
                    qo("grid")
                ]), x([
                    A2(si, x([
                        qo($i(2) + " col-start-1 row-start-1"),
                        ji("button"),
                        ki(_a(A2(fi, "copy-link-button", t.bl + "/" + r.D)))
                    ]), x([
                        A2(pi, "w-4 h-4 fill-current", d),
                        A2(Ci, x([
                            qo("hidden xs:inline")
                        ]), x([
                            ui(r.T)
                        ])),
                        A2(Ci, x([
                            qo("xs:hidden")
                        ]), x([
                            ui(r.U)
                        ]))
                    ])),
                    A2(Yo, x([
                        qo($i(1) + " col-start-1 row-start-1 justify-center shadow-primary-500/20 pointer-events-none opacity-0")
                    ]), x([
                        A2(Ji, "w-4 h-4 fill-current", d),
                        ui(r.V)
                    ]))
                ]));
            }()
        ]));
    }), Ri = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M10.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm.061 3.073a4 4 0 10-5.123 0 6.004 6.004 0 00-3.431 5.142.75.75 0 001.498.07 4.5 4.5 0 018.99 0 .75.75 0 101.498-.07 6.005 6.005 0 00-3.432-5.142z")
            ]), d)
        ]));
    }), Ei = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                So("M8.66659 11.6667C8.66659 11.8435 8.59635 12.013 8.47132 12.1381C8.3463 12.2631 8.17673 12.3333 7.99992 12.3333C7.82311 12.3333 7.65354 12.2631 7.52851 12.1381C7.40349 12.013 7.33325 11.8435 7.33325 11.6667C7.33325 11.4899 7.40349 11.3203 7.52851 11.1953C7.65354 11.0702 7.82311 11 7.99992 11C8.17673 11 8.3463 11.0702 8.47132 11.1953C8.59635 11.3203 8.66659 11.4899 8.66659 11.6667ZM8.49992 6.16667C8.49992 6.03406 8.44724 5.90688 8.35347 5.81311C8.2597 5.71934 8.13253 5.66667 7.99992 5.66667C7.86731 5.66667 7.74013 5.71934 7.64637 5.81311C7.5526 5.90688 7.49992 6.03406 7.49992 6.16667V9.16667C7.49992 9.29927 7.5526 9.42645 7.64637 9.52022C7.74013 9.61399 7.86731 9.66667 7.99992 9.66667C8.13253 9.66667 8.2597 9.61399 8.35347 9.52022C8.44724 9.42645 8.49992 9.29927 8.49992 9.16667V6.16667Z")
            ]), d),
            A2(Eo, x([
                Io("evenodd"),
                di("evenodd"),
                So("M6.20413 1.8325C6.84613 0.7225 8.44746 0.7225 9.08946 1.8325L15.0675 12.1685C15.7095 13.2798 14.9075 14.6698 13.6241 14.6698H1.66946C0.385458 14.6698 -0.415875 13.2798 0.226125 12.1685L6.20413 1.8325ZM8.22412 2.33317C8.16561 2.23183 8.08145 2.14768 7.98011 2.08917C7.87877 2.03066 7.76381 1.99986 7.64679 1.99986C7.52977 1.99986 7.41482 2.03066 7.31347 2.08917C7.21213 2.14768 7.12797 2.23183 7.06946 2.33317L1.09212 12.6692C1.03345 12.7705 1.00251 12.8856 1.00242 13.0027C1.00234 13.1198 1.03311 13.2349 1.09164 13.3363C1.15017 13.4378 1.23439 13.522 1.33583 13.5806C1.43727 13.6391 1.55234 13.6699 1.66946 13.6698H13.6241C13.7411 13.6698 13.8561 13.639 13.9575 13.5805C14.0588 13.522 14.143 13.4378 14.2015 13.3365C14.26 13.2351 14.2908 13.1202 14.2908 13.0032C14.2908 12.8861 14.26 12.7712 14.2015 12.6698L8.22412 2.3325V2.33317Z")
            ]), d)
        ]));
    }), Ti = function(t) {
        return A2(Yo, x([
            qo("fixed top-4 inset-x-2 flex justify-center pointer-events-none z-50")
        ]), x([
            A2(Yo, x([
                bi("toast"),
                qo("flex items-center py-2 px-4 gap-3 md:gap-4 text-white bg-black/80 rounded-lg opacity-0 -translate-y-1/2 ease-[cubic-bezier(.34,1.56,.64,1)] duration-700")
            ]), x([
                A2(Ei, "w-4 h-4 md:w-5 md:h-5 fill-white shrink-0 self-start mt-1.5 md:mt-1", d),
                A2(Ci, d, x([
                    ui(t.b7)
                ]))
            ]))
        ]));
    }, Hi = F2(function(t, e) {
        var r = function(t) {
            return Ci(x([
                qo("relative text-transparent before:absolute before:inset-x-0 before:inset-y-1 before:bg-black before:rounded-full before:animate-pulse " + t)
            ]));
        };
        return A2(Yo, d, x([
            Ti(e),
            A2(Yo, x([
                qo("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), x([
                A2(Ii, t, Te),
                A2(Yo, x([
                    qo("flex flex-col mx-4 mb-6 bg-white rounded-xl shadow-md shadow-black/5 md:mx-8 md:mb-12 overflow-hidden")
                ]), x([
                    A2(Yo, x([
                        qo("flex flex-col gap-4 p-4 text-left rounded-xl xs:p-5 md:p-8 lg:pb-8 outline-none focus-visible:ring-4 focus-visible:ring-primary-600 focus-visible:ring-inset")
                    ]), x([
                        A2(Yo, x([
                            qo("flex w-full items-center gap-2 lg:flex-row-reverse lg:gap-5")
                        ]), x([
                            A2(Yo, x([
                                qo("flex flex-col gap-1 grow")
                            ]), x([
                                A2(ci, x([
                                    qo("font-serif font-bold text-lg xs:text-xl md:text-2xl")
                                ]), x([
                                    A2(r, "opacity-40", x([
                                        ui("Title")
                                    ]))
                                ])),
                                A2(Yo, x([
                                    qo("flex flex-wrap gap-y-2 gap-x-4 sm:gap-x-6 text-sm xs:text-base sm:text-lg text-grey-400")
                                ]), x([
                                    A2(Yo, x([
                                        qo("flex gap-1.5 items-center")
                                    ]), x([
                                        A2(Ri, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", d),
                                        A2(r, "opacity-10", x([
                                            ui("Author")
                                        ]))
                                    ])),
                                    A2(Yo, x([
                                        qo("flex gap-1.5 items-center")
                                    ]), x([
                                        A2(Uo, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", d),
                                        A2(r, "opacity-10", x([
                                            ui("available until date")
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(Vo, "shrink-0 w-4 h-4 transition-transform", d)
                        ]))
                    ]))
                ])),
                A2(Yo, x([
                    qo("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), d),
                    A2(Yo, x([
                        qo("flex items-center gap-2 mr-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-grey-400")
                        ]), x([
                            A2(r, "opacity-20", x([
                                ui("Question")
                            ]))
                        ])),
                        A2(Ji, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", d)
                    ])),
                    A2(Yo, x([
                        qo("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), x([
                        A2(r, "opacity-10", x([
                            ui("started some")
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-2 mr-2 flex items-center gap-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-black")
                        ]), x([
                            A2(r, "opacity-40", x([
                                ui("Proposals")
                            ]))
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("text-transparent col-span-2 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), x([
                        ui("in progress")
                    ]))
                ])),
                A2(Yo, x([
                    qo("group overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10  bg-primary-200 h-screen")
                ]), x([
                    A2(Yo, x([
                        qo("flex flex-col w-full h-1/2 px-4 py-10 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
                    ]), d)
                ]))
            ])),
            A2(Yo, x([
                qo("mt-20 lg:mt-40")
            ]), x([
                A3(Ko, 0, 1, A3(ii, t, e.bZ, 1))
            ]))
        ]));
    }), Fi = F2(function(t, e) {
        return " font-serif font-extrabold px-6 py-3.5 text-center rounded-full" + function() {
            switch(t){
                case 0:
                    return " text-black bg-white ring-1 ring-grey-100 shadow-md shadow-black/5 hover:bg-black hover:text-white hover:fill-white hover:ring-0";
                case 1:
                    return " text-black bg-primary-300 selection:bg-white shadow-md shadow-primary-400/30 hover:bg-black hover:text-white hover:shadow-black/20";
                default:
                    return " text-white bg-black selection:bg-white shadow-md shadow-black/20 hover:bg-white hover:text-black hover:shadow-black/5 transition-colors";
            }
        }() + function() {
            switch(e){
                case 1:
                    return " disabled:bg-grey-200 disabled:text-grey-400 disabled:shadow-none disabled:cursor-not-allowed group-invalid:bg-grey-200 group-invalid:text-grey-400 group-invalid:shadow-none group-invalid:cursor-not-allowed";
                case 2:
                    return " disabled:bg-primary-200 disabled:text-primary-400 disabled:shadow-none disabled:cursor-not-allowed group-invalid:bg-primary-200 group-invalid:text-primary-400 group-invalid:shadow-none group-invalid:cursor-not-allowed";
                case 3:
                    return " disabled:ring-[#C99727] disabled:ring-2 disabled:bg-transparent disabled:text-[#C99727] disabled:shadow-none disabled:cursor-not-allowed group-invalid:ring-[#C99727] group-invalid:ring-2 group-invalid:bg-transparent group-invalid:text-[#C99727] group-invalid:shadow-none group-invalid:cursor-not-allowed";
                default:
                    return "";
            }
        }() + " outline-none focus-visible:ring-4 focus-visible:ring-offset-4 focus-visible:ring-primary-600";
    }), Vi = F2(function(t, e) {
        return A2(Yo, x([
            qo("min-h-screen bg-primary-300")
        ]), x([
            A2(Yo, x([
                qo("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), x([
                A2(Yo, x([
                    qo("flex justify-between items-center m-4 my-6 h-8 xs:m-6 sm:mx-8 md:h-9 md:my-10 lg:my-12 lg:mb-14")
                ]), x([
                    A2(Xo, x([
                        qo("outline-none focus-visible:ring-4 focus-visible:ring-primary-300 focus-visible:ring-offset-8 focus-visible:rounded-full"),
                        ei(t.dL),
                        hi("go to website")
                    ]), x([
                        wi(t)
                    ]))
                ])),
                A2(Yo, x([
                    qo("flex flex-col px-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(ci, x([
                        qo("text-3xl font-serif font-bold mb-4 mt-8 sm:text-center lg:text-4xl lg:mb-10 lg:mt-32")
                    ]), x([
                        ui(e.cI.h)
                    ])),
                    A2(ni, x([
                        qo("mb-14 sm:text-center lg:text-2xl lg:mb-20")
                    ]), x([
                        ui(e.cI.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col self-center")
                    ]), x([
                        A2(Xo, x([
                            qo("mb-4 " + A2(Fi, 2, 0)),
                            ei(t.bl)
                        ]), x([
                            ui(e.ct.de.cC)
                        ])),
                        A2(Xo, x([
                            qo(A2(Fi, 0, 0)),
                            ei(t.dL)
                        ]), x([
                            ui(e.ct.de.b8)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), Zi = function(t) {
        return {
            $: 1,
            a: t
        };
    }, qi = {
        $: 0
    }, Ui = {
        $: 0
    }, Qi = function(t) {
        return {
            $: 4,
            a: t
        };
    }, Oi = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M4.75 2.5a.25.25 0 00-.25.25v9.91l3.023-2.489a.75.75 0 01.954 0l3.023 2.49V2.75a.25.25 0 00-.25-.25h-6.5zM3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 01-1.227.579L8 11.722l-3.773 3.107A.75.75 0 013 14.25V2.75z")
            ]), d)
        ]));
    }), Gi = F3(function(t, e, r) {
        return e(t(r));
    }), Wi = function(t) {
        return {
            $: 9,
            a: t
        };
    }, Yi = j, Ki = function(t) {
        return A2(Yi, t, "");
    }, Xi = F3(function(t, e, r) {
        return t > 0 ? A3(Xi, t >> 1, b(e, e), 1 & t ? b(r, e) : r) : r;
    }), tc = F2(function(t, e) {
        return A3(Xi, t, e, "");
    }), ec = F3(function(t, e, r) {
        return b(A2(tc, t - Rr(r), Ki(e)), r);
    }), rc = F2(function(t, e) {
        return hr(t / e);
    }), nc = function(t) {
        return t;
    }, ac = F3(function(t, e, r) {
        for(;;){
            if (!r.b) return e + t;
            var n = r.a, a = r.b;
            if (0 > c(n.ai, e)) return e + n.b;
            r = a;
        }
    }), uc = F2(function(t, e) {
        var r = t.b;
        return A3(ac, t.a, A2(rc, e, 6e4), r);
    }), oc = function(t) {
        var e = A2(rc, t, 1440) + 719468, r = (0 > e ? e - 146096 : e) / 146097 | 0, n = e - 146097 * r, a = (n - (n / 1460 | 0) + (n / 36524 | 0) - (n / 146096 | 0)) / 365 | 0, u = n - (365 * a + (a / 4 | 0) - (a / 100 | 0)), o = (5 * u + 2) / 153 | 0, i = o + (10 > o ? 3 : -9);
        return {
            aq: u - ((153 * o + 2) / 5 | 0) + 1,
            aG: i,
            be: a + 400 * r + (i > 2 ? 0 : 1)
        };
    }, ic = F2(function(t, e) {
        return oc(A2(uc, t, e)).aq;
    }), cc = y, fc = F2(function(t, e) {
        return A2(cc, 24, A2(rc, A2(uc, t, e), 60));
    }), sc = F2(function(t, e) {
        return A2(cc, 60, A2(uc, t, e));
    }), lc = F2(function(t, e) {
        switch(oc(A2(uc, t, e)).aG){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), bc = function(t) {
        var e = t.a, r = t.b;
        return A3(ec, 2, "0", Ve(A2(ic, e, r))) + " " + function(t) {
            switch(t){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        }(A2(lc, e, r)) + " " + A3(ec, 2, "0", Ve(A2(fc, e, r))) + ":" + A3(ec, 2, "0", Ve(A2(sc, e, r)));
    }, dc = F3(function(t, e, r) {
        return A2(Yo, x([
            qo("flex flex-col justify-center items-center gap-4 mt-20 md:mt-32")
        ]), x([
            A2(Yo, x([
                qo("flex flex-col self-center gap-4")
            ]), x([
                A2(si, x([
                    qo(A2(Fi, 2, 0)),
                    ki(_a(Wi(r))),
                    ji("button")
                ]), x([
                    ui(t.b5)
                ])),
                A2(si, x([
                    qo(" font-serif font-extrabold px-6 py-3.5 text-center rounded-full ring-2 ring-black ring-inset group-invalid:bg-grey-200 group-invalid:text-grey-400 group-invalid:shadow-none outline-none focus-visible:ring-4 focus-visible:ring-primary-600 hover:bg-black hover:text-white"),
                    ki(_a(Zi(r)))
                ]), x([
                    ui(t.dc)
                ]))
            ])),
            A2(ni, x([
                qo("text-center text-grey-400 max-w-xs sm:max-w-sm text-sm xs:text-base sm:text-lg whitespace-pre-line break-words")
            ]), x([
                ui(t.da + "\n" + bc(e))
            ]))
        ]));
    }), pc = function(t) {
        var e = t.a, r = t.b;
        return A3(ec, 2, "0", Ve(A2(ic, e, r))) + "." + A3(ec, 2, "0", function(t) {
            switch(t){
                case 0:
                    return "01";
                case 1:
                    return "02";
                case 2:
                    return "03";
                case 3:
                    return "04";
                case 4:
                    return "05";
                case 5:
                    return "06";
                case 6:
                    return "07";
                case 7:
                    return "08";
                case 8:
                    return "09";
                case 9:
                    return "10";
                case 10:
                    return "11";
                default:
                    return "12";
            }
        }(A2(lc, e, r))) + ".";
    }, gc = Rt("input"), xc = Tt, mc = xc, hc = function(t) {
        return {
            $: 4,
            a: t
        };
    }, wc = {
        $: 8
    }, vc = F2(function(t, e) {
        return {
            $: 5,
            a: t,
            b: e
        };
    }), yc = {
        $: 16
    }, kc = {
        $: 16
    }, $c = function(t) {
        return {
            $: 13,
            a: t
        };
    }, Cc = {
        $: 14
    }, _c = function(t) {
        return {
            $: 5,
            a: t
        };
    }, Jc = function(t) {
        return {
            $: 7,
            a: t
        };
    }, jc = F2(function(t, e) {
        return A2(Vt, t, Hu(e));
    }), Bc = jc("disabled"), Mc = Zo("htmlFor"), zc = Rt("form"), Lc = Rt("h3"), Ac = Rt("label"), Pc = "text-xs tracking-wide uppercase font-bold sm:text-sm", Dc = function(t) {
        return A2(Zt, "minLength", Ve(t));
    }, Nc = function(t) {
        return s(t, !0);
    }, Sc = F2(function(t, e) {
        return A2(vi, t, {
            $: 1,
            a: e
        });
    }), Ic = F2(function(t, e) {
        return A3(Xr, mn, e, t);
    }), Rc = A2(Ic, x([
        "target",
        "value"
    ]), $a), Ec = function(t) {
        return A2(Sc, "input", A2(zr, Nc, A2(zr, t, Rc)));
    }, Tc = function(t) {
        return s(t, !0);
    }, Hc = F2(function(t, e) {
        return A2(vi, t, {
            $: 2,
            a: e
        });
    }), Fc = function(t) {
        return A2(Hc, "submit", A2(zr, Tc, Ar(t)));
    }, Vc = Zo("placeholder"), Zc = F3(function(t, e, r) {
        return A2(Ze, e, A2(qe, t, r));
    }), qc = jc("required"), Uc = F4(function(t, e, r, n) {
        return {
            cg: e,
            cp: t,
            cJ: r,
            dw: n
        };
    }), Qc = Ce, Oc = A2(Gi, function(t) {
        return A2(Qc, {
            bt: !1,
            cu: !1
        }, t);
    }, va(/.^/)), Gc = _e(1 / 0), Wc = F2(function(t, e) {
        return A2(va, "", A2(Wa, function(e) {
            var r = e.b;
            return A2(Yi, t(e.a), r);
        }, ar(e)));
    }), Yc = function(t) {
        return t.toUpperCase();
    }, Kc = function(t) {
        return A2(Wc, Yc, t);
    }, Xc = function(t) {
        var e = A2(Gc, Oc("\\w+"), A2(Gi, function(t) {
            return t.cp;
        }, Kc));
        return A3(Gc, Oc("^([a-z])|\\s+([a-z])"), A2(Gi, function(t) {
            return t.cp;
        }, e), t);
    }, tf = Zo("value"), ef = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 24 24"),
            Qo("none"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                So("M4.88207 23L2.01448 20.106L20.1179 2L23 4.8795L4.88207 23ZM20.1179 23L2 4.8795L4.88207 2L22.9855 20.106L20.1179 23Z")
            ]), d)
        ]));
    }), rf = F4(function(t, e, r, n) {
        var a, o = function(t) {
            return A2(Yo, x([
                qo("fixed z-40 inset-0 flex flex-col bg-white lg:p-6 lg:justify-center lg:items-center lg:bg-primary-300/80 lg:backdrop-blur-sm")
            ]), x([
                A2(Yo, x([
                    qo("relative flex flex-col p-6 overflow-auto max-w-3xl lg:p-14 lg:bg-white lg:max-h-[90%] lg:min-w-[30rem] lg:rounded-2xl lg:shadow-lg")
                ]), t)
            ]));
        }, i = function(t) {
            return A2(Yo, x([
                qo("fixed z-40 inset-0 p-6 flex flex-col justify-center items-center bg-primary-300/80 backdrop-blur-sm")
            ]), x([
                A2(Yo, x([
                    qo("flex flex-col p-6 max-w-md max-h-[90%] overflow-auto bg-white rounded-xl shadow-lg lg:max-w-lg lg:p-10 lg:rounded-2xl")
                ]), t)
            ]));
        };
        switch(n.$){
            case 1:
                var c = n.a.D, f = n.a.cQ, s = n.a.Q, l = n.a.R;
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.bE.h)
                    ])),
                    A2(ni, d, x([
                        ui(A3(Zc, "{name}", Xc(r.bn), e.ct.bE.k))
                    ])),
                    f.$ ? ui("") : A2(ni, x([
                        qo("mt-4")
                    ]), x([
                        ui(A3(Zc, "{name}", Xc(r.bn), e.ct.bE.cS))
                    ])),
                    f.$ ? A2(Yo, x([
                        qo("mt-10 flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            bi(Yu(_u)),
                            qo(A2(Fi, 1, 1)),
                            ki(_a(A2(vc, c, s))),
                            ji("button"),
                            Bc(!f.$ && !u(l, f.a))
                        ]), x([
                            ui(e.ct.bE.u)
                        ])),
                        A2(si, x([
                            qo(A2(Fi, 0, 0)),
                            ki(_a(wc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.br)
                        ]))
                    ])) : A2(zc, x([
                        Fc(_a(A2(vc, c, s)))
                    ]), x([
                        A2(Yo, x([
                            qo("flex flex-col gap-1.5 mt-6")
                        ]), x([
                            A2(Ac, x([
                                Mc("code-test"),
                                qo(Pc + " text-grey-600 selection:bg-white")
                            ]), x([
                                ui(e.cV)
                            ])),
                            A2(Yo, x([
                                qo("flex flex-wrap gap-4 items-center")
                            ]), x([
                                A2(gc, x([
                                    bi("code-input"),
                                    qo("appearance-none w-full px-4 py-3.5 bg-grey-100 rounded-md outline-none focus:bg-white focus:ring-2 focus:ring-inset focus:ring-grey-200 filled-invalid:ring filled-invalid:ring-red-400"),
                                    Vc(e.aL),
                                    Ec(A2(Ou, _a, hc)),
                                    tf(s),
                                    Dc(1),
                                    qc(!0)
                                ]), d)
                            ])),
                            A2(Yo, x([
                                qo("mt-10 flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                            ]), x([
                                A2(si, x([
                                    qo(A2(Fi, 1, 1)),
                                    ji("submit"),
                                    Bc(!f.$ && !u(l, f.a))
                                ]), x([
                                    ui(e.ct.bE.u)
                                ])),
                                A2(si, x([
                                    qo(A2(Fi, 0, 0)),
                                    ki(_a(wc)),
                                    ji("button")
                                ]), x([
                                    ui(e.ct.br)
                                ]))
                            ]))
                        ]))
                    ]))
                ]));
            case 3:
                return o(x([
                    A2(Lc, x([
                        qo("mb-6 text-2xl font-serif font-bold lg:w-5/6 lg:mb-10")
                    ]), x([
                        ui(e.ct.cT.h)
                    ])),
                    A2(ni, x([
                        qo("whitespace-pre-wrap")
                    ]), x([
                        ui(e.ct.cT.k)
                    ])),
                    A2(si, x([
                        qo("fixed bottom-6 right-6 !p-4 lg:absolute lg:bottom-auto lg:top-6 lg:right-6" + A2(Fi, 0, 0)),
                        ki(_a(wc)),
                        ji("button")
                    ]), x([
                        A2(ef, "w-6 h-6 fill-current", d)
                    ]))
                ]));
            case 4:
                return o(x([
                    A2(Lc, x([
                        qo("mb-6 text-2xl font-serif font-bold lg:w-5/6 lg:mb-10")
                    ]), x([
                        ui(e.ct.cU.h)
                    ])),
                    A2(ni, x([
                        qo("whitespace-pre-wrap")
                    ]), x([
                        ui(A3(Zc, "{name}", Xc(r.bn), e.ct.cU.k))
                    ])),
                    A2(si, x([
                        qo("fixed bottom-6 right-6 !p-4 lg:absolute lg:bottom-auto lg:top-6 lg:right-6" + A2(Fi, 0, 0)),
                        ki(_a(wc)),
                        ji("button")
                    ]), x([
                        A2(ef, "w-6 h-6 fill-current", d)
                    ]))
                ]));
            case 5:
                return o(x([
                    A2(Lc, x([
                        qo("mb-6 text-2xl font-serif font-bold lg:w-5/6 lg:mb-10")
                    ]), x([
                        ui(e.ct.bS.h)
                    ])),
                    A2(ni, x([
                        qo("whitespace-pre-wrap")
                    ]), x([
                        ui(e.ct.bS.k)
                    ])),
                    A2(si, x([
                        qo("fixed bottom-6 right-6 !p-4 lg:absolute lg:bottom-auto lg:top-6 lg:right-6" + A2(Fi, 0, 0)),
                        ki(_a(wc)),
                        ji("button")
                    ]), x([
                        A2(ef, "w-6 h-6 fill-current", d)
                    ]))
                ]));
            case 6:
                var b = n.a;
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.bQ.h)
                    ])),
                    A2(ni, x([
                        qo("mb-4")
                    ]), x([
                        ui(e.ct.bQ.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-center lg:justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            qo(A2(Fi, 1, 0)),
                            ki(Qi((a = b, {
                                $: 12,
                                a: a
                            }))),
                            ji("button")
                        ]), x([
                            ui(e.ct.bQ.u)
                        ])),
                        A2(si, x([
                            qo(A2(Fi, 0, 0)),
                            ki(_a(wc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.br)
                        ]))
                    ]))
                ]));
            case 7:
                return b = n.a, i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.cf.h)
                    ])),
                    A2(ni, x([
                        qo("mb-10")
                    ]), x([
                        ui(e.ct.cf.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-center lg:justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            qo(A2(Fi, 1, 0)),
                            ki(Qi($c(b))),
                            ji("button")
                        ]), x([
                            ui(e.ct.cf.u)
                        ])),
                        A2(si, x([
                            qo(A2(Fi, 0, 0)),
                            ki(_a(wc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.br)
                        ]))
                    ]))
                ]));
            case 8:
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.bM.h)
                    ])),
                    A2(ni, x([
                        qo("mb-10")
                    ]), x([
                        ui(e.ct.bM.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            bi(Yu(_u)),
                            qo(A2(Fi, 1, 0)),
                            ki(Qi(yc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.bM.u)
                        ])),
                        A2(si, x([
                            qo(A2(Fi, 0, 0)),
                            ki(_a(wc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.br)
                        ]))
                    ]))
                ]));
            case 9:
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.dg.h)
                    ])),
                    A2(ni, x([
                        qo("mb-10 whitespace-pre-line break-words")
                    ]), x([
                        ui(e.ct.dg.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            bi(Yu(_u)),
                            qo(A2(Fi, 1, 0)),
                            ki(_c(Cc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.dg.u)
                        ])),
                        A2(si, x([
                            qo(A2(Fi, 0, 0)),
                            ki(_a(wc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.br)
                        ]))
                    ]))
                ]));
            case 10:
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.bN.h)
                    ])),
                    A2(ni, x([
                        qo("mb-10")
                    ]), x([
                        ui(e.ct.bN.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            bi(Yu(_u)),
                            qo("px-6 py-4" + A2(Fi, 1, 0)),
                            ki(_c(kc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.bN.u)
                        ])),
                        A2(si, x([
                            qo("px-6 py-4" + A2(Fi, 0, 0)),
                            ki(_a(wc)),
                            ji("button")
                        ]), x([
                            ui(e.ct.br)
                        ]))
                    ]))
                ]));
            case 11:
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.di.h)
                    ])),
                    A2(ni, x([
                        qo("mb-10")
                    ]), x([
                        ui(e.ct.di.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-center self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            qo("px-6 py-4" + A2(Fi, 1, 0)),
                            ki(_a(Jc(r.aB))),
                            ji("button")
                        ]), x([
                            ui(e.ct.di.u)
                        ]))
                    ]))
                ]));
            case 12:
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.dp.h)
                    ])),
                    A2(ni, x([
                        qo("mb-10")
                    ]), x([
                        ui(e.ct.dp.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-center self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(si, x([
                            qo("px-6 py-4" + A2(Fi, 1, 0)),
                            ki(_a(Jc(r.aB))),
                            ji("button")
                        ]), x([
                            ui(e.ct.dp.u)
                        ]))
                    ]))
                ]));
            case 2:
                return i(x([
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold mb-4")
                    ]), x([
                        ui(e.ct.de.h)
                    ])),
                    A2(ni, x([
                        qo("mb-10")
                    ]), x([
                        ui(e.ct.de.k)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4 justify-between self-center lg:flex-row-reverse lg:w-full")
                    ]), x([
                        A2(Xo, x([
                            qo("px-6 py-4" + A2(Fi, 1, 0)),
                            ei(t.bl)
                        ]), x([
                            ui(e.ct.de.cC)
                        ])),
                        A2(Xo, x([
                            qo("px-6 py-4" + A2(Fi, 0, 0)),
                            ei(t.dL)
                        ]), x([
                            ui(e.ct.de.b8)
                        ]))
                    ]))
                ]));
            default:
                return ui("");
        }
    }), nf = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M5.5 3.5a2 2 0 100 4 2 2 0 000-4zM2 5.5a3.5 3.5 0 115.898 2.549 5.507 5.507 0 013.034 4.084.75.75 0 11-1.482.235 4.001 4.001 0 00-7.9 0 .75.75 0 01-1.482-.236A5.507 5.507 0 013.102 8.05 3.49 3.49 0 012 5.5zM11 4a.75.75 0 100 1.5 1.5 1.5 0 01.666 2.844.75.75 0 00-.416.672v.352a.75.75 0 00.574.73c1.2.289 2.162 1.2 2.522 2.372a.75.75 0 101.434-.44 5.01 5.01 0 00-2.56-3.012A3 3 0 0011 4z")
            ]), d)
        ]));
    }), af = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 24 24"),
            Qo("none"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                So("M11.6136 23.2726L14.25 20.6476L7.32951 13.7385H23.5454V9.89762H7.32951L14.25 2.97716L11.6136 0.363525L0.159058 11.8181L11.6136 23.2726Z")
            ]), d)
        ]));
    }), uf = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Qo("none"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M6.5 1.75a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25V3h-3V1.75zm4.5 0V3h2.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75zM4.496 6.675a.75.75 0 10-1.492.15l.66 6.6A1.75 1.75 0 005.405 15h5.19c.9 0 1.652-.681 1.741-1.576l.66-6.6a.75.75 0 00-1.492-.149l-.66 6.6a.25.25 0 01-.249.225h-5.19a.25.25 0 01-.249-.225l-.66-6.6z")
            ]), d)
        ]));
    }), of = F6(function(t, e, r, n, a, u) {
        var o;
        return A2(Yo, x([
            qo("flex flex-col mx-4 mb-6 bg-white rounded-xl shadow-md shadow-black/5 md:mx-8 md:mb-12 overflow-hidden")
        ]), x([
            A2(si, x([
                qo("flex flex-col gap-4 p-4 text-left rounded-xl xs:p-5 md:p-8 lg:pb-8 outline-none focus-visible:ring-4 focus-visible:ring-primary-600 focus-visible:ring-inset"),
                ti(x([
                    s("lg:!pb-0", n)
                ])),
                ji("button"),
                ki(a)
            ]), x([
                A2(Yo, x([
                    qo("flex w-full items-center gap-2 lg:flex-row-reverse lg:gap-5")
                ]), x([
                    A2(Yo, x([
                        qo("flex flex-col gap-1 grow")
                    ]), x([
                        A2(ci, x([
                            qo("font-serif font-bold text-lg xs:text-xl md:text-2xl")
                        ]), x([
                            ui(r.h)
                        ])),
                        A2(Yo, x([
                            qo("flex flex-wrap gap-y-2 gap-x-4 sm:gap-x-6 text-sm xs:text-base sm:text-lg text-grey-400")
                        ]), x([
                            A2(Yo, x([
                                qo("flex gap-1.5 items-center capitalize")
                            ]), x([
                                A2(Ri, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", d),
                                ui(r.bn)
                            ])),
                            A2(Yo, x([
                                qo("flex gap-1.5 items-center")
                            ]), x([
                                A2(Uo, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", d),
                                ui(t.db + " " + pc(s(e, r.bT)))
                            ]))
                        ]))
                    ])),
                    A2(Vo, "shrink-0 w-4 h-4 transition-transform", x([
                        s("rotate-90", n)
                    ]))
                ]))
            ])),
            A2(Yo, x([
                qo("fixed inset-0 px-6 py-10 z-40 bg-white flex flex-col gap-6 sm:px-8 lg:static lg:z-0 lg:m-0 lg:pt-6 lg:pb-10 lg:pl-16 lg:ml-1"),
                ti(x([
                    s("hidden", !n)
                ]))
            ]), x([
                A2(Yo, x([
                    qo("lg:hidden flex flex-col gap-1")
                ]), x([
                    A2(ci, x([
                        qo("font-serif font-bold text-lg xs:text-xl md:text-2xl")
                    ]), x([
                        ui(r.h)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-wrap gap-y-2 gap-x-4 sm:gap-x-6 text-sm xs:text-base sm:text-lg text-grey-400")
                    ]), x([
                        A2(Yo, x([
                            qo("flex gap-1.5 items-center capitalize")
                        ]), x([
                            A2(Ri, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", d),
                            ui(r.bn)
                        ])),
                        A2(Yo, x([
                            qo("flex gap-1.5 items-center")
                        ]), x([
                            A2(Uo, "inline-block w-3 h-3 fill-grey-400 sm:w-4 sm:h-4", d),
                            ui(t.db + " " + pc(s(e, r.bT)))
                        ]))
                    ]))
                ])),
                function() {
                    var e = r.k;
                    if (e.$) return ui("");
                    var n = e.a;
                    return A2(Yo, x([
                        qo("lg:space-y-1")
                    ]), x([
                        A2(Yo, x([
                            qo(Pc)
                        ]), x([
                            ui(t.df)
                        ])),
                        A2(ni, x([
                            qo("whitespace-pre-line break-words")
                        ]), x([
                            ui(n)
                        ]))
                    ]));
                }(),
                A2(Yo, x([
                    qo("flex flex-col p-6 gap-4 text-sm text-grey-400 bg-grey-100 rounded-xl xs:text-base sm:text-lg lg:bg-transparent lg:p-0 lg:pt-8 lg:mt-2 lg:border-t lg:border-grey-200 lg:rounded-none")
                ]), x([
                    ui(A3(Zc, "{time}", bc(s(e, r.bT)), t.c9)),
                    A2(si, x([
                        (o = u, A2(Sc, "click", Ar(s(o, !0)))),
                        qo("flex self-start px-3 py-2 gap-2 items-center text-sm md:text-base text-black fill-black font-semibold ring-2 ring-black rounded-full hover:bg-black hover:text-white hover:fill-white")
                    ]), x([
                        A2(uf, "w-4 h-4 fill-current", d),
                        ui(t.dd)
                    ]))
                ])),
                A2(Yo, x([
                    qo("fixed bottom-0 inset-x-0 flex p-6 justify-start")
                ]), x([
                    A2(si, x([
                        qo("lg:hidden self-end p-4 rounded-full bg-white shadow-md ring-1 ring-grey-50 hover:bg-black hover:text-white hover:fill-white hover:ring-black outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                        ki(a),
                        ji("button")
                    ]), x([
                        A2(af, "w-6 h-6 fill-current", d)
                    ]))
                ]))
            ]))
        ]));
    }), cf = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z")
            ]), d)
        ]));
    }), ff = F2(function(t, e) {
        for(;;){
            if (!e.b) return !1;
            var r = e.b;
            if (t(e.a)) return !0;
            e = r;
        }
    }), sf = F2(function(t, e) {
        return A2(ff, function(e) {
            return u(e, t);
        }, e);
    }), lf = F4(function(t, e, r, n) {
        for(;;){
            if (!r.b) return nr(n);
            var a = r.a, u = r.b, o = t(a);
            A2(sf, o, e) ? r = u : (e = A2(Je, o, e), r = u, n = A2(Je, a, n));
        }
    }), bf = F2(function(t, e) {
        return A4(lf, t, d, e, d);
    }), df = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M5.5 4a2.5 2.5 0 014.607-1.346.75.75 0 101.264-.808A4 4 0 004 4v2h-.501A1.5 1.5 0 002 7.5v6A1.5 1.5 0 003.5 15h9a1.5 1.5 0 001.5-1.5v-6A1.5 1.5 0 0012.5 6h-7V4zm-.75 3.5H3.5v6h9v-6H4.75z")
            ]), d)
        ]));
    }), pf = function(t) {
        return {
            $: 6,
            a: t
        };
    }, gf = function(t) {
        return {
            $: 5,
            a: t
        };
    }, xf = function(t) {
        return {
            $: 14,
            a: t
        };
    }, mf = {
        $: 1
    }, hf = function(t) {
        return {
            $: 4,
            a: t
        };
    }, wf = {
        $: 15
    }, vf = function(t) {
        return {
            $: 10,
            a: t
        };
    }, yf = {
        $: 2
    }, kf = function(t) {
        return {
            $: 11,
            a: t
        };
    }, $f = function(t) {
        return {
            $: 3,
            a: t
        };
    }, Cf = {
        $: 1
    }, _f = {
        $: 8
    }, Jf = {
        $: 9
    }, jf = {
        $: 7
    }, Bf = F2(function(t, e) {
        return e.ds ? ui("") : A2(ri, x([
            qo("relative flex flex-col border-2 border-yellow-500 border-dashed rounded-xl lg:overflow-hidden")
        ]), x([
            A2(si, x([
                qo("flex items-center gap-x-4 p-4 rounded-xl md:p-6 lg:flex-row-reverse outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                ki(Cf),
                ji("button")
            ]), x([
                A2(Ci, x([
                    qo("line-clamp-2 text-left grow text-yellow-800")
                ]), x([
                    ui(t.c5)
                ]))
            ]))
        ]));
    }), Mf = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Qo("none"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                So("M8.66675 4.99992C8.66675 5.17673 8.59651 5.3463 8.47149 5.47132C8.34646 5.59635 8.17689 5.66659 8.00008 5.66659C7.82327 5.66659 7.6537 5.59635 7.52868 5.47132C7.40365 5.3463 7.33341 5.17673 7.33341 4.99992C7.33341 4.82311 7.40365 4.65354 7.52868 4.52851C7.6537 4.40349 7.82327 4.33325 8.00008 4.33325C8.17689 4.33325 8.34646 4.40349 8.47149 4.52851C8.59651 4.65354 8.66675 4.82311 8.66675 4.99992ZM6.66675 7.49992C6.66675 7.36731 6.71943 7.24013 6.81319 7.14637C6.90696 7.0526 7.03414 6.99992 7.16675 6.99992H8.16675C8.29936 6.99992 8.42653 7.0526 8.5203 7.14637C8.61407 7.24013 8.66675 7.36731 8.66675 7.49992V10.3333H9.16675C9.29936 10.3333 9.42653 10.3859 9.5203 10.4797C9.61407 10.5735 9.66675 10.7006 9.66675 10.8333C9.66675 10.9659 9.61407 11.093 9.5203 11.1868C9.42653 11.2806 9.29936 11.3333 9.16675 11.3333H7.16675C7.03414 11.3333 6.90696 11.2806 6.81319 11.1868C6.71943 11.093 6.66675 10.9659 6.66675 10.8333C6.66675 10.7006 6.71943 10.5735 6.81319 10.4797C6.90696 10.3859 7.03414 10.3333 7.16675 10.3333H7.66675V7.99992H7.16675C7.03414 7.99992 6.90696 7.94724 6.81319 7.85347C6.71943 7.7597 6.66675 7.63253 6.66675 7.49992Z")
            ]), d),
            A2(Eo, x([
                Io("evenodd"),
                di("evenodd"),
                So("M8.00008 0.666748C3.95008 0.666748 0.666748 3.95008 0.666748 8.00008C0.666748 12.0501 3.95008 15.3334 8.00008 15.3334C12.0501 15.3334 15.3334 12.0501 15.3334 8.00008C15.3334 3.95008 12.0501 0.666748 8.00008 0.666748ZM1.66675 8.00008C1.66675 6.32038 2.33401 4.70947 3.52174 3.52174C4.70947 2.33401 6.32038 1.66675 8.00008 1.66675C9.67979 1.66675 11.2907 2.33401 12.4784 3.52174C13.6662 4.70947 14.3334 6.32038 14.3334 8.00008C14.3334 9.67979 13.6662 11.2907 12.4784 12.4784C11.2907 13.6662 9.67979 14.3334 8.00008 14.3334C6.32038 14.3334 4.70947 13.6662 3.52174 12.4784C2.33401 11.2907 1.66675 9.67979 1.66675 8.00008Z")
            ]), d)
        ]));
    }), zf = F2(function(t, e) {
        return !A2(Qn, t, e).$;
    }), Lf = F2(function(t, e) {
        return A2(zf, t, e);
    }), Af = F4(function(t, e, r, n) {
        return A2(ri, x([
            qo("relative flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40")
        ]), x([
            A2(Yo, x([
                qo("flex items-center lg:gap-6")
            ]), x([
                A2(si, x([
                    bi(n.aB),
                    qo("flex grow items-center gap-x-4 p-4 rounded-xl text-grey-400 md:p-6 lg:flex-row-reverse lg:pr-0 outline-none focus-visible:ring-4 focus-visible:ring-primary-600 focus-visible:ring-inset"),
                    function() {
                        if (r.$) return t = r.a, ki(A2(Lf, n.aB, e.ad) ? t.W(n.aB) : t.ac(n.aB));
                        var t = r.a;
                        return ki(A2(Lf, n.aB, e.ad) ? t.W(n.aB) : t.ac(n.aB));
                    }(),
                    ji("button")
                ]), x([
                    A2(Ci, x([
                        qo("line-clamp-2 text-left grow")
                    ]), x([
                        ui(n.h)
                    ])),
                    A2(Vo, "w-4 h-4 transition-transform", x([
                        s("rotate-90", A2(Lf, n.aB, e.ad))
                    ]))
                ])),
                function() {
                    if (r.$) return ui("");
                    var e = r.a;
                    return A2(si, x([
                        qo($i(1) + " hidden lg:block mr-4 md:mr-6 shadow-none"),
                        ki(e.cd(n.aB)),
                        ji("button")
                    ]), x([
                        ui(t.c6.ce)
                    ]));
                }()
            ])),
            A2(Yo, x([
                qo("fixed lg:static z-40 lg:z-0 inset-0 flex flex-col gap-y-6 py-10 px-6 bg-white rounded-b-xl overflow-y-auto lg:pt-0 lg:pb-10 lg:pl-14"),
                ti(x([
                    s("hidden", !A2(Lf, n.aB, e.ad))
                ]))
            ]), x([
                function() {
                    if (r.$) return ui("");
                    var e = r.a;
                    return A2(si, x([
                        qo("absolute top-3 right-3 flex items-center gap-1.5 py-1 px-2.5 text-sm text-grey-400 bg-grey-100 font-semibold rounded-full cursor-pointer lg:hidden"),
                        ki(e.dt),
                        ji("button")
                    ]), x([
                        A2(Mf, "w-4 h-4 fill-grey-400", d),
                        ui(t.c6.bR)
                    ]));
                }(),
                A2(Yo, x([
                    qo("lg:hidden")
                ]), x([
                    A2(Yo, x([
                        qo(Pc + " text-grey-400")
                    ]), x([
                        ui(t.c4)
                    ])),
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold")
                    ]), x([
                        ui(n.h)
                    ]))
                ])),
                function() {
                    var e = n.k;
                    if (e.$) return A2(ni, x([
                        qo("whitespace-pre-line break-words text-grey-400")
                    ]), x([
                        ui(t.bL)
                    ]));
                    var r = e.a;
                    return A2(Yo, x([
                        qo("lg:space-y-1")
                    ]), x([
                        A2(Yo, x([
                            qo(Pc + " text-grey-400")
                        ]), x([
                            ui(t.c3)
                        ])),
                        A2(ni, x([
                            qo("whitespace-pre-line break-words")
                        ]), x([
                            ui(r)
                        ]))
                    ]));
                }(),
                A2(Yo, x([
                    qo("fixed lg:hidden z-10 bottom-0 inset-x-0 flex p-6 justify-between lg:justify-end")
                ]), x([
                    A2(si, x([
                        qo("lg:hidden !p-4" + A2(Fi, 0, 0)),
                        ki(r.a.W(n.aB)),
                        ji("button")
                    ]), x([
                        A2(af, "w-6 h-6 fill-current", d)
                    ])),
                    function() {
                        if (r.$) return ui("");
                        var e = r.a;
                        return A2(si, x([
                            qo(A2(Fi, 1, 0)),
                            ki(e.cd(n.aB)),
                            ji("button")
                        ]), x([
                            ui(t.c6.ce)
                        ]));
                    }()
                ]))
            ]))
        ]));
    }), Pf = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm9 3a1 1 0 11-2 0 1 1 0 012 0zM6.92 6.085c.081-.16.19-.299.34-.398.145-.097.371-.187.74-.187.28 0 .553.087.738.225A.613.613 0 019 6.25c0 .177-.04.264-.077.318a.956.956 0 01-.277.245c-.076.051-.158.1-.258.161l-.007.004a7.728 7.728 0 00-.313.195 2.416 2.416 0 00-.692.661.75.75 0 001.248.832.956.956 0 01.276-.245 6.3 6.3 0 01.26-.16l.006-.004c.093-.057.204-.123.313-.195.222-.149.487-.355.692-.662.214-.32.329-.702.329-1.15 0-.76-.36-1.348-.863-1.725A2.76 2.76 0 008 4c-.631 0-1.155.16-1.572.438-.413.276-.68.638-.849.977a.75.75 0 101.342.67z")
            ]), d)
        ]));
    }), Df = F2(function(t, e) {
        return A2(si, x([
            qo("flex items-center gap-1.5 text-sm font-semibold text-primary-600 " + e),
            ki(t),
            ji("button")
        ]), x([
            A2(Pf, "w-4 h-4 fill-primary-600", d)
        ]));
    }), Nf = F2(function(t, e) {
        for(;;){
            if (!e.b) return Te;
            var r = e.a, n = e.b;
            if (t(r)) return Ee(r);
            e = n;
        }
    }), Sf = Rt("h2"), If = function(t) {
        return 1 !== t.$;
    }, Rf = function(t) {
        return A2(Zt, "maxlength", Ve(t));
    }, Ef = function(t) {
        return Rt(function(t) {
            return Ut.test(t) ? "p" : t;
        }(t));
    }, Tf = function(t) {
        return 1 === t.$;
    }, Hf = F3(function(t, e, r) {
        return A2(ri, x([
            qo("relative flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40 lg:overflow-hidden")
        ]), x([
            A2(Yo, x([
                qo("flex items-center lg:gap-6")
            ]), x([
                A2(si, x([
                    qo("flex grow items-center gap-x-4 p-4 rounded-xl md:p-6 lg:flex-row-reverse lg:pr-0 max-lg:truncate lg:max-w-[707px] outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                    ki(A2(Lf, r.aB, e.ad) ? hf(r.aB) : $f(r.aB)),
                    ji("button")
                ]), x([
                    A2(Ci, x([
                        qo("line-clamp-2 text-left grow")
                    ]), x([
                        ui(r.h)
                    ])),
                    A2(Vo, "w-4 h-4 transition-transform", x([
                        s("rotate-90", A2(Lf, r.aB, e.ad)),
                        s("fill-grey-300", Tf(r.k))
                    ]))
                ])),
                A2(si, x([
                    qo($i(1) + " hidden lg:block mr-4 md:mr-6 shadow-none"),
                    ki(vf(r.aB)),
                    ji("button")
                ]), x([
                    ui(t.c6.bP)
                ]))
            ])),
            A2(Yo, x([
                qo("fixed lg:static z-40 lg:z-0 inset-0 flex flex-col gap-y-6 py-10 px-6 bg-white overflow-y-auto lg:pt-0 lg:pb-10 lg:pl-14"),
                ti(x([
                    s("hidden", !A2(Lf, r.aB, e.ad))
                ]))
            ]), x([
                A2(Yo, x([
                    qo("lg:hidden")
                ]), x([
                    A2(Yo, x([
                        qo(Pc + " text-grey-400")
                    ]), x([
                        ui(t.c4)
                    ])),
                    A2(Lc, x([
                        qo("text-2xl font-serif font-bold break-word")
                    ]), x([
                        ui(r.h)
                    ]))
                ])),
                function() {
                    var e = r.k;
                    if (e.$) return A2(ni, x([
                        qo("whitespace-pre-line break-words text-grey-400")
                    ]), x([
                        ui(t.bL)
                    ]));
                    var n = e.a;
                    return A2(Yo, x([
                        qo("lg:space-y-1")
                    ]), x([
                        A2(Yo, x([
                            qo(Pc + " text-grey-400")
                        ]), x([
                            ui(t.c3)
                        ])),
                        A2(ni, x([
                            qo("whitespace-pre-line break-words")
                        ]), x([
                            ui(n)
                        ]))
                    ]));
                }(),
                A2(Yo, x([
                    qo("fixed lg:hidden z-10 bottom-0 inset-x-0 flex p-6 justify-between lg:justify-end")
                ]), x([
                    A2(si, x([
                        qo("lg:hidden !p-4" + A2(Fi, 0, 0)),
                        ki(hf(r.aB)),
                        ji("button")
                    ]), x([
                        A2(af, "w-6 h-6 fill-current", d)
                    ])),
                    A2(si, x([
                        qo(A2(Fi, 1, 0)),
                        ki(vf(r.aB)),
                        ji("button")
                    ]), x([
                        ui(t.c6.bP)
                    ]))
                ]))
            ]))
        ]));
    }), Ff = function(t) {
        return A2(Hc, "click", Ar(s(t, !0)));
    }, Vf = Zo("pattern"), Zf = function(t) {
        return A2(Zt, "rows", Ve(t));
    }, qf = w, Uf = Rt("textarea"), Qf = F4(function(t, e, r, n) {
        var a, o = If(A2(Nf, mr(r.cy.h), A2(tn, function(t) {
            return t.h;
        }, A2(bf, function(t) {
            return t.h;
        }, r.c6)))), i = A2(qf, A2(Gi, function(t) {
            return t.P;
        }, nc), A2(Po, A2(Gi, function(t) {
            return t.ck;
        }, mr(!1)), A2(bf, function(t) {
            return t.h;
        }, r.c6))), c = A2(qf, A2(Gi, function(t) {
            return t.P;
        }, nc), A2(Po, A2(Gi, function(t) {
            return t.ck;
        }, mr(!0)), A2(bf, function(t) {
            return t.h;
        }, r.c6)));
        return A2(zc, x([
            qo("group overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10"),
            Fc(wf)
        ]), x([
            A2(Yo, x([
                qo("flex flex-col w-full px-4 py-10 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), x([
                A2(ni, x([
                    qo("mb-10 font-serif font-bold italic selection:bg-white")
                ]), x([
                    ui(A3(Zc, "{name}", Xc(e.bn), t.c6.S))
                ])),
                A2(Sf, x([
                    qo("mb-2 text-primary-600 lg:mb-3 " + Pc)
                ]), x([
                    A2(Ci, x([
                        qo("selection:bg-white")
                    ]), x([
                        ui(t.c6.h)
                    ])),
                    A2(Ci, x([
                        qo("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2")
                    ]), x([
                        ui(Ve(Oe(i)))
                    ]))
                ])),
                A2(oi, x([
                    qo("relative flex flex-col gap-y-2 md:gap-y-4 mb-4 empty:mb-0")
                ]), n ? A2(tn, A2(Hf, t, r), i) : A2(Je, A2(Bf, t, r), A2(tn, A2(Hf, t, r), i))),
                A2(zc, x([
                    qo("fixed group inset-0 z-40 flex flex-col px-6 py-10 gap-6 bg-white overflow-y-auto lg:static lg:z-0 lg:p-8 lg:rounded-xl lg:on-yellow-shadow"),
                    ti(x([
                        s("hidden", !r.ds)
                    ])),
                    Fc(jf)
                ]), x([
                    A2(Yo, x([
                        qo("flex flex-col gap-2")
                    ]), x([
                        A2(Lc, x([
                            qo("text-xl font-serif font-bold mb-2")
                        ]), x([
                            ui(t.c6.b3)
                        ])),
                        A2(Yo, x([
                            qo("flex flex-col gap-1.5")
                        ]), x([
                            A2(Ac, x([
                                Mc("title-input"),
                                qo(Pc + " text-grey-400")
                            ]), x([
                                ui(t.c6.b1)
                            ])),
                            A2(gc, x([
                                bi("title-input"),
                                qo("appearance-none w-full px-4 py-3.5 bg-grey-100 rounded-md outline-none focus:bg-white focus:ring-2 focus:ring-inset focus:ring-grey-200 filled-invalid:ring filled-invalid:ring-red-400"),
                                Ec(gf),
                                tf(r.cy.h),
                                Vc(" "),
                                Vf(".*\\S.*"),
                                Dc(1),
                                Rf(80),
                                qc(!0)
                            ]), d),
                            o ? A2(ni, x([
                                qo("text-red-600 lg:text-lg")
                            ]), x([
                                ui(t.c6.b4)
                            ])) : ui("")
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col gap-4")
                    ]), x([
                        A2(Yo, x([
                            qo("flex flex-col gap-1.5")
                        ]), x([
                            A2(Ac, x([
                                Mc("description-input"),
                                qo(Pc + " text-grey-400")
                            ]), x([
                                ui(t.c6.b_)
                            ])),
                            A3(Ef, "textarea-autosize", d, x([
                                A2(Uf, x([
                                    bi("description-input"),
                                    qo("appearance-none w-full px-4 py-3.5 bg-grey-100 rounded-md outline-none focus:bg-white focus:ring-2 focus:ring-inset focus:ring-grey-200"),
                                    Zf(2),
                                    Ec(pf),
                                    tf(r.cy.k),
                                    Rf(500)
                                ]), d)
                            ]))
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("fixed flex bottom-0 inset-x-0 p-6 justify-between lg:p-0 lg:static")
                    ]), x([
                        A2(si, x([
                            qo(A2(Fi, 0, 0)),
                            ki(yf),
                            ji("button")
                        ]), x([
                            ui(t.bs)
                        ])),
                        A2(si, x([
                            qo(A2(Fi, 1, 1)),
                            ji("submit"),
                            Bc(o || n >= 50)
                        ]), x([
                            ui(t.c6.bg)
                        ]))
                    ]))
                ])),
                A2(si, x([
                    bi(Yu(mf)),
                    qo("mt-2 self-center lg:self-end" + A2(Fi, 2, 2)),
                    ti(x([
                        s("hidden", r.ds)
                    ])),
                    ki(Cf),
                    ji("button"),
                    Bc(n >= 50)
                ]), x([
                    ui(t.c6.bf)
                ])),
                Oe(c) > 0 ? A2(li, x([
                    qo("group mt-4 lg:mt-8")
                ]), x([
                    A2(_i, x([
                        qo("flex gap-1 items-center text-primary-600 cursor-pointer [&::-webkit-details-marker]:hidden lg:mb-4 lg:gap-2 " + Pc + " outline-none focus-visible:outline-2 focus-visible:outline-primary-600 focus-visible:rounded-full")
                    ]), x([
                        A2(Vo, "w-3 stroke-1 stroke-primary-600 fill-primary-600 transition-transform group-open:rotate-90 md:-mr-0.5", d),
                        A2(Ci, x([
                            qo("selection:bg-white")
                        ]), x([
                            ui(t.c6.bR)
                        ])),
                        A2(Df, _f, "ml-auto order-1 md:order-none md:-ml-1"),
                        A2(Ci, x([
                            qo("inline-block px-1.5 bg-primary-200 rounded-full selection:bg-white")
                        ]), x([
                            ui(Ve(Oe(c)))
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("flex flex-col mt-2 gap-2 md:gap-4")
                    ]), A2(tn, A3(Af, t, r, (a = {
                        W: hf,
                        bO: vf,
                        cd: kf,
                        ac: $f,
                        dt: _f
                    }, {
                        $: 0,
                        a: a
                    })), c))
                ])) : ui("")
            ])),
            A2(Yo, x([
                qo("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), x([
                A2(Yo, x([
                    qo("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("row-start-5 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("col-start-1 row-start-1 row-span-5 w-0.5 justify-self-center bg-primary-300")
                ]), d),
                A2(Yo, x([
                    qo("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), x([
                    ui("3")
                ])),
                A2(Yo, x([
                    qo("row-start-2 col-start-2 font-semibold")
                ]), x([
                    ui(t.dh.h)
                ])),
                A2(ni, x([
                    qo("row-start-3 col-start-2 mt-1 mb-4 text-primary-900 max-w-md")
                ]), x([
                    ui(t.dh.bU)
                ])),
                function() {
                    var a = e.cQ;
                    if (a.$) return A2(si, x([
                        qo(A2(Fi, 2, 2) + " row-start-4 col-start-1 col-span-2 justify-self-center mt-2 sm:mt-4"),
                        Bc(2 > n),
                        ji("submit")
                    ]), x([
                        ui(t.dh.aj)
                    ]));
                    var o = a.a;
                    return A2(Yo, x([
                        qo("row-start-4 col-start-2 mt-2 flex flex-col gap-1.5")
                    ]), x([
                        A2(Ac, x([
                            Mc("code-test"),
                            qo(Pc + " flex gap-1 items-center text-primary-600 selection:bg-white sm:leading-[18px]")
                        ]), x([
                            ui(t.cV),
                            A2(si, x([
                                ji("button"),
                                Ff(Jf)
                            ]), x([
                                A2(Pf, "w-4 h-4 fill-primary-600", d)
                            ]))
                        ])),
                        A2(Yo, x([
                            qo("flex flex-wrap gap-4 justify-center items-center")
                        ]), x([
                            A2(gc, x([
                                bi("code-test"),
                                qo("grow w-full xs:w-auto xs:min-w-[290px] px-4 py-3.5 bg-white placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                                Vc(t.aL),
                                Ec(xf),
                                tf(r.cP),
                                Dc(1)
                            ]), d),
                            A2(si, x([
                                qo(A2(Fi, 2, 2) + " justify-self-center"),
                                Bc(2 > n || !u(o, r.aK)),
                                ji("submit")
                            ]), x([
                                ui(t.dh.aj)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    }), Of = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 24 24"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                So("M9.036 7.976a.75.75 0 00-1.06 1.06L10.939 12l-2.963 2.963a.75.75 0 101.06 1.06L12 13.06l2.963 2.964a.75.75 0 001.061-1.06L13.061 12l2.963-2.964a.75.75 0 10-1.06-1.06L12 10.939 9.036 7.976z")
            ]), d),
            A2(Eo, x([
                Io("evenodd"),
                So("M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM2.5 12a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z")
            ]), d)
        ]));
    }), Gf = F3(function(t, e, r) {
        var n = t.I.bl + "/" + e.aB, a = Oe(A2(Po, A2(Gi, function(t) {
            return t.ck;
        }, mr(!1)), A2(bf, function(t) {
            return t.h;
        }, r.c6)));
        return A2(Yo, d, x([
            Ti(t.J),
            A2(Yo, x([
                qo("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), x([
                A2(Ii, t.I, Ee({
                    T: t.J.bw,
                    U: t.J.by,
                    V: t.J.bx,
                    D: e.aB
                })),
                r.cl ? A2(Yo, x([
                    qo("mx-4 md:mx-8 mb-6")
                ]), x([
                    A2(Yo, x([
                        qo("relative bg-grey-100 rounded-xl px-5 pt-6 pb-8 sm:p-6 sm:py-8 lg:p-8")
                    ]), x([
                        A2(si, x([
                            qo("absolute top-1 right-1 p-3"),
                            ki(Qi(qi))
                        ]), x([
                            A2(Of, "w-5 h-5 fill-black", d)
                        ])),
                        A2(ni, x([
                            qo("mb-4 text-black font-semibold w-5/6")
                        ]), x([
                            ui(t.J.c6.cF)
                        ])),
                        A2(Yo, x([
                            qo("relative w-full max-w-lg flex mb-8")
                        ]), x([
                            A2(gc, x([
                                qo("w-full text-sm sm:text-base leading-none border-black rounded-full text-grey-400 px-4 py-1.5 border-2 outline-none focus-visible:selection:bg-primary-300 selection:bg-white focus-visible:selection:text-black"),
                                ji("url"),
                                tf(A3(Zc, "http://", "", A3(Zc, "https://", "", n)))
                            ]), d),
                            A2(Yo, x([
                                bi("info-copy-link-button"),
                                qo("absolute right-0 grid rounded-r-full h-full")
                            ]), x([
                                A2(si, x([
                                    qo("col-start-1 row-start-1 text-sm sm:text-base font-serif font-extrabold text-white bg-black rounded-r-full h-full px-4 transition-all focus-visible:bg-primary-300 focus-visible:text-black focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-inset outline-none hover:text-black hover:bg-primary-300 hover:ring-2 hover:ring-black hover:ring-inset"),
                                    ji("button"),
                                    ki(_a(A2(fi, "info-copy-link-button", n)))
                                ]), x([
                                    ui(t.J.c6.cA)
                                ])),
                                A2(Yo, x([
                                    qo("opacity-0 col-start-1 row-start-1 transition-opacity pointer-events-none flex gap-1 items-center h-full px-4 text-sm sm:text-base font-serif font-extrabold text-black bg-primary-300 rounded-r-full ring-2 ring-black ring-inset")
                                ]), x([
                                    A2(Ji, "w-4 h-4 fill-current stroke-black stroke-[0.5]", d),
                                    ui(t.J.c6.cB)
                                ]))
                            ]))
                        ])),
                        A2(Yo, x([
                            qo("space-y-4")
                        ]), x([
                            A2(Yo, x([
                                qo("flex items-start gap-3 sm:gap-4 md:items-center")
                            ]), x([
                                A2(Oi, "w-4 shrink-0 translate-y-1 md:translate-y-0", d),
                                A2(ni, x([
                                    qo("text-base md:text-lg")
                                ]), x([
                                    ui(t.J.c6.cz)
                                ]))
                            ])),
                            A2(Yo, x([
                                qo("flex items-start gap-4 md:items-center")
                            ]), x([
                                A2(nf, "w-4 shrink-0 translate-y-1 md:translate-y-0", d),
                                A2(ni, x([
                                    qo("text-base md:text-lg")
                                ]), x([
                                    ui(t.J.c6.cD)
                                ]))
                            ])),
                            A2(Yo, x([
                                qo("flex items-start gap-4 md:items-center")
                            ]), x([
                                A2(df, "w-4 shrink-0 translate-y-1 md:translate-y-0", d),
                                A2(ni, x([
                                    qo("text-base md:text-lg")
                                ]), x([
                                    ui(t.J.c6.cE)
                                ]))
                            ]))
                        ]))
                    ]))
                ])) : ui(""),
                A2(mc, _a, A6(of, t.J, t.dD, e, r.ah, Ui, Zi(e.aB))),
                A2(Yo, x([
                    qo("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("1")
                    ])),
                    A2(Yo, x([
                        qo("flex items-center gap-2 mr-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-grey-400")
                        ]), x([
                            ui(t.J.c8.h)
                        ])),
                        A2(Ji, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", d)
                    ])),
                    A2(Yo, x([
                        qo("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), x([
                        ui(t.J.cZ + " " + pc(s(t.dD, e.P)))
                    ])),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("2")
                    ])),
                    A2(Yo, x([
                        qo("col-start-2 mr-2 flex items-center gap-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-black")
                        ]), x([
                            ui(t.J.c6.h)
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("col-span-2 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), x([
                        ui(t.J.cY)
                    ]))
                ])),
                A2(mc, Qi, A4(Qf, t.J, e, r, a)),
                A2(Yo, x([
                    qo("grid grid-flow-col [grid-template-columns:auto_1fr] px-4 gap-x-2 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 justify-self-center w-0.5 h-12 md:h-14 bg-primary-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 sm:w-6 sm:h-6")
                    ]), x([
                        A2(cf, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", d)
                    ])),
                    A2(Yo, x([
                        qo("col-start-2 row-start-2 flex items-center")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold")
                        ]), x([
                            ui(t.J.$7.h)
                        ]))
                    ])),
                    A2(ni, x([
                        qo("col-start-2 row-start-3 mt-1 text-grey-600 max-w-md")
                    ]), x([
                        ui(t.J.$7.Y)
                    ]))
                ]))
            ])),
            A3(dc, t.J, s(t.dD, e.bT), e.aB),
            A2(Yo, x([
                qo("mt-20 lg:mt-40")
            ]), x([
                A3(Ko, 0, 1, A3(ii, t.I, t.J.bZ, 1))
            ])),
            A4(rf, t.I, t.J, {
                bn: e.bn,
                k: e.k,
                aB: e.aB,
                h: e.h
            }, r.cs)
        ]));
    }), Wf = function(t) {
        return {
            $: 3,
            a: t
        };
    }, Yf = function(t) {
        return {
            $: 2,
            a: t
        };
    }, Kf = function(t) {
        return {
            $: 1,
            a: t
        };
    }, Xf = function(t) {
        return {
            $: 0,
            a: t
        };
    }, ts = function(t) {
        return {
            $: 4,
            a: t
        };
    }, es = {
        $: 6
    }, rs = {
        $: 5
    }, ns = function(t) {
        return {
            $: 3,
            a: t
        };
    }, as = jc("autofocus"), us = jc("checked"), os = A2(Ic, x([
        "target",
        "checked"
    ]), au), is = F2(function(t, e) {
        var r;
        return A2(zc, x([
            qo("group overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10"),
            Fc(rs)
        ]), x([
            A2(Yo, x([
                qo("flex flex-col px-4 py-10 gap-6 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), x([
                A2(ci, x([
                    qo("font-serif font-bold italic selection:bg-white")
                ]), x([
                    ui(t.c8.S)
                ])),
                A2(Yo, x([
                    qo("flex flex-col gap-1.5")
                ]), x([
                    A2(Ac, x([
                        Mc("title-input"),
                        qo(Pc + " text-primary-600 selection:bg-white")
                    ]), x([
                        ui(t.c8.cm)
                    ])),
                    A2(gc, x([
                        qo("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                        Vc(t.c8.c_),
                        Ec(Xf),
                        tf(e.h),
                        Vf(".*\\S.*"),
                        Dc(1),
                        Rf(80),
                        qc(!0),
                        as(!0)
                    ]), d)
                ])),
                A2(Yo, x([
                    qo("flex flex-col gap-1.5")
                ]), x([
                    A2(Ac, x([
                        Mc("info-input"),
                        qo(Pc + " text-primary-600 selection:bg-white")
                    ]), x([
                        ui(t.c8.bF)
                    ])),
                    A3(Ef, "textarea-autosize", d, x([
                        A2(Uf, x([
                            bi("info-input"),
                            qo("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300"),
                            Vc(t.c8.bH),
                            Ec(Kf),
                            Zf(2),
                            tf(e.k),
                            Rf(250)
                        ]), d)
                    ]))
                ])),
                A2(Yo, x([
                    qo("flex flex-col gap-1.5")
                ]), x([
                    A2(Ac, x([
                        Mc("author-input"),
                        qo(Pc + " text-primary-600 selection:bg-white")
                    ]), x([
                        ui(t.c8.cw)
                    ])),
                    A2(gc, x([
                        bi("author-input"),
                        qo("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                        Vc(t.c8.cx),
                        Ec(Yf),
                        tf(e.bn),
                        Vf(".*\\S.*"),
                        Dc(1),
                        Rf(50),
                        qc(!0)
                    ]), d)
                ]))
            ])),
            A2(Yo, x([
                qo("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), x([
                A2(Yo, x([
                    qo("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("row-start-6 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("col-start-1 row-start-1 row-span-6 w-0.5 justify-self-center bg-primary-300")
                ]), d),
                A2(Yo, x([
                    qo("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), x([
                    ui("2")
                ])),
                A2(Yo, x([
                    qo("row-start-2 col-start-2 font-semibold")
                ]), x([
                    ui(t.c6.h)
                ])),
                A2(ni, x([
                    qo("row-start-3 col-start-2 mt-1 mb-4 md:mb-6 text-primary-900 max-w-md")
                ]), x([
                    ui(t.c6.Y)
                ])),
                A2(Yo, x([
                    qo("row-start-4 col-start-2 flex justify-start")
                ]), x([
                    A2(Ac, x([
                        Mc("code-checkbox"),
                        qo("flex gap-2 xs:gap-3 items-center cursor-pointer")
                    ]), x([
                        A2(gc, x([
                            bi("code-checkbox"),
                            ji("checkbox"),
                            qo("peer sr-only"),
                            (r = ns, A2(yi, "change", A2(zr, r, os))),
                            us(!e.cP.$)
                        ]), d),
                        A2(Yo, x([
                            qo("shrink-0 flex justify-center items-center w-5 h-5 xs:w-6 xs:h-6 rounded border-2 border-primary-600 peer-focus-visible:ring peer-focus-visible:ring-primary-600"),
                            ti(x([
                                s("border-0 bg-primary-300", If(e.cP))
                            ]))
                        ]), x([
                            e.cP.$ ? ui("") : A2(Ji, "w-3 h-3 xs:w-4 xs:h-4", d)
                        ])),
                        A2(Yo, x([
                            qo("flex gap-1.5 xs:gap-2 items-center max-xs:translate-y-px")
                        ]), x([
                            A2(ni, x([
                                qo("text-primary-600 selection:bg-white leading-tight")
                            ]), x([
                                ui(t.c8.cR)
                            ])),
                            A2(si, x([
                                ji("button"),
                                Ff(es)
                            ]), x([
                                A2(Pf, "w-4 h-4 fill-primary-600 md:w-5 md:h-5", d)
                            ]))
                        ]))
                    ]))
                ])),
                e.cP.$ ? A2(si, x([
                    qo(A2(Fi, 2, 2) + " row-start-5 col-start-2 justify-self-center mt-10"),
                    ji("submit")
                ]), x([
                    ui(t.c6.aj)
                ])) : A2(Yo, x([
                    qo("row-start-5 col-start-2 mt-4 flex flex-col gap-1.5")
                ]), x([
                    A2(Ac, x([
                        Mc("code-test"),
                        qo(Pc + " text-primary-600 selection:bg-white sm:leading-[18px]")
                    ]), x([
                        ui(t.cV)
                    ])),
                    A2(Yo, x([
                        qo("flex flex-wrap gap-4 justify-center items-center")
                    ]), x([
                        A2(gc, x([
                            bi("code-input"),
                            qo("grow w-full xs:w-auto xs:min-w-[290px] px-4 py-3.5 bg-white placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                            Vc(t.c8.aL),
                            Ec(ts),
                            tf(A2(va, "", e.cP)),
                            Vf(".*\\S.*"),
                            Dc(1),
                            qc(!0)
                        ]), d),
                        A2(si, x([
                            qo(A2(Fi, 2, 2)),
                            ji("submit")
                        ]), x([
                            ui(t.c6.aj)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), cs = F2(function(t, e) {
        return A2(Yo, d, x([
            Ti(t.J),
            A2(Yo, x([
                qo("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), x([
                A2(Ii, t.I, Te),
                A2(Yo, x([
                    qo("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("1")
                    ])),
                    A2(Yo, x([
                        qo("flex items-center gap-2 mr-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold")
                        ]), x([
                            ui(t.J.c8.h)
                        ]))
                    ]))
                ])),
                A2(mc, Wf, A2(is, t.J, e)),
                A2(Yo, x([
                    qo("grid grid-flow-col [grid-template-columns:auto_1fr] px-4 gap-x-2 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 justify-self-center h-14 w-0.5 bg-primary-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 row-span-3 justify-self-center w-0.5 bg-primary-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-3 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("3")
                    ])),
                    A2(Yo, x([
                        qo("col-start-2 row-start-3 flex items-center")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold")
                        ]), x([
                            ui(t.J.dh.h)
                        ]))
                    ])),
                    A2(ni, x([
                        qo("col-start-2 row-start-4 mt-1 mb-4 text-grey-600 max-w-md")
                    ]), x([
                        ui(t.J.dh.Y)
                    ]))
                ])),
                A2(Yo, x([
                    qo("grid grid-flow-col [grid-template-columns:auto_1fr] px-4 gap-x-2 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 justify-self-center w-0.5 h-12 md:h-14 bg-primary-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 sm:w-6 sm:h-6")
                    ]), x([
                        A2(cf, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", d)
                    ])),
                    A2(Yo, x([
                        qo("col-start-2 row-start-2 flex items-center")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold")
                        ]), x([
                            ui(t.J.$7.h)
                        ]))
                    ])),
                    A2(ni, x([
                        qo("col-start-2 row-start-3 mt-1 text-grey-600 max-w-md")
                    ]), x([
                        ui(t.J.$7.Y)
                    ]))
                ])),
                A2(Yo, x([
                    qo("flex flex-col items-center mt-20 md:mt-32 gap-4")
                ]), x([
                    A2(si, x([
                        qo(A2(Fi, 2, 0)),
                        ki(_a(Wi("not created"))),
                        ji("button")
                    ]), x([
                        ui(t.J.b5)
                    ]))
                ]))
            ])),
            A2(Yo, x([
                qo("mt-20 lg:mt-40")
            ]), x([
                A3(Ko, 0, 1, A3(ii, t.I, t.J.bZ, 1))
            ])),
            A4(rf, t.I, t.J, {
                bn: e.bn,
                k: Ee(e.k),
                aB: "",
                h: e.h
            }, e.cs)
        ]));
    }), fs = function(t) {
        return {
            $: 9,
            a: t
        };
    }, ss = function(t) {
        return {
            $: 15,
            a: t
        };
    }, ls = function(t) {
        return {
            $: 1,
            a: t
        };
    }, bs = function(t) {
        return {
            $: 5,
            a: t
        };
    }, ds = {
        $: 13
    }, ps = function(t) {
        return {
            $: 4,
            a: t
        };
    }, gs = {
        $: 10
    }, xs = {
        $: 11
    }, ms = {
        $: 12
    }, hs = F3(function(t, e, r) {
        var n = t.dN, a = Ve, u = function(t) {
            var r = s(n, e);
            return r.a ? r.b ? "in " + t : t + " ago" : t;
        };
        switch(r.$){
            case 0:
            case 1:
                return "now";
            case 2:
                return 1 === (o = r.a) ? "now" : u("less than " + a(o) + " min");
            case 3:
                return u(1 === (o = r.a) ? "1 min" : a(o) + " mins");
            case 4:
                return u(1 === (o = r.a) ? "about 1 hour" : "about " + a(o) + " hours");
            case 5:
                return u(1 === (o = r.a) ? "1 day" : a(o) + " days");
            case 6:
                return u(1 === (o = r.a) ? "about 1 month" : "about " + a(o) + " months");
            case 7:
                return u(1 === (o = r.a) ? "1 month" : a(o) + " months");
            default:
                var o;
                return u(1 === (o = r.a) ? "1 year" : a(o) + " years");
        }
    }), ws = F2(function(t, e) {
        t: for(;;){
            if (t > 0) {
                if (e.b) {
                    t -= 1, e = e.b;
                    continue t;
                }
                return e;
            }
            return e;
        }
    }), vs = function(t) {
        return t.b ? Ee(t.a) : Te;
    }, ys = F2(function(t, e) {
        return 0 > t ? Te : vs(A2(ws, t, e));
    }), ks = function(t) {
        return {
            $: 4,
            a: t
        };
    }, $s = function(t) {
        return {
            $: 2,
            a: t
        };
    }, Cs = function(t) {
        return {
            $: 5,
            a: t
        };
    }, _s = function(t) {
        return {
            $: 3,
            a: t
        };
    }, Js = function(t) {
        return 0 > t ? -t : t;
    }, js = 43200, Bs = {
        $: 1
    }, Ms = function(t) {
        return {
            $: 0,
            a: t
        };
    }, zs = F3(function(t, e, r) {
        var n = Js(r - e) / 1e3 | 0, a = Tn(n / 60);
        return t && 2 > a ? function(t) {
            return 5 > t ? Ms(5) : 10 > t ? Ms(10) : 20 > t ? Ms(20) : 40 > t ? Bs : 60 > t ? $s(1) : _s(1);
        }(n) : a ? 2 > a || 45 > a ? _s(a) : 90 > a ? ks(1) : 0 > c(a, 1440) ? function(t) {
            var e = Tn(t / 60);
            return ks(e);
        }(a) : 0 > c(a, 2520) ? Cs(1) : 0 > c(a, js) ? function(t) {
            var e = Tn(t / 1440);
            return Cs(e);
        }(a) : 0 > c(a, 86400) ? function(t) {
            return {
                $: 6,
                a: Tn(t / js)
            };
        }(a) : function(t) {
            var e = t / js | 0;
            if (12 > e) return function(t) {
                return {
                    $: 7,
                    a: Tn(t / js)
                };
            }(t);
            var r = hr(e / 12), n = A2(cc, 12, e);
            var a;
            return 3 > n ? {
                $: 8,
                a: r
            } : 9 > n ? {
                $: 9,
                a: r
            } : (a = r + 1, {
                $: 10,
                a: a
            });
        }(a) : $s(1);
    }), Ls = F4(function(t, e, r, n) {
        var a = r, u = n, o = A3(zs, !0, a, u);
        return A3(e, t, 2 === A2(Un, u, a) ? 0 : 1, o);
    }), As = F2(function(t, e) {
        return A3(Xr, F2(function(e, r) {
            var n = r.a, a = r.b;
            return t(e) ? s(A2(Je, e, n), a) : s(n, A2(Je, e, a));
        }), s(d, d), e);
    }), Ps = F2(function(t, e) {
        return {
            $: 6,
            a: t,
            b: e
        };
    }), Ds = F2(function(t, e) {
        return {
            $: 7,
            a: t,
            b: e
        };
    }), Ns = F2(function(t, e) {
        return {
            $: 8,
            a: t,
            b: e
        };
    }), Ss = function(t) {
        return {
            $: 3,
            a: t
        };
    }, Is = F2(function(t, e) {
        return {
            $: 2,
            a: t,
            b: e
        };
    }), Rs = F2(function(t, e) {
        return {
            $: 1,
            a: t,
            b: e
        };
    }), Es = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 32 32"),
            Qo("none"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                di("evenodd"),
                So("M5.33333 9.33317C5.68696 9.33317 6.02609 9.19269 6.27614 8.94265C6.52619 8.6926 6.66667 8.35346 6.66667 7.99984C6.66667 7.64622 6.52619 7.30708 6.27614 7.05703C6.02609 6.80698 5.68696 6.6665 5.33333 6.6665C4.97971 6.6665 4.64057 6.80698 4.39052 7.05703C4.14048 7.30708 4 7.64622 4 7.99984C4 8.35346 4.14048 8.6926 4.39052 8.94265C4.64057 9.19269 4.97971 9.33317 5.33333 9.33317V9.33317ZM11.6667 7.33317C11.4015 7.33317 11.1471 7.43853 10.9596 7.62606C10.772 7.8136 10.6667 8.06795 10.6667 8.33317C10.6667 8.59839 10.772 8.85274 10.9596 9.04028C11.1471 9.22781 11.4015 9.33317 11.6667 9.33317H27C27.2652 9.33317 27.5196 9.22781 27.7071 9.04028C27.8946 8.85274 28 8.59839 28 8.33317C28 8.06795 27.8946 7.8136 27.7071 7.62606C27.5196 7.43853 27.2652 7.33317 27 7.33317H11.6667ZM11.6667 15.3332C11.4015 15.3332 11.1471 15.4385 10.9596 15.6261C10.772 15.8136 10.6667 16.068 10.6667 16.3332C10.6667 16.5984 10.772 16.8527 10.9596 17.0403C11.1471 17.2278 11.4015 17.3332 11.6667 17.3332H27C27.2652 17.3332 27.5196 17.2278 27.7071 17.0403C27.8946 16.8527 28 16.5984 28 16.3332C28 16.068 27.8946 15.8136 27.7071 15.6261C27.5196 15.4385 27.2652 15.3332 27 15.3332H11.6667ZM11.6667 23.3332C11.4015 23.3332 11.1471 23.4385 10.9596 23.6261C10.772 23.8136 10.6667 24.068 10.6667 24.3332C10.6667 24.5984 10.772 24.8527 10.9596 25.0403C11.1471 25.2278 11.4015 25.3332 11.6667 25.3332H27C27.2652 25.3332 27.5196 25.2278 27.7071 25.0403C27.8946 24.8527 28 24.5984 28 24.3332C28 24.068 27.8946 23.8136 27.7071 23.6261C27.5196 23.4385 27.2652 23.3332 27 23.3332H11.6667ZM6.66667 15.9998C6.66667 16.3535 6.52619 16.6926 6.27614 16.9426C6.02609 17.1927 5.68696 17.3332 5.33333 17.3332C4.97971 17.3332 4.64057 17.1927 4.39052 16.9426C4.14048 16.6926 4 16.3535 4 15.9998C4 15.6462 4.14048 15.3071 4.39052 15.057C4.64057 14.807 4.97971 14.6665 5.33333 14.6665C5.68696 14.6665 6.02609 14.807 6.27614 15.057C6.52619 15.3071 6.66667 15.6462 6.66667 15.9998V15.9998ZM5.33333 25.3332C5.68696 25.3332 6.02609 25.1927 6.27614 24.9426C6.52619 24.6926 6.66667 24.3535 6.66667 23.9998C6.66667 23.6462 6.52619 23.3071 6.27614 23.057C6.02609 22.807 5.68696 22.6665 5.33333 22.6665C4.97971 22.6665 4.64057 22.807 4.39052 23.057C4.14048 23.3071 4 23.6462 4 23.9998C4 24.3535 4.14048 24.6926 4.39052 24.9426C4.64057 25.1927 4.97971 25.3332 5.33333 25.3332V25.3332Z")
            ]), d)
        ]));
    }), Ts = Zo("max"), Hs = Zo("min"), Fs = function(t) {
        return A2(yi, "mouseleave", Ar(t));
    }, Vs = Ro("circle"), Zs = Zt("cx"), qs = Zt("cy"), Us = Ro("line"), Qs = Zt("r"), Os = Zt("stroke"), Gs = Zt("stroke-linecap"), Ws = Zt("stroke-linejoin"), Ys = Zt("stroke-miterlimit"), Ks = Zt("stroke-width"), Xs = Zt("x1"), tl = Zt("x2"), el = Zt("y1"), rl = Zt("y2"), nl = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 72 72"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Qo("#FCEA2B"),
                So("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), d),
            A2(Vs, x([
                Zs("36"),
                qs("36"),
                Qs("23"),
                Qo("inherit"),
                Os("inherit"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                So("M30,32.9252c0,1.6567-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6553,1.3447-3,3-3C28.6552,29.9252,30,31.27,30,32.9252"),
                Qo("#000"),
                Os("#000")
            ]), d),
            A2(Eo, x([
                So("M48,32.9252c0,1.6567-1.3447,3-3,3s-3-1.3433-3-3c0-1.6553,1.3447-3,3-3S48,31.27,48,32.9252"),
                Qo("#000"),
                Os("#000")
            ]), d),
            A2(Us, x([
                Xs("23"),
                tl("30"),
                el("24"),
                rl("28"),
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Us, x([
                Xs("49"),
                tl("42"),
                el("24"),
                rl("28"),
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ys("10"),
                Ks("2"),
                So("M29.5,43c1.2841-0.6376,3.9847-1.0308,6.8421-0.9981c2.6235,0.03,4.9897,0.4146,6.1579,0.9981")
            ]), d)
        ]));
    }), al = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 72 72"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Qo("inherit"),
                So("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), d),
            A2(Vs, x([
                Zs("36"),
                qs("36"),
                Qs("23"),
                Qo("none"),
                Os("inherit"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                So("m26 48c10-5 21-4.03 21-4.03"),
                Qo("none"),
                Os("#000"),
                Gs("round"),
                Ws("round"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                So("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Qo("#000"),
                Os("none")
            ]), d),
            A2(Eo, x([
                So("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Qo("#000"),
                Os("none")
            ]), d)
        ]));
    }), ul = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 72 72"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Vs, x([
                Zs("36"),
                qs("36"),
                Qo("inherit"),
                Qs("23")
            ]), d),
            A2(Eo, x([
                Qo("#FFFFFF"),
                So("M48.5859,42.6735c0,5.6296-4.1784,10.1046-12.5541,10.1046c-8.3738,0-12.6069-4.4888-12.6069-10.1047 C23.4249,42.6734,36.4503,45.7045,48.5859,42.6735z")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ys("10"),
                Ks("2"),
                So("M48.5859,42.6735c0,5.6296-4.1784,10.1046-12.5541,10.1046c-8.3738,0-12.6069-4.4888-12.6069-10.1047 C23.4249,42.6734,36.4503,45.7045,48.5859,42.6735z")
            ]), d),
            A2(Li, x([
                Qo("none"),
                Gs("round"),
                Ks("2")
            ]), x([
                A2(Vs, x([
                    Zs("36"),
                    qs("36"),
                    Qs("23"),
                    Ws("round"),
                    Os("inherit")
                ]), d),
                A2(Eo, x([
                    So("m31.6941 32.4036a4.7262 4.7262 0 0 0 -8.6382 0"),
                    Ys("10"),
                    Os("#000")
                ]), d),
                A2(Eo, x([
                    So("m48.9441 32.4036a4.7262 4.7262 0 0 0 -8.6382 0"),
                    Ys("10"),
                    Os("#000")
                ]), d)
            ]))
        ]));
    }), ol = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 72 72"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Qo("inherit"),
                So("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), d),
            A2(Vs, x([
                Zs("36"),
                qs("36"),
                Qs("23"),
                Qo("none"),
                Os("inherit"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Us, x([
                Xs("27"),
                tl("45"),
                el("43"),
                rl("43"),
                Qo("none"),
                Os("#000"),
                Gs("round"),
                Ws("round"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                So("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Qo("#000"),
                Os("none")
            ]), d),
            A2(Eo, x([
                So("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Qo("#000"),
                Os("none")
            ]), d)
        ]));
    }), il = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 72 72"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Qo("inherit"),
                So("M36,13c-12.6823,0-23,10.3177-23,23c0,12.6822,10.3177,23,23,23c12.6822,0,23-10.3178,23-23 C59,23.3177,48.6822,13,36,13z")
            ]), d),
            A2(Vs, x([
                Zs("36"),
                qs("36"),
                Qs("23"),
                Qo("none"),
                Os("inherit"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                So("m28 46c1.5805-2.5575 4.9043-4.1349 8.4211-4.0038 3.2288.1204 6.1411 1.6633 7.5789 4.0038"),
                Qo("none"),
                Os("#000"),
                Gs("round"),
                Ws("round"),
                Ys("10"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                So("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Qo("#000"),
                Os("none")
            ]), d),
            A2(Eo, x([
                So("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Qo("#000"),
                Os("none")
            ]), d)
        ]));
    }), cl = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 72 72"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Vs, x([
                Zs("36.0001"),
                qs("36"),
                Qs("22.9999"),
                Qo("inherit")
            ]), d),
            A2(Vs, x([
                Zs("36"),
                qs("36"),
                Qs("23"),
                Qo("none"),
                Os("inherit"),
                Gs("round"),
                Ws("round"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M45.8149,44.9293 c-2.8995,1.6362-6.2482,2.5699-9.8149,2.5699s-6.9153-0.9336-9.8149-2.5699")
            ]), d),
            A2(Eo, x([
                So("M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"),
                Qo("#000"),
                Os("none")
            ]), d),
            A2(Eo, x([
                So("M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"),
                Qo("#000"),
                Os("none")
            ]), d)
        ]));
    }), fl = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 72 72"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Qo("inherit"),
                So("M36,12c-13.2548,0-24,10.7452-24,24s10.7452,24,24,24s24-10.7452,24-24S49.2548,12,36,12L36,12z")
            ]), d),
            A2(Eo, x([
                Qo("#fff"),
                So("M41.5405,37.4966L55.2873,43.81c0,0,3.8107-4.3777,7.3934-0.753c1.8042,1.6892,1.8974,4.5211,0.2082,6.3253 c0,0,0,0.0001-0.0001,0.0001c-0.0219,0.0235-0.0441,0.0468-0.0666,0.07c-0.0338,0.0348,3.46,3.3212,0.3024,6.4791 c-1.6137,1.6749-4.2497,1.8118-6.0282,0.313c0,0-2.5219,3.7564-6.086-0.2145s0.8088-7.42,0.8088-7.42L41.5405,37.4966z")
            ]), d),
            A2(Eo, x([
                Qo("#fff"),
                So("M30.4596,37.4966L16.7127,43.81c0,0-3.8107-4.3777-7.3934-0.753 c-1.8042,1.6892-1.8974,4.5211-0.2082,6.3253c0,0,0,0.0001,0.0001,0.0001c0.0219,0.0235,0.0441,0.0468,0.0666,0.07 c0.0338,0.0348-3.46,3.3212-0.3024,6.4791c1.6137,1.6749,4.2498,1.8118,6.0283,0.313c0,0,2.5218,3.7566,6.0858-0.2148 s-0.8088-7.42-0.8088-7.42L30.4596,37.4966z")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("inherit"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M46.7165,56.3562 c-6.7467,3.5446-14.8098,3.5235-21.5379-0.0562")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("inherit"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M47.4511,55.9513 c-0.2421,0.1393-0.4869,0.2743-0.7346,0.4049")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("inherit"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M13.1224,38.3876 C13.0407,37.5944,12.9999,36.7974,13,36c0-12.7025,10.2975-23,23-23s23,10.2975,23,23c0,0.5043-0.0161,1.0046-0.0482,1.501")
            ]), d),
            A2(Us, x([
                Xs("23"),
                tl("30"),
                el("24.0001"),
                rl("28.0001"),
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ks("2")
            ]), d),
            A2(Us, x([
                Xs("49"),
                tl("42"),
                el("24.0001"),
                rl("28.0001"),
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ks("2")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M30,43 c2.1924-0.7812,4.5179-1.1204,6.8421-0.9981C38.9397,41.9366,41.0304,42.2755,43,43")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M22.5,33.0775 c1.3758,1.1372,3.1261,1.7206,4.9091,1.6364c1.503-0.0963,2.9361-0.6696,4.0909-1.6364")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M40.5,33.0775 c1.3758,1.1372,3.1261,1.7206,4.9091,1.6364c1.503-0.0963,2.9361-0.6696,4.0909-1.6364")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M30.4596,37.4966 L16.7127,43.81c0,0-3.8107-4.3777-7.3934-0.753c-1.8042,1.6892-1.8974,4.5211-0.2082,6.3253c0,0,0,0.0001,0.0001,0.0001 c0.0219,0.0235,0.0441,0.0468,0.0666,0.07c0.0338,0.0348-3.46,3.3212-0.3024,6.4791c1.6137,1.6749,4.2498,1.8118,6.0283,0.313 c0,0,2.5218,3.7566,6.0858-0.2148s-0.8088-7.42-0.8088-7.42L30.4596,37.4966z")
            ]), d),
            A2(Eo, x([
                Qo("none"),
                Os("#000000"),
                Gs("round"),
                Ws("round"),
                Ks("2"),
                So("M41.5405,37.4966 L55.2873,43.81c0,0,3.8107-4.3777,7.3934-0.753c1.8042,1.6892,1.8974,4.5211,0.2082,6.3253c0,0,0,0.0001-0.0001,0.0001 c-0.0219,0.0235-0.0441,0.0468-0.0666,0.07c-0.0338,0.0348,3.46,3.3212,0.3024,6.4791c-1.6137,1.6749-4.2497,1.8118-6.0282,0.313 c0,0-2.5219,3.7564-6.086-0.2145s0.8088-7.42,0.8088-7.42L41.5405,37.4966z")
            ]), d)
        ]));
    }), sl = function(t) {
        switch(t){
            case 0:
                return ul;
            case 1:
            case 2:
                return cl;
            case 3:
            case 4:
                return ol;
            case 5:
                return al;
            case 6:
            case 7:
                return il;
            case 8:
            case 9:
                return nl;
            default:
                return fl;
        }
    }, ll = F2(function(t, e) {
        switch(e){
            case 0:
                return t.dh.cH;
            case 1:
                return "1 " + t.dh.dm;
            case 10:
                return t.dh.cq;
            default:
                return Ve(e) + " " + t.dh.dn;
        }
    }), bl = Ft, dl = F4(function(t, e, r, n) {
        var a, o = r.c0, i = r.cG, c = A2(va, s(0, Te), A2(Qn, n.aB, e.dJ)), f = A2(va, c.a, c.b);
        return A2(ri, x([
            qo("flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40")
        ]), x([
            A2(Yo, x([
                qo("contents lg:flex lg:gap-x-4")
            ]), x([
                A2(si, x([
                    qo("flex gap-2 items-center p-4 gap-x-4 rounded-xl lg:flex-auto lg:p-6 lg:pr-0 outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                    ti(x([
                        s("max-lg:truncate lg:max-w-[376px]", !e.ca),
                        s("lg:truncate", e.ca)
                    ])),
                    ki(A2(Lf, n.aB, e.ad) ? Ss(n.aB) : (a = n.aB, {
                        $: 0,
                        a: a
                    })),
                    ji("button")
                ]), x([
                    A2(Vo, "hidden lg:block shrink-0 w-4 h-14 self-start transition-transform", x([
                        s("rotate-90", A2(Lf, n.aB, e.ad)),
                        s("opacity-30", 1 === n.k.$)
                    ])),
                    A2(Ci, x([
                        qo("max-lg:overflow-hidden max-lg:overflow-ellipsis lg:line-clamp-2 text-left"),
                        ti(x([
                            s("lg:line-clamp-none", A2(Lf, n.aB, e.ad))
                        ]))
                    ]), x([
                        ui(n.h)
                    ])),
                    A2(Ci, x([
                        qo("ml-auto inline-block px-2.5 py-0.5 bg-primary-300 shrink-0 rounded-full xs:px-3 lg:inline-block lg:text-xl lg:mr-6 lg:px-3.5 lg:py-1 lg:-my-1"),
                        ti(x([
                            s("lg:hidden", !e.ca)
                        ]))
                    ]), x([
                        ui(Ve(c.a))
                    ]))
                ])),
                e.ca ? ui("") : A2(Yo, x([
                    qo("hidden relative lg:flex gap-2 self-start items-center pr-6 h-[104px]")
                ]), b(A2(tn, function(t) {
                    var e;
                    return A2(si, x([
                        qo("relative group w-8 h-8 border-2 border-primary-300 rounded-full text-sm lg:text-base hover:border-transparent outline-none focus-visible:border-black ring-black"),
                        ji("button"),
                        ti(x([
                            s("focus-visible:ring-2", u(t, c.a))
                        ])),
                        ki(A2(Ps, n.aB, t)),
                        (e = A2(Ds, n.aB, s(c.a, Ee(t))), A2(yi, "mouseenter", Ar(e))),
                        Fs(A2(Ns, n.aB, s(c.a, Te)))
                    ]), x([
                        A2(Ci, x([
                            qo("group-hover:opacity-0 group-focus-visible:opacity-0")
                        ]), x([
                            ui(Ve(t))
                        ])),
                        A3(sl, t, "absolute -top-2.5 -left-2.5 w-12 h-12 fill-primary-300 stroke-primary-300 group-focus-visible:opacity-60 group-hover:opacity-60", x([
                            s("opacity-0", !u(t, c.a))
                        ]))
                    ]));
                }, A2(Ye, 0, 10)), x([
                    A2(Yo, x([
                        qo("max-lg:hidden left-4 -top-6 absolute -translate-x-1/2")
                    ]), x([
                        A2(Yo, x([
                            qo("px-4 py-2 text-white bg-black/80 rounded pointer-events-none transition after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:w-0 after:h-0 after:[border-left:8px_solid_transparent] after:[border-right:8px_solid_transparent] after:[border-top:8px_solid_rgba(0,0,0,.8)]"),
                            ti(x([
                                s("opacity-0", !u(c.a, f) || u(c.b, Te))
                            ])),
                            A2(bl, "transform", "translateX(" + Ve(40 * f) + "px)")
                        ]), x([
                            ui(A2(ll, t, f))
                        ]))
                    ]))
                ])))
            ])),
            A2(Yo, x([
                qo("fixed inset-0 z-40 flex flex-col bg-white lg:static lg:z-0 lg:rounded-b-xl"),
                ti(x([
                    s("hidden", !A2(Lf, n.aB, e.ad))
                ]))
            ]), x([
                A2(Yo, x([
                    qo("flex flex-col py-10 px-6 gap-6 overflow-y-auto lg:pt-4 lg:pl-14 lg:gap-14")
                ]), x([
                    A2(Yo, x([
                        qo("lg:hidden")
                    ]), x([
                        A2(Yo, x([
                            qo(Pc + " text-grey-400")
                        ]), x([
                            ui(t.c4)
                        ])),
                        A2(Yo, x([
                            qo("flex justify-between items-baseline")
                        ]), x([
                            A2(Lc, x([
                                qo("text-2xl font-serif font-bold break-word")
                            ]), x([
                                ui(n.h)
                            ])),
                            e.ca ? A2(Ci, x([
                                qo("inline-block px-2.5 py-0.5 shrink-0 bg-primary-300 rounded-full xs:px-3")
                            ]), x([
                                ui(Ve(c.a))
                            ])) : ui("")
                        ]))
                    ])),
                    function() {
                        var e = n.k;
                        if (e.$) return ui("");
                        var r = e.a;
                        return A2(Yo, d, x([
                            A2(Yo, x([
                                qo(Pc + " text-grey-400 lg:mb-2")
                            ]), x([
                                ui(t.c3)
                            ])),
                            A2(ni, x([
                                qo("max-w-prose whitespace-pre-line break-words")
                            ]), x([
                                ui(r)
                            ]))
                        ]));
                    }(),
                    1 === n.k.$ ? A2(Ci, x([
                        qo("max-w-prose text-grey-400")
                    ]), x([
                        ui(t.bL)
                    ])) : ui("")
                ])),
                e.ca ? A2(Yo, x([
                    qo("lg:hidden relative mt-auto flex flex-col p-6")
                ]), x([
                    A2(si, x([
                        qo("w-14 h-14 !p-0 flex justify-center items-center" + A2(Fi, 0, 0)),
                        ki(Ss(n.aB)),
                        ji("button")
                    ]), x([
                        A2(af, "w-6 h-6 fill-current", d)
                    ]))
                ])) : A2(Yo, x([
                    qo("lg:hidden relative mt-auto flex flex-col justify-between p-6 bg-primary-300 after:absolute after:block after:bottom-full z-10 after:inset-x-0 after:h-3 after:bg-gradient-to-t after:from-black/5 after:to-transparent")
                ]), x([
                    A2(Yo, x([
                        qo("flex justify-between items-center mb-4 px-1")
                    ]), x([
                        A3(sl, A2(va, c.a, c.b), "w-10 h-10 -ml-2 -my-2 fill-primary-300 stroke-black", d),
                        A2(ni, d, x([
                            ui(A2(ll, t, c.a))
                        ]))
                    ])),
                    A2(gc, x([
                        qo("range"),
                        ji("range"),
                        Hs("0"),
                        Ts("10"),
                        tf(Ve(c.a)),
                        Ec(A2(Ou, A2(Ou, Ps(n.aB), va(0)), Zr))
                    ]), d),
                    A2(Yo, x([
                        qo("flex w-full justify-between mb-4 px-3 text-sm text-primary-600")
                    ]), x([
                        A2(Ci, x([
                            ti(x([
                                s("text-black", !c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 0))
                        ]), x([
                            ui("0")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 1 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 1))
                        ]), x([
                            ui("1")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 2 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 2))
                        ]), x([
                            ui("2")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 3 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 3))
                        ]), x([
                            ui("3")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 4 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 4))
                        ]), x([
                            ui("4")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 5 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 5))
                        ]), x([
                            ui("5")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 6 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 6))
                        ]), x([
                            ui("6")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 7 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 7))
                        ]), x([
                            ui("7")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 8 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 8))
                        ]), x([
                            ui("8")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 9 === c.a)
                            ])),
                            qo("cursor-pointer"),
                            ki(A2(Ps, n.aB, 9))
                        ]), x([
                            ui("9")
                        ])),
                        A2(Ci, x([
                            ti(x([
                                s("text-black", 10 === c.a)
                            ])),
                            qo("cursor-pointer -mr-2 -translate-x-1.5"),
                            ki(A2(Ps, n.aB, 10))
                        ]), x([
                            ui("10")
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("flex justify-between")
                    ]), x([
                        A2(si, x([
                            qo("w-14 h-14 !p-0 flex justify-center items-center" + A2(Fi, 0, 0)),
                            ki(A2(Rs, o, n.aB)),
                            ji("button")
                        ]), x([
                            A2(af, "w-6 h-6 fill-current", d)
                        ])),
                        A2(si, x([
                            qo("w-14 h-14 !p-0 flex justify-center items-center" + A2(Fi, 0, 0)),
                            ki(Ss(n.aB)),
                            ji("button")
                        ]), x([
                            A2(Es, "w-8 h-8 fill-current stroke-current", d)
                        ])),
                        A2(si, x([
                            qo("w-14 h-14 !p-0 flex justify-center items-center" + A2(Fi, 2, 0)),
                            ki(A2(Is, i, n.aB)),
                            ji("button")
                        ]), x([
                            A2(af, "w-6 h-6 fill-current -scale-x-100", d)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), pl = function(t) {
        var e = t.a, r = 277803737 * (e ^ e >>> 4 + (e >>> 28));
        return (r >>> 22 ^ r) >>> 0;
    }, gl = F2(function(t, e) {
        return function(r) {
            var n = 0 > c(t, e) ? s(t, e) : s(e, t), a = n.a, u = n.b - a + 1;
            if (u - 1 & u) {
                var o = (-u >>> 0) % u >>> 0;
                return function(t) {
                    for(;;){
                        var e = pl(t), r = Nn(t);
                        if (c(e, o) >= 0) return s(e % u + a, r);
                        t = r;
                    }
                }(r);
            }
            return s(((u - 1 & pl(r)) >>> 0) + a, Nn(r));
        };
    }), xl = A2(gl, -2147483648, 2147483647), ml = F4(function(t, e, r, n) {
        var a = e, u = r, o = n;
        return function(e) {
            var r = a(e), n = r.a, i = u(r.b), c = i.a, f = o(i.b), l = f.b;
            return s(A3(t, n, c, f.a), l);
        };
    }), hl = F2(function(t, e) {
        return t(e);
    }), wl = function(t) {
        var e = F3(function(t, e, r) {
            return Nn(A2(Dn, t, (1 | e ^ r) >>> 0));
        }), r = A2(gl, 0, 4294967295);
        return A2(hl, A4(ml, e, r, r, r), t);
    }, vl = F2(function(t, e) {
        var r = e;
        return function(e) {
            var n = r(e), a = n.b;
            return s(t(n.a), a);
        };
    }), yl = F3(function(t, e, r) {
        for(;;){
            if (!r.b) return Te;
            var n = r.b;
            if (e(r.a)) return Ee(t);
            t += 1, r = n;
        }
    })(0), kl = F3(function(t, e, r) {
        t: for(;;){
            if (t > 0) {
                if (e.b) {
                    var n = e.a;
                    t -= 1, e = e.b, r = A2(Je, n, r);
                    continue t;
                }
                return r;
            }
            return r;
        }
    }), $l = F2(function(t, e) {
        return nr(A3(kl, t, e, d));
    }), Cl = F3(function(t, e, r) {
        if (e > 0) {
            var n = s(e, r);
            t: for(;;){
                e: for(;;){
                    if (!n.b.b) return r;
                    if (!n.b.b.b) {
                        if (1 === n.a) break t;
                        break e;
                    }
                    switch(n.a){
                        case 1:
                            break t;
                        case 2:
                            var a = n.b;
                            return x([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (n.b.b.b.b) {
                                var u = n.b, o = u.b;
                                return x([
                                    u.a,
                                    o.a,
                                    o.b.a
                                ]);
                            }
                            break e;
                        default:
                            if (n.b.b.b.b && n.b.b.b.b.b) {
                                var i = n.b, c = i.b, f = c.b, l = f.b, b = l.b;
                                return A2(Je, i.a, A2(Je, c.a, A2(Je, f.a, A2(Je, l.a, t > 1e3 ? A2($l, e - 4, b) : A3(Cl, t + 1, e - 4, b)))));
                            }
                            break e;
                    }
                }
                return r;
            }
            return x([
                n.b.a
            ]);
        }
        return d;
    }), _l = F2(function(t, e) {
        return A3(Cl, 0, t, e);
    }), Jl = F2(function(t, e) {
        return s(A2(_l, t, e), A2(ws, t, e));
    }), jl = F2(function(t, e) {
        return A2(Wa, function(t) {
            return A2(Jl, t, e);
        }, A2(yl, t, e));
    }), Bl = F2(function(t, e) {
        return A2(Yo, x([
            qo(t.aV ? "space-y-2" : 1 > Oe(e) ? "hidden lg:block space-y-2" : "space-y-2")
        ]), x([
            A2(Sf, x([
                ti(x([
                    s(Pc + " mb-2", !0),
                    s("xs:mb-6 text-primary-600", !t.aV),
                    s("text-primary-600 lg:text-grey-400", 1 === t.aV)
                ]))
            ]), A2(Je, A2(Ci, d, x([
                ui(t.cm)
            ])), t.az ? d : x([
                A2(Ci, x([
                    qo("inline-block ml-2 px-1.5 text-primary-600 bg-primary-200 rounded-full")
                ]), x([
                    ui(Ve(Oe(e)))
                ]))
            ]))),
            A2(oi, x([
                qo("space-y-3"),
                ti(x([
                    s("md:gap-x-20 md:grid md:grid-cols-2", 1 === t.aV)
                ]))
            ]), A2(tn, function(e) {
                var r = e.a, n = e.b;
                return t.aV ? A2(ri, x([
                    qo("flex items-center gap-4")
                ]), x([
                    A2(Yo, x([
                        qo("flex shrink-0 text-base uppercase text-primary-600 w-8 h-8 rounded-full justify-center items-center bg-primary-200 selection:bg-white")
                    ]), x([
                        ui(1 === n.$ ? A3(Er, 0, 1, r) : n.a)
                    ])),
                    A2(Ci, x([
                        qo("capitalize selection:bg-white")
                    ]), x([
                        ui(r)
                    ]))
                ])) : A2(ri, x([
                    qo("flex items-center gap-3")
                ]), x([
                    A2(Yo, x([
                        qo("flex shrink-0 text-base uppercase text-primary-600 w-8 h-8 rounded-full justify-center items-center bg-primary-200")
                    ]), x([
                        ui(A3(Er, 0, 1, r))
                    ])),
                    A2(Yo, x([
                        qo("selection:bg-white")
                    ]), x([
                        A2(Ci, x([
                            qo("capitalize")
                        ]), x([
                            ui(r)
                        ])),
                        function() {
                            if (1 === n.$) return ui("");
                            var t = n.a;
                            return A2(Ci, x([
                                qo("shrink-0 text-sm text-primary-600 sm:text-base")
                            ]), x([
                                ui(" \u2219 " + t)
                            ]));
                        }()
                    ]))
                ]));
            }, e))
        ]));
    }), Ml = F5(function(t, e, r, n, a) {
        var o, i = Oe(A2(Po, A2(Gi, function(t) {
            return t.ck;
        }, mr(!1)), A2(bf, function(t) {
            return t.h;
        }, n.c6))), c = If(A2(Nf, A3(Ou, mr, po, a.dI), A2(tn, function(t) {
            return t.bn;
        }, a.cN))), f = A2(As, function(t) {
            return !t.ck;
        }, A2(bf, function(t) {
            return t.h;
        }, n.c6)), l = f.b, b = A2(hl, (o = f.a, A2(vl, function(t) {
            return A2(tn, $r, A2(qf, Do, A3(Qe, F2(function(t, e) {
                var r = e.a, n = A2(hl, xl, e.b), a = n.b;
                return s(A2(Je, s(t, n.a), r), a);
            }), s(d, t), o).a));
        }, wl)), t), p = b.a;
        return A2(zc, x([
            qo("shadow-xl shadow-primary-500/10"),
            Fc(ms)
        ]), x([
            A2(Yo, x([
                qo("px-4 py-10 bg-primary-300 lg:rounded-t-xl xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), x([
                A2(ni, x([
                    qo("mb-10 font-serif font-bold italic selection:bg-white max-w-xl")
                ]), x([
                    ui(r.dh.S)
                ])),
                A2(Yo, x([
                    qo("relative flex justify-between items-baseline mb-2 xs:mb-3")
                ]), x([
                    A2(Sf, x([
                        qo(Pc + " text-primary-600")
                    ]), x([
                        A2(Ci, x([
                            qo("selection:bg-white")
                        ]), x([
                            ui(r.c6.h)
                        ])),
                        A2(Ci, x([
                            qo("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2")
                        ]), x([
                            ui(Ve(i))
                        ]))
                    ])),
                    A2(Lc, x([
                        qo("text-primary-600 selection:bg-white " + Pc),
                        ti(x([
                            s("lg:absolute lg:right-[456px] lg:translate-x-full lg:bottom-0", !a.ca)
                        ]))
                    ]), x([
                        ui(r.dh.dP)
                    ]))
                ])),
                A2(oi, x([
                    qo("flex flex-col gap-2 md:gap-4")
                ]), A2(tn, function(t) {
                    var e = function(t) {
                        t: for(;;){
                            if (t.b) {
                                if (t.b.b) {
                                    t = t.b;
                                    continue t;
                                }
                                return Ee(t.a);
                            }
                            return Te;
                        }
                    }(A2(va, d, A2(Wa, $r, A2(jl, mr(t.aB), A2(tn, function(t) {
                        return t.aB;
                    }, p))))), n = A2(ys, 1, A2(va, d, A2(Wa, Do, A2(jl, mr(t.aB), A2(tn, function(t) {
                        return t.aB;
                    }, p)))));
                    return A4(dl, r, a, {
                        cG: n,
                        c0: e
                    }, t);
                }, p)),
                Oe(l) > 0 ? A2(li, x([
                    qo("group mt-4 lg:mt-8")
                ]), x([
                    A2(_i, x([
                        qo("flex gap-1 items-center text-primary-600 cursor-pointer mb-2 [&::-webkit-details-marker]:hidden xs:mb-3 lg:gap-2 " + Pc + " outline-none focus-visible:outline-4 focus-visible:outline-primary-600 focus-visible:rounded-full")
                    ]), x([
                        A2(Vo, "w-3 stroke-1 stroke-primary-600 fill-primary-600 transition-transform group-open:rotate-90 md:-mr-0.5", d),
                        A2(Ci, x([
                            qo("selection:bg-white")
                        ]), x([
                            ui(r.c6.bR)
                        ])),
                        A2(Df, gs, "ml-auto order-1 md:order-none md:-ml-1"),
                        A2(Ci, x([
                            qo("inline-block px-1.5 bg-primary-200 rounded-full selection:bg-white")
                        ]), x([
                            ui(Ve(Oe(l)))
                        ]))
                    ])),
                    A2(oi, x([
                        qo("flex flex-col mt-2 gap-2 md:gap-4")
                    ]), A2(tn, A3(Af, r, a, ls({
                        W: bs,
                        ac: ps
                    })), l))
                ])) : ui(""),
                a.ca ? A2(Yo, x([
                    qo("flex flex-wrap mt-16 pr-2 h-14 lg:h-16 justify-center items-center gap-3")
                ]), x([
                    A2(Yo, x([
                        qo("p-1.5 bg-primary-200 rounded-full")
                    ]), x([
                        A2(Ji, "w-4 h-4 stroke-primary-600", d)
                    ])),
                    A2(Sf, x([
                        qo("text-xl font-serif font-bold selection:bg-white")
                    ]), x([
                        ui(r.dh.dj)
                    ]))
                ])) : A2(Yo, x([
                    qo("flex flex-col mt-10 items-end gap-4 xs:flex-row md:gap-8")
                ]), x([
                    A2(Yo, x([
                        qo("relative flex flex-col w-full gap-2 lg:gap-3")
                    ]), x([
                        A2(Ac, x([
                            Mc("author-input"),
                            qo(Pc + " text-primary-600 selection:bg-white")
                        ]), x([
                            ui(r.dh.b$)
                        ])),
                        A2(gc, x([
                            bi("author-input"),
                            qo("w-full px-4 py-3.5 bg-primary-100 placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                            Vc(r.dh.b0),
                            Ec(fs),
                            tf(a.dI),
                            Vf(".*\\S.*"),
                            Dc(1),
                            Rf(50),
                            qc(!0)
                        ]), d),
                        c ? A2(ni, x([
                            qo("text-red-600 xs:absolute xs:top-full xs:mt-1 xs:text-base")
                        ]), x([
                            ui(r.dh.b2)
                        ])) : ui("")
                    ])),
                    A2(si, x([
                        qo("shrink-0 self-center xs:self-end" + A2(Fi, 2, 2)),
                        Bc(!Rr(io(a.dI)) || c)
                    ]), x([
                        ui(r.dh.dx)
                    ]))
                ])),
                Oe(a.cN) > 0 ? A2(Yo, x([
                    qo("flex flex-col mt-12 lg:flex-row gap-20 w-full")
                ]), x([
                    A2(Bl, {
                        az: !1,
                        cm: r.dM,
                        aV: 0
                    }, A2(tn, function(t) {
                        return s(t.bn, Ee(A4(Ls, {
                            dN: !0
                        }, hs, t.P, e)));
                    }, nr(A2(bf, function(t) {
                        return t.bn;
                    }, A2(qf, A2(Gi, function(t) {
                        return t.P;
                    }, nc), a.cN)))))
                ])) : ui("")
            ])),
            A2(Yo, x([
                qo("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), x([
                A2(Yo, x([
                    qo("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("row-start-5 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("col-start-1 row-start-1 row-span-2 w-0.5 h-5/6 justify-self-center bg-primary-300")
                ]), d),
                A2(Yo, x([
                    qo("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), x([
                    A2(cf, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", d)
                ])),
                A2(Yo, x([
                    qo("row-start-2 col-start-2 font-semibold")
                ]), x([
                    ui(r.$7.h)
                ])),
                A2(ni, x([
                    qo("row-start-3 col-start-2 mt-1 mb-4 text-primary-900 max-w-md")
                ]), x([
                    ui(r.$7.bV)
                ])),
                function() {
                    var t = n.cQ;
                    if (t.$) return A2(si, x([
                        qo(A2(Fi, 2, 2) + " row-start-4 col-start-1 col-span-2 justify-self-center mt-2 sm:mt-4"),
                        ki(ds),
                        Bc(2 > Oe(A2(bf, function(t) {
                            return t.bn;
                        }, a.cN))),
                        ji("button")
                    ]), x([
                        ui(r.$7.aj)
                    ]));
                    var e = t.a;
                    return A2(Yo, x([
                        qo("row-start-4 col-start-2 mt-2 flex flex-col gap-1.5")
                    ]), x([
                        A2(Ac, x([
                            Mc("code-test"),
                            qo(Pc + " flex gap-1 items-center text-primary-600 selection:bg-white sm:leading-[18px]")
                        ]), x([
                            ui(r.cV),
                            A2(si, x([
                                ji("button"),
                                Ff(xs)
                            ]), x([
                                A2(Pf, "w-4 h-4 fill-primary-600", d)
                            ]))
                        ])),
                        A2(Yo, x([
                            qo("flex flex-wrap gap-4 justify-center items-center")
                        ]), x([
                            A2(gc, x([
                                bi("code-test"),
                                qo("grow w-full xs:w-auto xs:min-w-[290px] px-4 py-3.5 bg-white placeholder:text-primary-600 rounded-md ring-inset outline-none focus:bg-white focus:placeholder:text-grey-300 filled-invalid:ring filled-invalid:ring-red-400"),
                                Vc(r.aL),
                                Ec(ss),
                                tf(a.cP),
                                Dc(1)
                            ]), d),
                            A2(si, x([
                                qo(A2(Fi, 2, 2) + " justify-self-center"),
                                ki(ds),
                                Bc(2 > Oe(A2(bf, function(t) {
                                    return t.bn;
                                }, a.cN)) || !u(e, a.aK)),
                                ji("button")
                            ]), x([
                                ui(r.$7.aj)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    }), zl = F3(function(t, e, r) {
        return A2(Yo, d, x([
            Ti(t.J),
            A2(Yo, x([
                qo("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), x([
                A2(Ii, t.I, Ee({
                    T: t.J.bw,
                    U: t.J.by,
                    V: t.J.bx,
                    D: e.aB
                })),
                A2(mc, _a, A6(of, t.J, t.dD, e, r.ah, Ui, Zi(e.aB))),
                A2(Yo, x([
                    qo("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("1")
                    ])),
                    A2(Yo, x([
                        qo("flex items-center gap-2 mr-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-grey-400")
                        ]), x([
                            ui(t.J.c8.h)
                        ])),
                        A2(Ji, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", d)
                    ])),
                    A2(Yo, x([
                        qo("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), x([
                        ui(t.J.cZ + " " + pc(s(t.dD, e.P)))
                    ])),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("2")
                    ])),
                    A2(Yo, x([
                        qo("row-start-2 flex items-center gap-2 mr-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-grey-400")
                        ]), x([
                            ui(t.J.c6.h)
                        ])),
                        A2(Ji, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", d)
                    ])),
                    function() {
                        var r = e.aR;
                        if (r.$) return ui("");
                        var n = r.a;
                        return A2(Yo, x([
                            qo("row-start-2 col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                        ]), x([
                            ui(t.J.cX + " " + pc(s(t.dD, n)))
                        ]));
                    }(),
                    A2(Yo, x([
                        qo("col-start-1 row-start-3 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-3 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("3")
                    ])),
                    A2(Yo, x([
                        qo("col-start-2 mr-2 flex items-center gap-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-black")
                        ]), x([
                            ui(t.J.dh.h)
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("col-span-2 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), x([
                        ui(t.J.cY)
                    ]))
                ])),
                A2(mc, _c, A5(Ml, t.af, t.aa, t.J, e, r))
            ])),
            A3(dc, t.J, s(t.dD, e.bT), e.aB),
            A2(Yo, x([
                qo("mt-20 lg:mt-40")
            ]), x([
                A3(Ko, 0, 1, A3(ii, t.I, t.J.bZ, 1))
            ])),
            A4(rf, t.I, t.J, {
                bn: e.bn,
                k: e.k,
                aB: e.aB,
                h: e.h
            }, r.cs)
        ]));
    }), Ll = function(t) {
        return {
            $: 6,
            a: t
        };
    }, Al = function(t) {
        return {
            $: 1,
            a: t
        };
    }, Pl = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Dl = {
        $: 2
    }, Nl = F2(function(t, e) {
        t: for(;;){
            if (e.b) {
                var r = e.b;
                if (t(e.a)) {
                    e = r;
                    continue t;
                }
                return e;
            }
            return d;
        }
    }), Sl = function(t) {
        return F2(function(e, r) {
            t: for(;;){
                if (r.b) {
                    var n = r.a, a = r.b;
                    if (t(n)) {
                        e = A2(Je, n, e), r = a;
                        continue t;
                    }
                    return nr(e);
                }
                return nr(e);
            }
        })(d);
    }, Il = F2(function(t, e) {
        return s(A2(Sl, t, e), A2(Nl, t, e));
    }), Rl = function(t) {
        return Il(A2(Ou, ao, t));
    }, El = F2(function(t, e) {
        t: for(;;){
            if (e.b) {
                var r = e.b, n = t(e.a);
                if (n.$) {
                    e = r;
                    continue t;
                }
                return Ee(n.a);
            }
            return Te;
        }
    }), Tl = F2(function(t, e) {
        return A2(F2(function(e, r) {
            for(;;){
                if (!e.b) return nr(r);
                var n = e.a, a = e.b, u = A2(As, t(n), a);
                e = u.b, r = A2(Je, s(n, u.a), r);
            }
        }), e, d);
    }), Hl = F2(function(t, e) {
        return A2(Tl, F2(function(e, r) {
            return u(t(e), t(r));
        }), e);
    }), Fl = F2(function(t, e) {
        return A2(To, x([
            Ao(t),
            No(e),
            Ho("0 0 16 16"),
            Fo("http://www.w3.org/2000/svg")
        ]), x([
            A2(Eo, x([
                Io("evenodd"),
                So("M7.655 14.916L8 14.25l.345.666a.752.752 0 01-.69 0zm0 0L8 14.25l.345.666.002-.001.006-.003.018-.01a7.643 7.643 0 00.31-.17 22.08 22.08 0 003.433-2.414C13.956 10.731 16 8.35 16 5.5 16 2.836 13.914 1 11.75 1 10.203 1 8.847 1.802 8 3.02 7.153 1.802 5.797 1 4.25 1 2.086 1 0 2.836 0 5.5c0 2.85 2.045 5.231 3.885 6.818a22.075 22.075 0 003.744 2.584l.018.01.006.003h.002z")
            ]), d)
        ]));
    }), Vl = Rt("iframe"), Zl = F3(function(t, e, r) {
        return 1 === r ? t : e;
    }), ql = F2(function(t, e) {
        return 1 > t ? e : A3(Er, 0, -t, e);
    }), Ul = N, Ql = B, Ol = F2(function(t, e) {
        return b(t && A2(ff, function(t) {
            return "0" !== t && "." !== t;
        }, A3(Ql, Je, d, e)) ? "-" : "", e);
    }), Gl = I, Wl = function(t) {
        var e = t.a, r = t.b;
        if ("9" === e) {
            var n = ar(r);
            return 1 === n.$ ? "01" : A2(Yi, "0", Wl(n.a));
        }
        var a, u = Xe(e);
        return u >= 48 && 57 > u ? A2(Yi, 0 > (a = u + 1) || a > 1114111 ? "\uFFFD" : a > 65535 ? String.fromCharCode(Math.floor((a -= 65536) / 1024) + 55296, a % 1024 + 56320) : String.fromCharCode(a), r) : "0";
    }, Yl = J, Kl = F3(function(t, e, r) {
        return b(r, A2(tc, t - Rr(r), Ki(e)));
    }), Xl = function(t) {
        for(var e = t.length, r = Array(e), n = 0; e > n;){
            var a = t.charCodeAt(n);
            55296 > a || a > 56319 ? (r[e - n] = t[n], n++) : (r[e - n] = t[n + 1], r[e - ++n] = t[n - 1], n++);
        }
        return r.join("");
    }, tb = function(t) {
        var e = A2(qe, ".", t);
        return e.b ? s(e.a, e.b.b ? e.b.a : "0") : s("0", "0");
    }, eb = F2(function(t, e) {
        var r = e.b;
        return s(t(e.a), r);
    }), rb = F3(function(t, e, r) {
        if ((n = r) === 1 / 0 || n === -1 / 0 || Yl(r)) return Gl(r);
        var n, a = 0 > r, u = tb(function(t) {
            var e = A2(qe, "e", Gl(Js(t)));
            if (e.b) {
                if (e.b.b) {
                    var r = e.a, n = e.b.a, a = A2(va, 0, Zr(A2(Gr, "+", n) ? A2(Tr, 1, n) : n)), u = tb(r), o = b(u.a, u.b), i = 0 > a ? A2(va, "0", A2(Wa, function(t) {
                        return t.a + "." + t.b;
                    }, A2(Wa, eb(Ki), ar(b(A2(tc, Js(a), "0"), o))))) : A3(Kl, a + 1, "0", o);
                    return b(0 > t ? "-" : "", i);
                }
                return b(0 > t ? "-" : "", r = e.a);
            }
            return "";
        }(Js(r))), o = u.a, i = u.b, f = Rr(o) + e, s = b(A2(tc, 1 - f, "0"), A3(Kl, f, "0", b(o, i))), l = Rr(s), d = A2(vr, 1, f), p = A2(t, a, A3(Er, d, l, s)), g = A3(Er, 0, d, s), x = p ? Xl(A2(va, "1", A2(Wa, Wl, ar(Xl(g))))) : g, m = Rr(x), h = "0" === x ? x : e > 0 ? 0 > c(e, Rr(i)) ? A3(Er, 0, m - e, x) + "." + A3(Er, m - e, m, x) : b(o + ".", A3(Kl, e, "0", i)) : b(x, A2(tc, Js(e), "0"));
        return A2(Ol, a, h);
    })(F2(function(t, e) {
        var r, n = ar(e);
        return 1 !== n.$ && ("5" === n.a.a ? "" !== n.a.b || !t : (r = Xe(n.a.a)) > 53 && t || r >= 53 && !t);
    })), nb = F3(function(t, e, r) {
        return t(r) ? e(r) : r;
    }), ab = F4(function(t, e, r, n) {
        var a = n.a, u = n.b, o = n.c, i = A3(nb, Ul(".0"), A2(Zc, ".0", ""), A3(nb, Ul("0"), ql(1), A2(rb, 2, o))), c = A2(tn, function(t) {
            return s(t.bn, Ee(Ve(t.c$)));
        }, nr(A2(qf, function(t) {
            return t.c$;
        }, A2(Po, A2(Gi, function(t) {
            return t.c2;
        }, mr(a)), e.aW)))), f = A2(va, Te, A2(Qn, a, to(A2(tn, function(t) {
            return s(t.aB, t.k);
        }, A2(bf, function(t) {
            return t.h;
        }, e.c6)))));
        return A2(ri, x([
            qo("relative flex flex-col bg-white rounded-xl shadow-md shadow-primary-500/40 lg:overflow-hidden")
        ]), x([
            A2(si, x([
                qo("flex items-center gap-x-4 p-4 rounded-xl lg:p-6 outline-none focus-visible:ring-inset focus-visible:ring-4 focus-visible:ring-primary-600"),
                ki(A2(Lf, a, r.ad) ? Al(a) : Pl(a)),
                ji("button")
            ]), x([
                A2(Vo, "hidden lg:block w-4 transition-transform", x([
                    s("rotate-90", A2(Lf, a, r.ad)),
                    s("fill-grey-300", Tf(f))
                ])),
                A2(Ci, x([
                    qo("line-clamp-2 text-left")
                ]), x([
                    ui(u)
                ])),
                A2(Ci, x([
                    qo("inline-block ml-auto px-2.5 py-0.5 shrink-0 font-normal bg-primary-300 rounded-full xs:px-3 lg:px-3.5 lg:py-1.5 lg:-my-1.5 lg:min-w-[2.5rem]")
                ]), x([
                    ui(i)
                ]))
            ])),
            A2(Yo, x([
                qo("fixed z-40 inset-0 bg-primary-300 overflow-y-auto lg:static lg:z-0 lg:bg-white lg:pt-2"),
                ti(x([
                    s("hidden", !A2(Lf, a, r.ad))
                ]))
            ]), x([
                A2(Yo, x([
                    qo("relative flex flex-col py-10 px-6 bg-white  lg:pt-0 lg:py-4 lg:pl-14 lg:pb-0")
                ]), x([
                    A2(Yo, x([
                        qo("mb-6 lg:hidden")
                    ]), x([
                        A2(Yo, x([
                            qo(Pc + " text-grey-400")
                        ]), x([
                            ui(t.c4)
                        ])),
                        A2(Yo, x([
                            qo("flex justify-between items-baseline gap-4")
                        ]), x([
                            A2(Lc, x([
                                qo("text-2xl font-serif font-bold break-word")
                            ]), x([
                                ui(u)
                            ])),
                            A2(Ci, x([
                                qo("inline-block px-2.5 py-0.5 shrink-0 bg-primary-300 rounded-full xs:px-3")
                            ]), x([
                                ui(i)
                            ]))
                        ]))
                    ])),
                    function() {
                        if (f.$) return A2(ni, x([
                            qo("lg:mb-10 whitespace-pre-line break-words text-grey-400")
                        ]), x([
                            ui(t.bL)
                        ]));
                        var e = f.a;
                        return A2(Yo, x([
                            qo("lg:mb-10 lg:space-y-1")
                        ]), x([
                            A2(Yo, x([
                                qo(Pc + " text-grey-400")
                            ]), x([
                                ui(t.c3)
                            ])),
                            A2(ni, x([
                                qo("whitespace-pre-line break-words max-w-prose")
                            ]), x([
                                ui(e)
                            ]))
                        ]));
                    }(),
                    Go("absolute w-full max-h-3 left-0 top-full z-10 fill-white lg:hidden")
                ])),
                A2(Yo, x([
                    qo("flex flex-col py-14 px-6 lg:px-14 lg:pt-0 lg:pb-12")
                ]), x([
                    A2(Bl, {
                        az: !0,
                        cm: t.ch,
                        aV: 1
                    }, c)
                ])),
                A2(Yo, x([
                    qo("fixed z-10 bottom-0 inset-x-0 flex p-6 justify-between lg:hidden")
                ]), x([
                    A2(si, x([
                        qo("p-4 rounded-full bg-white shadow-md outline-none focus-visible:outline-4 focus-visible:outline-yellow focus-visible:outline-offset-4"),
                        ki(Al(a)),
                        ji("button")
                    ]), x([
                        A2(af, "w-6 h-6 fill-current", d)
                    ]))
                ]))
            ]))
        ]));
    }), ub = F4(function(t, e, r, n) {
        var a = A2(tn, function(t) {
            var n = t.a, a = t.b;
            return {
                a: n,
                b: A2(va, e.bD, A2(El, function(t) {
                    return u(t.aB, n) ? Ee(t.h) : Te;
                }, r.c6)),
                c: a
            };
        }, A2(qf, Do, A2(tn, function(t) {
            var e = t.a, r = t.b, n = Oe(A2(Je, e, r));
            return s(e.c2, A3(Qe, Re, 0, A2(tn, function(t) {
                return t.c$;
            }, A2(Je, e, r))) / n);
        }, A2(Hl, function(t) {
            return t.c2;
        }, r.aW)))), o = A2(va, 0, A2(Wa, function(t) {
            return t.c;
        }, vs(a))), i = A2(Rl, function(t) {
            return c(t.c, o) > 0;
        }, a), f = i.a, l = i.b, b = A2(As, A2(Ou, ao, function(t) {
            return t.ck;
        }), A2(bf, function(t) {
            return t.h;
        }, r.c6)).b;
        return A2(Yo, x([
            qo("overflow-hidden lg:rounded-xl shadow-xl shadow-primary-500/10")
        ]), x([
            A2(Yo, x([
                qo("px-4 py-10 bg-primary-300 xs:p-6 sm:p-8 md:p-12 lg:p-16")
            ]), x([
                A2(ni, x([
                    qo("mb-10 font-serif font-bold italic selection:bg-white")
                ]), x([
                    ui(e.$7.S)
                ])),
                A2(Lc, x([
                    qo("flex mb-2 text-primary-600 xs:mb-3 " + Pc)
                ]), x([
                    A2(Ci, x([
                        qo("selection:bg-white")
                    ]), x([
                        ui(A3(Zl, e.$7.bo, e.$7.bp, Oe(f)))
                    ])),
                    A2(Ci, x([
                        qo("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2"),
                        ti(x([
                            s("hidden", 1 === Oe(f))
                        ]))
                    ]), x([
                        ui(Ve(Oe(f)))
                    ])),
                    A2(Ci, x([
                        qo("inline-block ml-auto selection:bg-white")
                    ]), x([
                        ui(e.$7.b9)
                    ]))
                ])),
                A2(oi, x([
                    qo("flex flex-col gap-2 md:gap-4")
                ]), A2(tn, A3(ab, e, r, n), f)),
                Oe(l) > 0 ? A2(Lc, x([
                    qo("flex mb-2 text-primary-600 mt-8 lg:mt-16 lg:mb-3 " + Pc)
                ]), x([
                    A2(Ci, x([
                        qo("selection:bg-white")
                    ]), x([
                        ui(e.$7.cO)
                    ])),
                    A2(Ci, x([
                        qo("inline-block ml-1 px-1.5 bg-primary-200 rounded-full selection:bg-white lg:ml-2")
                    ]), x([
                        ui(Ve(Oe(l)))
                    ])),
                    A2(Ci, x([
                        qo("inline-block ml-auto selection:bg-white")
                    ]), x([
                        ui(e.$7.b9)
                    ]))
                ])) : ui(""),
                Oe(l) > 0 ? A2(oi, x([
                    qo("flex flex-col gap-y-2 lg:gap-y-4")
                ]), A2(tn, A3(ab, e, r, n), l)) : ui(""),
                Oe(b) > 0 ? A2(li, x([
                    qo("group mt-4 lg:mt-8")
                ]), x([
                    A2(_i, x([
                        qo("flex gap-1 order items-center text-primary-600 cursor-pointer mb-2 [&::-webkit-details-marker]:hidden xs:mb-3 md:gap-2 " + Pc + " outline-none focus-visible:outline-4 focus-visible:outline-primary-600 focus-visible:rounded-full")
                    ]), x([
                        A2(Vo, "w-3 stroke-1 stroke-primary-600 fill-primary-600 transition-transform group-open:rotate-90 md:-mr-0.5", d),
                        A2(Ci, x([
                            qo("selection:bg-white")
                        ]), x([
                            ui(e.c6.bR)
                        ])),
                        A2(Df, Dl, "ml-auto order-1 md:order-none md:-ml-1"),
                        A2(Ci, x([
                            qo("inline-block px-1.5 bg-primary-200 rounded-full selection:bg-white")
                        ]), x([
                            ui(Ve(Oe(b)))
                        ]))
                    ])),
                    A2(oi, x([
                        qo("flex flex-col mt-2 gap-2 md:gap-4")
                    ]), A2(tn, A3(Af, e, n, ls({
                        W: Al,
                        ac: Pl
                    })), b))
                ])) : ui(""),
                A2(Yo, x([
                    qo("mt-12")
                ]), x([
                    A2(Bl, {
                        az: !1,
                        cm: e.dM,
                        aV: 0
                    }, A2(tn, function(t) {
                        return s(t.bn, Te);
                    }, A2(bf, function(t) {
                        return t.bn;
                    }, A2(qf, A2(Gi, function(t) {
                        return t.P;
                    }, nc), r.aW))))
                ]))
            ])),
            A2(Yo, x([
                qo("grid [grid-template-columns:auto_1fr] px-4 gap-x-2 bg-primary-100 sm:gap-x-4 xs:px-6 sm:px-8 md:px-12 lg:px-16")
            ]), x([
                A2(Yo, x([
                    qo("row-start-1 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("row-start-6 col-start-1 col-span-2 h-10 sm:h-12 md:h-14")
                ]), d),
                A2(Yo, x([
                    qo("col-start-1 row-start-1 row-span-2 w-0.5 h-5/6 justify-self-center bg-primary-300")
                ]), d),
                A2(Yo, x([
                    qo("row-start-2 col-start-1 z-10 place-self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-primary-300 text-black text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                ]), x([
                    A2(Fl, "w-[10px] h-[10px] fill-black sm:w-3 sm:h-3", d)
                ])),
                A2(Yo, x([
                    qo("row-start-2 col-start-2 font-semibold")
                ]), x([
                    ui(e.$7.dB)
                ])),
                A2(ni, x([
                    qo("row-start-3 col-start-2 mt-1 mb-6 sm:mb-8 text-primary-900 max-w-md")
                ]), x([
                    ui(e.$7.dA)
                ])),
                A2(Yo, x([
                    qo("flex flex-col mt-4 row-start-4 col-start-1 col-span-2 justify-self-center gap-4 sm:gap-6")
                ]), x([
                    A2(Xo, x([
                        qo(A2(Fi, 2, 2)),
                        ei(t.bI)
                    ]), x([
                        ui(e.$7.dz)
                    ]))
                ])),
                A2(Yo, x([
                    qo("flex mt-12 justify-center row-start-5 col-start-1 col-span-2 h-[500px] sm:h-[410px] sm:col-start-2 sm:col-span-1")
                ]), x([
                    A2(Vl, x([
                        qo("w-full sm:w-3/5"),
                        mi(t.bY),
                        hi("konsens feedback")
                    ]), d)
                ]))
            ]))
        ]));
    }), ob = F3(function(t, e, r) {
        return A2(Yo, d, x([
            Ti(t.J),
            A2(Yo, x([
                qo("flex flex-col max-w-screen-lg mx-auto lg:px-8")
            ]), x([
                A2(Ii, t.I, Ee({
                    T: t.J.bz,
                    U: t.J.by,
                    V: t.J.bx,
                    D: e.aB
                })),
                A2(mc, _a, A6(of, t.J, t.dD, e, r.ah, Ui, Zi(e.aB))),
                A2(Yo, x([
                    qo("grid [grid-template-columns:auto_auto_auto_1fr] px-4 gap-x-2 gap-y-4 sm:gap-x-3 xs:px-6 sm:px-8 md:px-12 lg:px-16")
                ]), x([
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-1 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("1")
                    ])),
                    A2(Yo, x([
                        qo("flex items-center gap-2 mr-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-grey-400")
                        ]), x([
                            ui(t.J.c8.h)
                        ])),
                        A2(Ji, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", d)
                    ])),
                    A2(Yo, x([
                        qo("col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                    ]), x([
                        ui(t.J.cZ + " " + pc(s(t.dD, e.P)))
                    ])),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 row-span-2 justify-self-center mt-1 w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-2 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("2")
                    ])),
                    A2(Yo, x([
                        qo("row-start-2 flex items-center gap-2 mr-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-grey-400")
                        ]), x([
                            ui(t.J.c6.h)
                        ])),
                        A2(Ji, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", d)
                    ])),
                    function() {
                        var r = e.aR;
                        if (r.$) return ui("");
                        var n = r.a;
                        return A2(Yo, x([
                            qo("row-start-2 col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                        ]), x([
                            ui(t.J.cX + " " + pc(s(t.dD, n)))
                        ]));
                    }(),
                    A2(Yo, x([
                        qo("col-start-1 row-start-3 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-3 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-grey-300 text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        ui("3")
                    ])),
                    A2(Yo, x([
                        qo("col-start-2 row-start-3 mr-2 flex items-center gap-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-grey-400")
                        ]), x([
                            ui(t.J.dh.h)
                        ])),
                        A2(Ji, "w-[10px] h-[10px] fill-grey-400 stroke-grey-400 sm:w-3 sm:h-3", d)
                    ])),
                    function() {
                        var r = e.aU;
                        if (r.$) return ui("");
                        var n = r.a;
                        return A2(Yo, x([
                            qo("row-start-3 col-span-2 self-center justify-self-end text-sm text-grey-400 sm:text-base xs:col-span-1 xs:justify-self-center")
                        ]), x([
                            ui(t.J.cX + " " + pc(s(t.dD, n)))
                        ]));
                    }(),
                    A2(Yo, x([
                        qo("col-start-1 row-start-4 row-span-2 justify-self-center w-0.5 bg-grey-300")
                    ]), d),
                    A2(Yo, x([
                        qo("col-start-1 row-start-4 self-center flex shrink-0 justify-center items-center w-5 h-5 gap-2 rounded-full bg-black text-white text-xs font-bold sm:w-6 sm:h-6 sm:text-base")
                    ]), x([
                        A2(cf, "w-[10px] h-[10px] fill-white sm:w-3 sm:h-3", d)
                    ])),
                    A2(Yo, x([
                        qo("col-start-2 row-start-4 mr-2 flex items-center gap-2")
                    ]), x([
                        A2(Ci, x([
                            qo("font-semibold text-black")
                        ]), x([
                            ui(t.J.$7.h)
                        ]))
                    ])),
                    A2(Yo, x([
                        qo("col-span-2 row-start-4 justify-self-end px-2 py-1 font-semibold text-xs text-primary-600 bg-primary-200 rounded-full xs:col-span-1 xs:text-sm xs:px-3 xs:justify-self-start md:text-base md:-my-0.5")
                    ]), x([
                        ui(t.J.cW)
                    ]))
                ])),
                A2(mc, Ll, A4(ub, t.I, t.J, e, r)),
                A3(dc, t.J, s(t.dD, e.bT), e.aB)
            ])),
            A2(Yo, x([
                qo("mt-20 lg:mt-40")
            ]), x([
                A3(Ko, 0, 1, A3(ii, t.I, t.J.bZ, 1))
            ])),
            A4(rf, t.I, t.J, {
                bn: e.bn,
                k: e.k,
                aB: e.aB,
                h: e.h
            }, r.cs)
        ]));
    });
    dn = {
        Main: {
            init: xn({
                ci: function(t) {
                    var e, r, n = 1 === (r = t.a9, e = A2(Gr, "http://", r) ? A2(Or, 0, A2(Tr, 7, r)) : A2(Gr, "https://", r) ? A2(Or, 1, A2(Tr, 8, r)) : Te).$ ? Hn : A2(va, Hn, A2(fa, wa, e.a));
                    return s({
                        I: t.I,
                        J: t.J,
                        aa: Rn(t.aa),
                        aJ: function() {
                            switch(n.$){
                                case 0:
                                    return Cn({
                                        bn: "",
                                        k: "",
                                        cs: kn,
                                        cP: Te,
                                        h: ""
                                    });
                                case 2:
                                    return $n;
                                default:
                                    return yn;
                            }
                        }(),
                        af: Sn(Tn(t.af)),
                        dD: ya
                    }, _n(x([
                        A2(gn, wn, Pn),
                        1 === n.$ ? A2(In, vn, zn(n.a)) : En
                    ])));
                },
                dy: function() {
                    return Ca(x([
                        hu(mu)
                    ]));
                },
                dH: Lo,
                dK: function(t) {
                    var e = t.aJ;
                    switch(e.$){
                        case 0:
                            return A2(Vi, t.I, t.J);
                        case 1:
                            return A2(Hi, t.I, t.J);
                        case 2:
                            return A2(cs, t, e.a);
                        case 3:
                            return A3(Gf, t, e.a, e.b);
                        case 4:
                            return A3(zl, t, e.a, e.b);
                        default:
                            return A3(ob, t, e.a, e.b);
                    }
                }
            })(A2(Mr, function(t) {
                return A2(Mr, function(e) {
                    return A2(Mr, function(r) {
                        return A2(Mr, function(n) {
                            return A2(Mr, function(a) {
                                return Ar({
                                    I: a,
                                    J: n,
                                    aa: r,
                                    af: e,
                                    a9: t
                                });
                            }, A2(mn, "config", A2(Mr, function(t) {
                                return A2(Mr, function(e) {
                                    return A2(Mr, function(r) {
                                        return A2(Mr, function(n) {
                                            return A2(Mr, function(a) {
                                                return A2(Mr, function(u) {
                                                    return A2(Mr, function(o) {
                                                        return A2(Mr, function(i) {
                                                            return Ar({
                                                                bj: i,
                                                                bk: o,
                                                                bl: u,
                                                                bI: a,
                                                                bY: n,
                                                                co: r,
                                                                dF: e,
                                                                dL: t
                                                            });
                                                        }, A2(mn, "appUrlEnglish", $a));
                                                    }, A2(mn, "appUrlGerman", $a));
                                                }, A2(mn, "appUrlSpanish", $a));
                                            }, A2(mn, "donateUrl", $a));
                                        }, A2(mn, "feedbackFormUrl", $a));
                                    }, A2(mn, "logoUrl", $a));
                                }, A2(mn, "tinyteamUrl", $a));
                            }, A2(mn, "websiteUrl", $a))));
                        }, A2(mn, "copy", A2(Mr, function(t) {
                            return A2(Mr, function(e) {
                                return A2(Mr, function(r) {
                                    return A2(Mr, function(n) {
                                        return A2(Mr, function(a) {
                                            return A2(Mr, function(u) {
                                                return A2(Mr, function(o) {
                                                    return A2(Mr, function(i) {
                                                        return A2(Mr, function(c) {
                                                            return A2(Mr, function(f) {
                                                                return A2(Mr, function(s) {
                                                                    return A2(Mr, function(l) {
                                                                        return A2(Mr, function(b) {
                                                                            return A2(Mr, function(d) {
                                                                                return A2(Mr, function(p) {
                                                                                    return A2(Mr, function(g) {
                                                                                        return A2(Mr, function(x) {
                                                                                            return A2(Mr, function(m) {
                                                                                                return A2(Mr, function(h) {
                                                                                                    return A2(Mr, function(w) {
                                                                                                        return A2(Mr, function(v) {
                                                                                                            return A2(Mr, function(y) {
                                                                                                                return A2(Mr, function(k) {
                                                                                                                    return A2(Mr, function($) {
                                                                                                                        return A2(Mr, function(C) {
                                                                                                                            return A2(Mr, function(_) {
                                                                                                                                return A2(Mr, function(J) {
                                                                                                                                    return A2(Mr, function(j) {
                                                                                                                                        return A2(Mr, function(B) {
                                                                                                                                            return A2(Mr, function(M) {
                                                                                                                                                return A2(Mr, function(z) {
                                                                                                                                                    return A2(Mr, function(L) {
                                                                                                                                                        return A2(Mr, function(A) {
                                                                                                                                                            return A2(Mr, function(P) {
                                                                                                                                                                return A2(Mr, function(D) {
                                                                                                                                                                    return Ar({
                                                                                                                                                                        bi: D,
                                                                                                                                                                        bs: P,
                                                                                                                                                                        bw: A,
                                                                                                                                                                        bx: L,
                                                                                                                                                                        by: z,
                                                                                                                                                                        bz: M,
                                                                                                                                                                        bC: B,
                                                                                                                                                                        bD: j,
                                                                                                                                                                        bL: J,
                                                                                                                                                                        bZ: _,
                                                                                                                                                                        b5: C,
                                                                                                                                                                        b7: $,
                                                                                                                                                                        ch: k,
                                                                                                                                                                        ct: y,
                                                                                                                                                                        cI: v,
                                                                                                                                                                        cV: w,
                                                                                                                                                                        aL: h,
                                                                                                                                                                        cW: m,
                                                                                                                                                                        cX: x,
                                                                                                                                                                        cY: g,
                                                                                                                                                                        cZ: p,
                                                                                                                                                                        c3: d,
                                                                                                                                                                        c4: b,
                                                                                                                                                                        c5: l,
                                                                                                                                                                        c6: s,
                                                                                                                                                                        c8: f,
                                                                                                                                                                        c9: c,
                                                                                                                                                                        da: i,
                                                                                                                                                                        db: o,
                                                                                                                                                                        dc: u,
                                                                                                                                                                        dd: a,
                                                                                                                                                                        df: n,
                                                                                                                                                                        dh: r,
                                                                                                                                                                        $7: e,
                                                                                                                                                                        dM: t
                                                                                                                                                                    });
                                                                                                                                                                }, A2(mn, "api_response", A2(Mr, function(t) {
                                                                                                                                                                    return A2(Mr, function(e) {
                                                                                                                                                                        return A2(Mr, function(r) {
                                                                                                                                                                            return A2(Mr, function(n) {
                                                                                                                                                                                return A2(Mr, function(a) {
                                                                                                                                                                                    return Ar({
                                                                                                                                                                                        bG: a,
                                                                                                                                                                                        b6: n,
                                                                                                                                                                                        c7: r,
                                                                                                                                                                                        dk: e,
                                                                                                                                                                                        dG: t
                                                                                                                                                                                    });
                                                                                                                                                                                }, A2(mn, "description_length", $a));
                                                                                                                                                                            }, A2(mn, "generic", $a));
                                                                                                                                                                        }, A2(mn, "proposals_title_question_id_key", $a));
                                                                                                                                                                    }, A2(mn, "ratings_proposal_id_question_id_author_key", $a));
                                                                                                                                                                }, A2(mn, "title_length", $a))));
                                                                                                                                                            }, A2(mn, "cancel_button", $a));
                                                                                                                                                        }, A2(mn, "copy_invite_link_button", $a));
                                                                                                                                                    }, A2(mn, "copy_link_button_pressed", $a));
                                                                                                                                                }, A2(mn, "copy_link_short_button", $a));
                                                                                                                                            }, A2(mn, "copy_result_link_button", $a));
                                                                                                                                        }, A2(mn, "default_proposal_description", $a));
                                                                                                                                    }, A2(mn, "default_proposal_title", $a));
                                                                                                                                }, A2(mn, "empty_proposal_description", $a));
                                                                                                                            }, A2(mn, "footer", A2(Mr, function(t) {
                                                                                                                                return A2(Mr, function(e) {
                                                                                                                                    return A2(Mr, function(r) {
                                                                                                                                        return A2(Mr, function(n) {
                                                                                                                                            return A2(Mr, function(a) {
                                                                                                                                                return A2(Mr, function(u) {
                                                                                                                                                    return Ar({
                                                                                                                                                        bA: u,
                                                                                                                                                        bB: a,
                                                                                                                                                        bX: n,
                                                                                                                                                        cn: r,
                                                                                                                                                        c1: e,
                                                                                                                                                        dC: t
                                                                                                                                                    });
                                                                                                                                                }, A2(mn, "copyright", $a));
                                                                                                                                            }, A2(mn, "created_by", $a));
                                                                                                                                        }, A2(mn, "faq", $a));
                                                                                                                                    }, A2(mn, "legal_notice", $a));
                                                                                                                                }, A2(mn, "privacy_policy", $a));
                                                                                                                            }, A2(mn, "terms_of_use", $a))));
                                                                                                                        }, A2(mn, "found_bug_button", $a));
                                                                                                                    }, A2(mn, "generic_error", $a));
                                                                                                                }, A2(mn, "individual_ratings", $a));
                                                                                                            }, A2(mn, "modals", A2(Mr, function(t) {
                                                                                                                return A2(Mr, function(e) {
                                                                                                                    return A2(Mr, function(r) {
                                                                                                                        return A2(Mr, function(n) {
                                                                                                                            return A2(Mr, function(a) {
                                                                                                                                return A2(Mr, function(u) {
                                                                                                                                    return A2(Mr, function(o) {
                                                                                                                                        return A2(Mr, function(i) {
                                                                                                                                            return A2(Mr, function(c) {
                                                                                                                                                return A2(Mr, function(f) {
                                                                                                                                                    return A2(Mr, function(s) {
                                                                                                                                                        return A2(Mr, function(l) {
                                                                                                                                                            return A2(Mr, function(b) {
                                                                                                                                                                return Ar({
                                                                                                                                                                    br: b,
                                                                                                                                                                    bE: l,
                                                                                                                                                                    bM: s,
                                                                                                                                                                    bN: f,
                                                                                                                                                                    bQ: c,
                                                                                                                                                                    bS: i,
                                                                                                                                                                    cf: o,
                                                                                                                                                                    cT: u,
                                                                                                                                                                    cU: a,
                                                                                                                                                                    de: n,
                                                                                                                                                                    dg: r,
                                                                                                                                                                    di: e,
                                                                                                                                                                    dp: t
                                                                                                                                                                });
                                                                                                                                                            }, A2(mn, "cancel", $a));
                                                                                                                                                        }, A2(mn, "delete_question", A2(Mr, function(t) {
                                                                                                                                                            return A2(Mr, function(e) {
                                                                                                                                                                return A2(Mr, function(r) {
                                                                                                                                                                    return A2(Mr, function(n) {
                                                                                                                                                                        return Ar({
                                                                                                                                                                            u: n,
                                                                                                                                                                            k: r,
                                                                                                                                                                            cS: e,
                                                                                                                                                                            h: t
                                                                                                                                                                        });
                                                                                                                                                                    }, A2(mn, "button", $a));
                                                                                                                                                                }, A2(mn, "description", $a));
                                                                                                                                                            }, A2(mn, "phase_code_description", $a));
                                                                                                                                                        }, A2(mn, "title", $a))));
                                                                                                                                                    }, A2(mn, "end_proposal_phase", A2(Mr, function(t) {
                                                                                                                                                        return A2(Mr, function(e) {
                                                                                                                                                            return A2(Mr, function(r) {
                                                                                                                                                                return Ar({
                                                                                                                                                                    u: r,
                                                                                                                                                                    k: e,
                                                                                                                                                                    h: t
                                                                                                                                                                });
                                                                                                                                                            }, A2(mn, "button", $a));
                                                                                                                                                        }, A2(mn, "description", $a));
                                                                                                                                                    }, A2(mn, "title", $a))));
                                                                                                                                                }, A2(mn, "end_rating_phase", A2(Mr, function(t) {
                                                                                                                                                    return A2(Mr, function(e) {
                                                                                                                                                        return A2(Mr, function(r) {
                                                                                                                                                            return Ar({
                                                                                                                                                                u: r,
                                                                                                                                                                k: e,
                                                                                                                                                                h: t
                                                                                                                                                            });
                                                                                                                                                        }, A2(mn, "button", $a));
                                                                                                                                                    }, A2(mn, "description", $a));
                                                                                                                                                }, A2(mn, "title", $a))));
                                                                                                                                            }, A2(mn, "exclude_proposal", A2(Mr, function(t) {
                                                                                                                                                return A2(Mr, function(e) {
                                                                                                                                                    return A2(Mr, function(r) {
                                                                                                                                                        return Ar({
                                                                                                                                                            u: r,
                                                                                                                                                            k: e,
                                                                                                                                                            h: t
                                                                                                                                                        });
                                                                                                                                                    }, A2(mn, "button", $a));
                                                                                                                                                }, A2(mn, "description", $a));
                                                                                                                                            }, A2(mn, "title", $a))));
                                                                                                                                        }, A2(mn, "exclusion_info", A2(Mr, function(t) {
                                                                                                                                            return A2(Mr, function(e) {
                                                                                                                                                return Ar({
                                                                                                                                                    k: e,
                                                                                                                                                    h: t
                                                                                                                                                });
                                                                                                                                            }, A2(mn, "description", $a));
                                                                                                                                        }, A2(mn, "title", $a))));
                                                                                                                                    }, A2(mn, "include_proposal", A2(Mr, function(t) {
                                                                                                                                        return A2(Mr, function(e) {
                                                                                                                                            return A2(Mr, function(r) {
                                                                                                                                                return Ar({
                                                                                                                                                    u: r,
                                                                                                                                                    k: e,
                                                                                                                                                    h: t
                                                                                                                                                });
                                                                                                                                            }, A2(mn, "button", $a));
                                                                                                                                        }, A2(mn, "description", $a));
                                                                                                                                    }, A2(mn, "title", $a))));
                                                                                                                                }, A2(mn, "phase_code_explanation", A2(Mr, function(t) {
                                                                                                                                    return A2(Mr, function(e) {
                                                                                                                                        return Ar({
                                                                                                                                            k: e,
                                                                                                                                            h: t
                                                                                                                                        });
                                                                                                                                    }, A2(mn, "description", $a));
                                                                                                                                }, A2(mn, "title", $a))));
                                                                                                                            }, A2(mn, "phase_code_info", A2(Mr, function(t) {
                                                                                                                                return A2(Mr, function(e) {
                                                                                                                                    return Ar({
                                                                                                                                        k: e,
                                                                                                                                        h: t
                                                                                                                                    });
                                                                                                                                }, A2(mn, "description", $a));
                                                                                                                            }, A2(mn, "title", $a))));
                                                                                                                        }, A2(mn, "question_deleted", A2(Mr, function(t) {
                                                                                                                            return A2(Mr, function(e) {
                                                                                                                                return A2(Mr, function(r) {
                                                                                                                                    return A2(Mr, function(n) {
                                                                                                                                        return Ar({
                                                                                                                                            k: n,
                                                                                                                                            b8: r,
                                                                                                                                            cC: e,
                                                                                                                                            h: t
                                                                                                                                        });
                                                                                                                                    }, A2(mn, "description", $a));
                                                                                                                                }, A2(mn, "go_to_hompage_button", $a));
                                                                                                                            }, A2(mn, "new_decision_button", $a));
                                                                                                                        }, A2(mn, "title", $a))));
                                                                                                                    }, A2(mn, "rate_proposals", A2(Mr, function(t) {
                                                                                                                        return A2(Mr, function(e) {
                                                                                                                            return A2(Mr, function(r) {
                                                                                                                                return Ar({
                                                                                                                                    u: r,
                                                                                                                                    k: e,
                                                                                                                                    h: t
                                                                                                                                });
                                                                                                                            }, A2(mn, "button", $a));
                                                                                                                        }, A2(mn, "description", $a));
                                                                                                                    }, A2(mn, "title", $a))));
                                                                                                                }, A2(mn, "rating_phase_started", A2(Mr, function(t) {
                                                                                                                    return A2(Mr, function(e) {
                                                                                                                        return A2(Mr, function(r) {
                                                                                                                            return Ar({
                                                                                                                                u: r,
                                                                                                                                k: e,
                                                                                                                                h: t
                                                                                                                            });
                                                                                                                        }, A2(mn, "button", $a));
                                                                                                                    }, A2(mn, "description", $a));
                                                                                                                }, A2(mn, "title", $a))));
                                                                                                            }, A2(mn, "result_phase_started", A2(Mr, function(t) {
                                                                                                                return A2(Mr, function(e) {
                                                                                                                    return A2(Mr, function(r) {
                                                                                                                        return Ar({
                                                                                                                            u: r,
                                                                                                                            k: e,
                                                                                                                            h: t
                                                                                                                        });
                                                                                                                    }, A2(mn, "button", $a));
                                                                                                                }, A2(mn, "description", $a));
                                                                                                            }, A2(mn, "title", $a))))));
                                                                                                        }, A2(mn, "not_found", A2(Mr, function(t) {
                                                                                                            return A2(Mr, function(e) {
                                                                                                                return Ar({
                                                                                                                    k: e,
                                                                                                                    h: t
                                                                                                                });
                                                                                                            }, A2(mn, "description", $a));
                                                                                                        }, A2(mn, "title", $a))));
                                                                                                    }, A2(mn, "phase_code_label", $a));
                                                                                                }, A2(mn, "phase_code_placeholder", $a));
                                                                                            }, A2(mn, "phase_done", $a));
                                                                                        }, A2(mn, "phase_ended", $a));
                                                                                    }, A2(mn, "phase_in_progress", $a));
                                                                                }, A2(mn, "phase_started", $a));
                                                                            }, A2(mn, "proposal_description", $a));
                                                                        }, A2(mn, "proposal_label", $a));
                                                                    }, A2(mn, "proposal_placeholder_title", $a));
                                                                }, A2(mn, "proposals", A2(Mr, function(t) {
                                                                    return A2(Mr, function(e) {
                                                                        return A2(Mr, function(r) {
                                                                            return A2(Mr, function(n) {
                                                                                return A2(Mr, function(a) {
                                                                                    return A2(Mr, function(u) {
                                                                                        return A2(Mr, function(o) {
                                                                                            return A2(Mr, function(i) {
                                                                                                return A2(Mr, function(c) {
                                                                                                    return A2(Mr, function(f) {
                                                                                                        return A2(Mr, function(s) {
                                                                                                            return A2(Mr, function(l) {
                                                                                                                return A2(Mr, function(b) {
                                                                                                                    return A2(Mr, function(d) {
                                                                                                                        return A2(Mr, function(p) {
                                                                                                                            return A2(Mr, function(g) {
                                                                                                                                return A2(Mr, function(x) {
                                                                                                                                    return A2(Mr, function(m) {
                                                                                                                                        return A2(Mr, function(h) {
                                                                                                                                            return Ar({
                                                                                                                                                bf: h,
                                                                                                                                                bg: m,
                                                                                                                                                bP: x,
                                                                                                                                                bR: g,
                                                                                                                                                Y: p,
                                                                                                                                                b_: d,
                                                                                                                                                b1: b,
                                                                                                                                                b3: l,
                                                                                                                                                b4: s,
                                                                                                                                                S: f,
                                                                                                                                                ce: c,
                                                                                                                                                cz: i,
                                                                                                                                                cA: o,
                                                                                                                                                cB: u,
                                                                                                                                                cD: a,
                                                                                                                                                cE: n,
                                                                                                                                                cF: r,
                                                                                                                                                aj: e,
                                                                                                                                                h: t
                                                                                                                                            });
                                                                                                                                        }, A2(mn, "add_proposal_button", $a));
                                                                                                                                    }, A2(mn, "add_proposal_button_short", $a));
                                                                                                                                }, A2(mn, "exclude_button", $a));
                                                                                                                            }, A2(mn, "excluded_label", $a));
                                                                                                                        }, A2(mn, "explanation", $a));
                                                                                                                    }, A2(mn, "form_label_description", $a));
                                                                                                                }, A2(mn, "form_label_title", $a));
                                                                                                            }, A2(mn, "form_title", $a));
                                                                                                        }, A2(mn, "form_title_error", $a));
                                                                                                    }, A2(mn, "headline", $a));
                                                                                                }, A2(mn, "include_button", $a));
                                                                                            }, A2(mn, "new_boomark_link", $a));
                                                                                        }, A2(mn, "new_copy_button", $a));
                                                                                    }, A2(mn, "new_copy_button_pressed", $a));
                                                                                }, A2(mn, "new_invite_link", $a));
                                                                            }, A2(mn, "new_public_info", $a));
                                                                        }, A2(mn, "new_title", $a));
                                                                    }, A2(mn, "start_phase_button", $a));
                                                                }, A2(mn, "title", $a))));
                                                            }, A2(mn, "question", A2(Mr, function(t) {
                                                                return A2(Mr, function(e) {
                                                                    return A2(Mr, function(r) {
                                                                        return A2(Mr, function(n) {
                                                                            return A2(Mr, function(a) {
                                                                                return A2(Mr, function(u) {
                                                                                    return A2(Mr, function(o) {
                                                                                        return A2(Mr, function(i) {
                                                                                            return A2(Mr, function(c) {
                                                                                                return A2(Mr, function(f) {
                                                                                                    return Ar({
                                                                                                        bF: f,
                                                                                                        bH: c,
                                                                                                        S: i,
                                                                                                        cm: o,
                                                                                                        cw: u,
                                                                                                        cx: a,
                                                                                                        cR: n,
                                                                                                        aL: r,
                                                                                                        c_: e,
                                                                                                        h: t
                                                                                                    });
                                                                                                }, A2(mn, "description_label", $a));
                                                                                            }, A2(mn, "description_placeholder", $a));
                                                                                        }, A2(mn, "headline", $a));
                                                                                    }, A2(mn, "label", $a));
                                                                                }, A2(mn, "name_label", $a));
                                                                            }, A2(mn, "name_placeholder", $a));
                                                                        }, A2(mn, "phase_code_checkbox_label", $a));
                                                                    }, A2(mn, "phase_code_placeholder", $a));
                                                                }, A2(mn, "placeholder", $a));
                                                            }, A2(mn, "title", $a))));
                                                        }, A2(mn, "question_automatic_deletion", $a));
                                                    }, A2(mn, "question_automatic_deletion_short", $a));
                                                }, A2(mn, "question_available_until", $a));
                                            }, A2(mn, "question_delete_button", $a));
                                        }, A2(mn, "question_delete_now_button", $a));
                                    }, A2(mn, "question_description", $a));
                                }, A2(mn, "rating", A2(Mr, function(t) {
                                    return A2(Mr, function(e) {
                                        return A2(Mr, function(r) {
                                            return A2(Mr, function(n) {
                                                return A2(Mr, function(a) {
                                                    return A2(Mr, function(u) {
                                                        return A2(Mr, function(o) {
                                                            return A2(Mr, function(i) {
                                                                return A2(Mr, function(c) {
                                                                    return A2(Mr, function(f) {
                                                                        return A2(Mr, function(s) {
                                                                            return A2(Mr, function(l) {
                                                                                return A2(Mr, function(b) {
                                                                                    return A2(Mr, function(d) {
                                                                                        return A2(Mr, function(p) {
                                                                                            return Ar({
                                                                                                Y: p,
                                                                                                bU: d,
                                                                                                b$: b,
                                                                                                b0: l,
                                                                                                b2: s,
                                                                                                S: f,
                                                                                                cq: c,
                                                                                                cH: i,
                                                                                                dj: o,
                                                                                                dm: u,
                                                                                                dn: a,
                                                                                                aj: n,
                                                                                                dx: r,
                                                                                                h: e,
                                                                                                dP: t
                                                                                            });
                                                                                        }, A2(mn, "explanation", $a));
                                                                                    }, A2(mn, "explanation_in_proposal", $a));
                                                                                }, A2(mn, "form_label_name", $a));
                                                                            }, A2(mn, "form_label_placeholder", $a));
                                                                        }, A2(mn, "form_name_error", $a));
                                                                    }, A2(mn, "headline", $a));
                                                                }, A2(mn, "maximum_resistance", $a));
                                                            }, A2(mn, "no_resistance", $a));
                                                        }, A2(mn, "rating_submitted", $a));
                                                    }, A2(mn, "resistant_point", $a));
                                                }, A2(mn, "resistant_points", $a));
                                            }, A2(mn, "start_phase_button", $a));
                                        }, A2(mn, "submit_rating_button", $a));
                                    }, A2(mn, "title", $a));
                                }, A2(mn, "your_resistance", $a))));
                            }, A2(mn, "result", A2(Mr, function(t) {
                                return A2(Mr, function(e) {
                                    return A2(Mr, function(r) {
                                        return A2(Mr, function(n) {
                                            return A2(Mr, function(a) {
                                                return A2(Mr, function(u) {
                                                    return A2(Mr, function(o) {
                                                        return A2(Mr, function(i) {
                                                            return A2(Mr, function(c) {
                                                                return A2(Mr, function(f) {
                                                                    return A2(Mr, function(s) {
                                                                        return A2(Mr, function(l) {
                                                                            return Ar({
                                                                                bo: l,
                                                                                bp: s,
                                                                                Y: f,
                                                                                bV: c,
                                                                                b9: i,
                                                                                S: o,
                                                                                cO: u,
                                                                                aj: a,
                                                                                dz: n,
                                                                                dA: r,
                                                                                dB: e,
                                                                                h: t
                                                                            });
                                                                        }, A2(mn, "best_proposal", $a));
                                                                    }, A2(mn, "best_proposals", $a));
                                                                }, A2(mn, "explanation", $a));
                                                            }, A2(mn, "explanation_in_rating", $a));
                                                        }, A2(mn, "group_resistance", $a));
                                                    }, A2(mn, "headline", $a));
                                                }, A2(mn, "other_proposals", $a));
                                            }, A2(mn, "start_phase_button", $a));
                                        }, A2(mn, "support_button", $a));
                                    }, A2(mn, "support_description", $a));
                                }, A2(mn, "support_title", $a));
                            }, A2(mn, "title", $a))));
                        }, A2(mn, "who_rated", $a))));
                    }, A2(mn, "now", ka));
                }, A2(mn, "seed", hn));
            }, A2(mn, "url", $a)))(0)
        }
    }, t.Elm ? function t(e, r) {
        for(var n in r)n in e ? "init" == n ? a(6) : t(e[n], r[n]) : e[n] = r[n];
    }(t.Elm, dn) : t.Elm = dn;
}($09ec739d0d47b71c$exports);


var $55ac9bb4512a08c1$var$e = new Map;
function $55ac9bb4512a08c1$var$t(t) {
    var o = $55ac9bb4512a08c1$var$e.get(t);
    o && o.destroy();
}
function $55ac9bb4512a08c1$var$o(t) {
    var o = $55ac9bb4512a08c1$var$e.get(t);
    o && o.update();
}
var $55ac9bb4512a08c1$var$r = null;
"undefined" == typeof window ? (($55ac9bb4512a08c1$var$r = function(e) {
    return e;
}).destroy = function(e) {
    return e;
}, $55ac9bb4512a08c1$var$r.update = function(e) {
    return e;
}) : (($55ac9bb4512a08c1$var$r = function(t, o) {
    return t && Array.prototype.forEach.call(t.length ? t : [
        t
    ], function(t) {
        return function(t) {
            if (t && t.nodeName && "TEXTAREA" === t.nodeName && !$55ac9bb4512a08c1$var$e.has(t)) {
                var o, r = null, n = window.getComputedStyle(t), i = (o = t.value, function() {
                    a({
                        testForHeightReduction: "" === o || !t.value.startsWith(o),
                        restoreTextAlign: null
                    }), o = t.value;
                }), l = (function(o) {
                    t.removeEventListener("autosize:destroy", l), t.removeEventListener("autosize:update", s), t.removeEventListener("input", i), window.removeEventListener("resize", s), Object.keys(o).forEach(function(e) {
                        return t.style[e] = o[e];
                    }), $55ac9bb4512a08c1$var$e.delete(t);
                }).bind(t, {
                    height: t.style.height,
                    resize: t.style.resize,
                    textAlign: t.style.textAlign,
                    overflowY: t.style.overflowY,
                    overflowX: t.style.overflowX,
                    wordWrap: t.style.wordWrap
                });
                t.addEventListener("autosize:destroy", l), t.addEventListener("autosize:update", s), t.addEventListener("input", i), window.addEventListener("resize", s), t.style.overflowX = "hidden", t.style.wordWrap = "break-word", $55ac9bb4512a08c1$var$e.set(t, {
                    destroy: l,
                    update: s
                }), s();
            }
            function a(e) {
                var o, i, l = e.restoreTextAlign, s = void 0 === l ? null : l, d = e.testForHeightReduction, u = void 0 === d || d, c = n.overflowY;
                if (0 !== t.scrollHeight && ("vertical" === n.resize ? t.style.resize = "none" : "both" === n.resize && (t.style.resize = "horizontal"), u && (o = function(e) {
                    for(var t = []; e && e.parentNode && e.parentNode instanceof Element;)e.parentNode.scrollTop && t.push([
                        e.parentNode,
                        e.parentNode.scrollTop
                    ]), e = e.parentNode;
                    return function() {
                        return t.forEach(function(e) {
                            var t = e[0], o = e[1];
                            t.style.scrollBehavior = "auto", t.scrollTop = o, t.style.scrollBehavior = null;
                        });
                    };
                }(t), t.style.height = ""), i = "content-box" === n.boxSizing ? t.scrollHeight - (parseFloat(n.paddingTop) + parseFloat(n.paddingBottom)) : t.scrollHeight + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth), "none" !== n.maxHeight && i > parseFloat(n.maxHeight) ? ("hidden" === n.overflowY && (t.style.overflow = "scroll"), i = parseFloat(n.maxHeight)) : "hidden" !== n.overflowY && (t.style.overflow = "hidden"), t.style.height = i + "px", s && (t.style.textAlign = s), o && o(), r !== i && (t.dispatchEvent(new Event("autosize:resized", {
                    bubbles: !0
                })), r = i), c !== n.overflow && !s)) {
                    var v = n.textAlign;
                    "hidden" === n.overflow && (t.style.textAlign = "start" === v ? "end" : "start"), a({
                        restoreTextAlign: v,
                        testForHeightReduction: !0
                    });
                }
            }
            function s() {
                a({
                    testForHeightReduction: !0,
                    restoreTextAlign: null
                });
            }
        }(t);
    }), t;
}).destroy = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], $55ac9bb4512a08c1$var$t), e;
}, $55ac9bb4512a08c1$var$r.update = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], $55ac9bb4512a08c1$var$o), e;
});
var $55ac9bb4512a08c1$var$n = $55ac9bb4512a08c1$var$r;
var $55ac9bb4512a08c1$export$2e2bcd8739ae039 = $55ac9bb4512a08c1$var$n;


class $2b3a5afb4a111d4d$export$dcaf143e197b2cd2 extends Error {
    constructor(e){
        super("ClientResponseError"), this.url = "", this.status = 0, this.response = {}, this.isAbort = !1, this.originalError = null, Object.setPrototypeOf(this, $2b3a5afb4a111d4d$export$dcaf143e197b2cd2.prototype), null !== e && "object" == typeof e && (this.url = "string" == typeof e.url ? e.url : "", this.status = "number" == typeof e.status ? e.status : 0, this.isAbort = !!e.isAbort, this.originalError = e.originalError, null !== e.response && "object" == typeof e.response ? this.response = e.response : null !== e.data && "object" == typeof e.data ? this.response = e.data : this.response = {}), this.originalError || e instanceof $2b3a5afb4a111d4d$export$dcaf143e197b2cd2 || (this.originalError = e), "undefined" != typeof DOMException && e instanceof DOMException && (this.isAbort = !0), this.name = "ClientResponseError " + this.status, this.message = this.response?.message, this.message || (this.isAbort ? this.message = "The request was autocancelled. You can find more info in https://github.com/pocketbase/js-sdk#auto-cancellation." : this.originalError?.cause?.message?.includes("ECONNREFUSED ::1") ? this.message = "Failed to connect to the PocketBase server. Try changing the SDK URL from localhost to 127.0.0.1 (https://github.com/pocketbase/js-sdk/issues/21)." : this.message = "Something went wrong while processing your request.");
    }
    get data() {
        return this.response;
    }
    toJSON() {
        return {
            ...this
        };
    }
}
const $2b3a5afb4a111d4d$var$e = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function $2b3a5afb4a111d4d$export$2314e25186e9360(e, t) {
    const s = {};
    if ("string" != typeof e) return s;
    const i = Object.assign({}, t || {}).decode || $2b3a5afb4a111d4d$var$defaultDecode;
    let n = 0;
    for(; n < e.length;){
        const t = e.indexOf("=", n);
        if (-1 === t) break;
        let r = e.indexOf(";", n);
        if (-1 === r) r = e.length;
        else if (r < t) {
            n = e.lastIndexOf(";", t - 1) + 1;
            continue;
        }
        const o = e.slice(n, t).trim();
        if (void 0 === s[o]) {
            let n = e.slice(t + 1, r).trim();
            34 === n.charCodeAt(0) && (n = n.slice(1, -1));
            try {
                s[o] = i(n);
            } catch (e) {
                s[o] = n;
            }
        }
        n = r + 1;
    }
    return s;
}
function $2b3a5afb4a111d4d$export$879d2f108927fb90(t, s, i) {
    const n = Object.assign({}, i || {}), r = n.encode || $2b3a5afb4a111d4d$var$defaultEncode;
    if (!$2b3a5afb4a111d4d$var$e.test(t)) throw new TypeError("argument name is invalid");
    const o = r(s);
    if (o && !$2b3a5afb4a111d4d$var$e.test(o)) throw new TypeError("argument val is invalid");
    let a = t + "=" + o;
    if (null != n.maxAge) {
        const e = n.maxAge - 0;
        if (isNaN(e) || !isFinite(e)) throw new TypeError("option maxAge is invalid");
        a += "; Max-Age=" + Math.floor(e);
    }
    if (n.domain) {
        if (!$2b3a5afb4a111d4d$var$e.test(n.domain)) throw new TypeError("option domain is invalid");
        a += "; Domain=" + n.domain;
    }
    if (n.path) {
        if (!$2b3a5afb4a111d4d$var$e.test(n.path)) throw new TypeError("option path is invalid");
        a += "; Path=" + n.path;
    }
    if (n.expires) {
        if (!function isDate(e) {
            return "[object Date]" === Object.prototype.toString.call(e) || e instanceof Date;
        }(n.expires) || isNaN(n.expires.valueOf())) throw new TypeError("option expires is invalid");
        a += "; Expires=" + n.expires.toUTCString();
    }
    if (n.httpOnly && (a += "; HttpOnly"), n.secure && (a += "; Secure"), n.priority) switch("string" == typeof n.priority ? n.priority.toLowerCase() : n.priority){
        case "low":
            a += "; Priority=Low";
            break;
        case "medium":
            a += "; Priority=Medium";
            break;
        case "high":
            a += "; Priority=High";
            break;
        default:
            throw new TypeError("option priority is invalid");
    }
    if (n.sameSite) switch("string" == typeof n.sameSite ? n.sameSite.toLowerCase() : n.sameSite){
        case !0:
            a += "; SameSite=Strict";
            break;
        case "lax":
            a += "; SameSite=Lax";
            break;
        case "strict":
            a += "; SameSite=Strict";
            break;
        case "none":
            a += "; SameSite=None";
            break;
        default:
            throw new TypeError("option sameSite is invalid");
    }
    return a;
}
function $2b3a5afb4a111d4d$var$defaultDecode(e) {
    return -1 !== e.indexOf("%") ? decodeURIComponent(e) : e;
}
function $2b3a5afb4a111d4d$var$defaultEncode(e) {
    return encodeURIComponent(e);
}
const $2b3a5afb4a111d4d$var$t = "undefined" != typeof navigator && "ReactNative" === navigator.product || "undefined" != typeof $parcel$global && $parcel$global.HermesInternal;
let $2b3a5afb4a111d4d$var$s;
function $2b3a5afb4a111d4d$export$26ddc56bc995240a(e) {
    if (e) try {
        const t = decodeURIComponent($2b3a5afb4a111d4d$var$s(e.split(".")[1]).split("").map(function(e) {
            return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(t) || {};
    } catch (e) {}
    return {};
}
function $2b3a5afb4a111d4d$export$b007d77a962aa175(e, t = 0) {
    let s = $2b3a5afb4a111d4d$export$26ddc56bc995240a(e);
    return !(Object.keys(s).length > 0 && (!s.exp || s.exp - t > Date.now() / 1e3));
}
$2b3a5afb4a111d4d$var$s = "function" != typeof atob || $2b3a5afb4a111d4d$var$t ? (e)=>{
    let t = String(e).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var s, i, n = 0, r = 0, o = ""; i = t.charAt(r++); ~i && (s = n % 4 ? 64 * s + i : i, n++ % 4) && (o += String.fromCharCode(255 & s >> (-2 * n & 6))))i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(i);
    return o;
} : atob;
const $2b3a5afb4a111d4d$var$i = "pb_auth";
class $2b3a5afb4a111d4d$export$68a044b9d3f6e888 {
    constructor(){
        this.baseToken = "", this.baseModel = null, this._onChangeCallbacks = [];
    }
    get token() {
        return this.baseToken;
    }
    get record() {
        return this.baseModel;
    }
    get model() {
        return this.baseModel;
    }
    get isValid() {
        return !$2b3a5afb4a111d4d$export$b007d77a962aa175(this.token);
    }
    get isSuperuser() {
        let e = $2b3a5afb4a111d4d$export$26ddc56bc995240a(this.token);
        return "auth" == e.type && ("_superusers" == this.record?.collectionName || !this.record?.collectionName && "pbc_3142635823" == e.collectionId);
    }
    get isAdmin() {
        return console.warn("Please replace pb.authStore.isAdmin with pb.authStore.isSuperuser OR simply check the value of pb.authStore.record?.collectionName"), this.isSuperuser;
    }
    get isAuthRecord() {
        return console.warn("Please replace pb.authStore.isAuthRecord with !pb.authStore.isSuperuser OR simply check the value of pb.authStore.record?.collectionName"), "auth" == $2b3a5afb4a111d4d$export$26ddc56bc995240a(this.token).type && !this.isSuperuser;
    }
    save(e, t) {
        this.baseToken = e || "", this.baseModel = t || null, this.triggerChange();
    }
    clear() {
        this.baseToken = "", this.baseModel = null, this.triggerChange();
    }
    loadFromCookie(e, t = $2b3a5afb4a111d4d$var$i) {
        const s = $2b3a5afb4a111d4d$export$2314e25186e9360(e || "")[t] || "";
        let n = {};
        try {
            n = JSON.parse(s), ("object" != typeof n || Array.isArray(n)) && (n = {});
        } catch (e) {}
        this.save(n.token || "", n.record || n.model || null);
    }
    exportToCookie(e, t = $2b3a5afb4a111d4d$var$i) {
        const s = {
            secure: !0,
            sameSite: !0,
            httpOnly: !0,
            path: "/"
        }, n = $2b3a5afb4a111d4d$export$26ddc56bc995240a(this.token);
        s.expires = n?.exp ? new Date(1e3 * n.exp) : new Date("1970-01-01"), e = Object.assign({}, s, e);
        const r = {
            token: this.token,
            record: this.record ? JSON.parse(JSON.stringify(this.record)) : null
        };
        let o = $2b3a5afb4a111d4d$export$879d2f108927fb90(t, JSON.stringify(r), e);
        const a = "undefined" != typeof Blob ? new Blob([
            o
        ]).size : o.length;
        if (r.record && a > 4096) {
            r.record = {
                id: r.record?.id,
                email: r.record?.email
            };
            const s = [
                "collectionId",
                "collectionName",
                "verified"
            ];
            for(const e in this.record)s.includes(e) && (r.record[e] = this.record[e]);
            o = $2b3a5afb4a111d4d$export$879d2f108927fb90(t, JSON.stringify(r), e);
        }
        return o;
    }
    onChange(e, t = !1) {
        return this._onChangeCallbacks.push(e), t && e(this.token, this.record), ()=>{
            for(let t = this._onChangeCallbacks.length - 1; t >= 0; t--)if (this._onChangeCallbacks[t] == e) return delete this._onChangeCallbacks[t], void this._onChangeCallbacks.splice(t, 1);
        };
    }
    triggerChange() {
        for (const e of this._onChangeCallbacks)e && e(this.token, this.record);
    }
}
class $2b3a5afb4a111d4d$export$6439a4b85bcd7f5d extends $2b3a5afb4a111d4d$export$68a044b9d3f6e888 {
    constructor(e = "pocketbase_auth"){
        super(), this.storageFallback = {}, this.storageKey = e, this._bindStorageEvent();
    }
    get token() {
        return (this._storageGet(this.storageKey) || {}).token || "";
    }
    get record() {
        const e = this._storageGet(this.storageKey) || {};
        return e.record || e.model || null;
    }
    get model() {
        return this.record;
    }
    save(e, t) {
        this._storageSet(this.storageKey, {
            token: e,
            record: t
        }), super.save(e, t);
    }
    clear() {
        this._storageRemove(this.storageKey), super.clear();
    }
    _storageGet(e) {
        if ("undefined" != typeof window && window?.localStorage) {
            const t = window.localStorage.getItem(e) || "";
            try {
                return JSON.parse(t);
            } catch (e) {
                return t;
            }
        }
        return this.storageFallback[e];
    }
    _storageSet(e, t) {
        if ("undefined" != typeof window && window?.localStorage) {
            let s = t;
            "string" != typeof t && (s = JSON.stringify(t)), window.localStorage.setItem(e, s);
        } else this.storageFallback[e] = t;
    }
    _storageRemove(e) {
        "undefined" != typeof window && window?.localStorage && window.localStorage?.removeItem(e), delete this.storageFallback[e];
    }
    _bindStorageEvent() {
        "undefined" != typeof window && window?.localStorage && window.addEventListener && window.addEventListener("storage", (e)=>{
            if (e.key != this.storageKey) return;
            const t = this._storageGet(this.storageKey) || {};
            super.save(t.token || "", t.record || t.model || null);
        });
    }
}
class $2b3a5afb4a111d4d$var$BaseService {
    constructor(e){
        this.client = e;
    }
}
class $2b3a5afb4a111d4d$var$SettingsService extends $2b3a5afb4a111d4d$var$BaseService {
    async getAll(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/settings", e);
    }
    async update(e, t) {
        return t = Object.assign({
            method: "PATCH",
            body: e
        }, t), this.client.send("/api/settings", t);
    }
    async testS3(e = "storage", t) {
        return t = Object.assign({
            method: "POST",
            body: {
                filesystem: e
            }
        }, t), this.client.send("/api/settings/test/s3", t).then(()=>!0);
    }
    async testEmail(e, t, s, i) {
        return i = Object.assign({
            method: "POST",
            body: {
                email: t,
                template: s,
                collection: e
            }
        }, i), this.client.send("/api/settings/test/email", i).then(()=>!0);
    }
    async generateAppleClientSecret(e, t, s, i, n, r) {
        return r = Object.assign({
            method: "POST",
            body: {
                clientId: e,
                teamId: t,
                keyId: s,
                privateKey: i,
                duration: n
            }
        }, r), this.client.send("/api/settings/apple/generate-client-secret", r);
    }
}
const $2b3a5afb4a111d4d$var$n = [
    "requestKey",
    "$cancelKey",
    "$autoCancel",
    "fetch",
    "headers",
    "body",
    "query",
    "params",
    "cache",
    "credentials",
    "headers",
    "integrity",
    "keepalive",
    "method",
    "mode",
    "redirect",
    "referrer",
    "referrerPolicy",
    "signal",
    "window"
];
function $2b3a5afb4a111d4d$export$d4eab50bd87f5014(e) {
    if (e) {
        e.query = e.query || {};
        for(let t in e)$2b3a5afb4a111d4d$var$n.includes(t) || (e.query[t] = e[t], delete e[t]);
    }
}
function $2b3a5afb4a111d4d$export$a2e7490059781fcf(e) {
    const t = [];
    for(const s in e){
        if (null === e[s]) continue;
        const i = e[s], n = encodeURIComponent(s);
        if (Array.isArray(i)) for (const e of i)t.push(n + "=" + encodeURIComponent(e));
        else i instanceof Date ? t.push(n + "=" + encodeURIComponent(i.toISOString())) : "object" == typeof i ? t.push(n + "=" + encodeURIComponent(JSON.stringify(i))) : t.push(n + "=" + encodeURIComponent(i));
    }
    return t.join("&");
}
class $2b3a5afb4a111d4d$export$94618cb2db738d0c extends $2b3a5afb4a111d4d$var$BaseService {
    constructor(){
        super(...arguments), this.clientId = "", this.eventSource = null, this.subscriptions = {}, this.lastSentSubscriptions = [], this.maxConnectTimeout = 15e3, this.reconnectAttempts = 0, this.maxReconnectAttempts = 1 / 0, this.predefinedReconnectIntervals = [
            200,
            300,
            500,
            1e3,
            1200,
            1500,
            2e3
        ], this.pendingConnects = [];
    }
    get isConnected() {
        return !!this.eventSource && !!this.clientId && !this.pendingConnects.length;
    }
    async subscribe(e, t, s) {
        if (!e) throw new Error("topic must be set.");
        let i = e;
        if (s) {
            $2b3a5afb4a111d4d$export$d4eab50bd87f5014(s = Object.assign({}, s));
            const e = "options=" + encodeURIComponent(JSON.stringify({
                query: s.query,
                headers: s.headers
            }));
            i += (i.includes("?") ? "&" : "?") + e;
        }
        const listener = function(e) {
            const s = e;
            let i;
            try {
                i = JSON.parse(s?.data);
            } catch  {}
            t(i || {});
        };
        return this.subscriptions[i] || (this.subscriptions[i] = []), this.subscriptions[i].push(listener), this.isConnected ? 1 === this.subscriptions[i].length ? await this.submitSubscriptions() : this.eventSource?.addEventListener(i, listener) : await this.connect(), async ()=>this.unsubscribeByTopicAndListener(e, listener);
    }
    async unsubscribe(e) {
        let t = !1;
        if (e) {
            const s = this.getSubscriptionsByTopic(e);
            for(let e in s)if (this.hasSubscriptionListeners(e)) {
                for (let t of this.subscriptions[e])this.eventSource?.removeEventListener(e, t);
                delete this.subscriptions[e], t || (t = !0);
            }
        } else this.subscriptions = {};
        this.hasSubscriptionListeners() ? t && await this.submitSubscriptions() : this.disconnect();
    }
    async unsubscribeByPrefix(e) {
        let t = !1;
        for(let s in this.subscriptions)if ((s + "?").startsWith(e)) {
            t = !0;
            for (let e of this.subscriptions[s])this.eventSource?.removeEventListener(s, e);
            delete this.subscriptions[s];
        }
        t && (this.hasSubscriptionListeners() ? await this.submitSubscriptions() : this.disconnect());
    }
    async unsubscribeByTopicAndListener(e, t) {
        let s = !1;
        const i = this.getSubscriptionsByTopic(e);
        for(let e in i){
            if (!Array.isArray(this.subscriptions[e]) || !this.subscriptions[e].length) continue;
            let i = !1;
            for(let s = this.subscriptions[e].length - 1; s >= 0; s--)this.subscriptions[e][s] === t && (i = !0, delete this.subscriptions[e][s], this.subscriptions[e].splice(s, 1), this.eventSource?.removeEventListener(e, t));
            i && (this.subscriptions[e].length || delete this.subscriptions[e], s || this.hasSubscriptionListeners(e) || (s = !0));
        }
        this.hasSubscriptionListeners() ? s && await this.submitSubscriptions() : this.disconnect();
    }
    hasSubscriptionListeners(e) {
        if (this.subscriptions = this.subscriptions || {}, e) return !!this.subscriptions[e]?.length;
        for(let e in this.subscriptions)if (this.subscriptions[e]?.length) return !0;
        return !1;
    }
    async submitSubscriptions() {
        if (this.clientId) return this.addAllSubscriptionListeners(), this.lastSentSubscriptions = this.getNonEmptySubscriptionKeys(), this.client.send("/api/realtime", {
            method: "POST",
            body: {
                clientId: this.clientId,
                subscriptions: this.lastSentSubscriptions
            },
            requestKey: this.getSubscriptionsCancelKey()
        }).catch((e)=>{
            if (!e?.isAbort) throw e;
        });
    }
    getSubscriptionsCancelKey() {
        return "realtime_" + this.clientId;
    }
    getSubscriptionsByTopic(e) {
        const t = {};
        e = e.includes("?") ? e : e + "?";
        for(let s in this.subscriptions)(s + "?").startsWith(e) && (t[s] = this.subscriptions[s]);
        return t;
    }
    getNonEmptySubscriptionKeys() {
        const e = [];
        for(let t in this.subscriptions)this.subscriptions[t].length && e.push(t);
        return e;
    }
    addAllSubscriptionListeners() {
        if (this.eventSource) {
            this.removeAllSubscriptionListeners();
            for(let e in this.subscriptions)for (let t of this.subscriptions[e])this.eventSource.addEventListener(e, t);
        }
    }
    removeAllSubscriptionListeners() {
        if (this.eventSource) for(let e in this.subscriptions)for (let t of this.subscriptions[e])this.eventSource.removeEventListener(e, t);
    }
    async connect() {
        if (!(this.reconnectAttempts > 0)) return new Promise((e, t)=>{
            this.pendingConnects.push({
                resolve: e,
                reject: t
            }), this.pendingConnects.length > 1 || this.initConnect();
        });
    }
    initConnect() {
        this.disconnect(!0), clearTimeout(this.connectTimeoutId), this.connectTimeoutId = setTimeout(()=>{
            this.connectErrorHandler(new Error("EventSource connect took too long."));
        }, this.maxConnectTimeout), this.eventSource = new EventSource(this.client.buildURL("/api/realtime")), this.eventSource.onerror = (e)=>{
            this.connectErrorHandler(new Error("Failed to establish realtime connection."));
        }, this.eventSource.addEventListener("PB_CONNECT", (e)=>{
            const t = e;
            this.clientId = t?.lastEventId, this.submitSubscriptions().then(async ()=>{
                let e = 3;
                for(; this.hasUnsentSubscriptions() && e > 0;)e--, await this.submitSubscriptions();
            }).then(()=>{
                for (let e of this.pendingConnects)e.resolve();
                this.pendingConnects = [], this.reconnectAttempts = 0, clearTimeout(this.reconnectTimeoutId), clearTimeout(this.connectTimeoutId);
                const t = this.getSubscriptionsByTopic("PB_CONNECT");
                for(let s in t)for (let i of t[s])i(e);
            }).catch((e)=>{
                this.clientId = "", this.connectErrorHandler(e);
            });
        });
    }
    hasUnsentSubscriptions() {
        const e = this.getNonEmptySubscriptionKeys();
        if (e.length != this.lastSentSubscriptions.length) return !0;
        for (const t of e)if (!this.lastSentSubscriptions.includes(t)) return !0;
        return !1;
    }
    connectErrorHandler(e) {
        if (clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), !this.clientId && !this.reconnectAttempts || this.reconnectAttempts > this.maxReconnectAttempts) {
            for (let t of this.pendingConnects)t.reject(new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2(e));
            return this.pendingConnects = [], void this.disconnect();
        }
        this.disconnect(!0);
        const t = this.predefinedReconnectIntervals[this.reconnectAttempts] || this.predefinedReconnectIntervals[this.predefinedReconnectIntervals.length - 1];
        this.reconnectAttempts++, this.reconnectTimeoutId = setTimeout(()=>{
            this.initConnect();
        }, t);
    }
    disconnect(e = !1) {
        if (clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), this.removeAllSubscriptionListeners(), this.client.cancelRequest(this.getSubscriptionsCancelKey()), this.eventSource?.close(), this.eventSource = null, this.clientId = "", !e) {
            this.reconnectAttempts = 0;
            for (let e of this.pendingConnects)e.resolve();
            this.pendingConnects = [];
        }
    }
}
class $2b3a5afb4a111d4d$export$d8ebe4a1f8b281ca extends $2b3a5afb4a111d4d$var$BaseService {
    decode(e) {
        return e;
    }
    async getFullList(e, t) {
        if ("number" == typeof e) return this._getFullList(e, t);
        let s = 500;
        return (t = Object.assign({}, e, t)).batch && (s = t.batch, delete t.batch), this._getFullList(s, t);
    }
    async getList(e = 1, t = 30, s) {
        return (s = Object.assign({
            method: "GET"
        }, s)).query = Object.assign({
            page: e,
            perPage: t
        }, s.query), this.client.send(this.baseCrudPath, s).then((e)=>(e.items = e.items?.map((e)=>this.decode(e)) || [], e));
    }
    async getFirstListItem(e, t) {
        return (t = Object.assign({
            requestKey: "one_by_filter_" + this.baseCrudPath + "_" + e
        }, t)).query = Object.assign({
            filter: e,
            skipTotal: 1
        }, t.query), this.getList(1, 1, t).then((e)=>{
            if (!e?.items?.length) throw new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2({
                status: 404,
                response: {
                    code: 404,
                    message: "The requested resource wasn't found.",
                    data: {}
                }
            });
            return e.items[0];
        });
    }
    async getOne(e, t) {
        if (!e) throw new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2({
            url: this.client.buildURL(this.baseCrudPath + "/"),
            status: 404,
            response: {
                code: 404,
                message: "Missing required record id.",
                data: {}
            }
        });
        return t = Object.assign({
            method: "GET"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), t).then((e)=>this.decode(e));
    }
    async create(e, t) {
        return t = Object.assign({
            method: "POST",
            body: e
        }, t), this.client.send(this.baseCrudPath, t).then((e)=>this.decode(e));
    }
    async update(e, t, s) {
        return s = Object.assign({
            method: "PATCH",
            body: t
        }, s), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), s).then((e)=>this.decode(e));
    }
    async delete(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), t).then(()=>!0);
    }
    _getFullList(e = 500, t) {
        (t = t || {}).query = Object.assign({
            skipTotal: 1
        }, t.query);
        let s = [], request = async (i)=>this.getList(i, e || 500, t).then((e)=>{
                const t = e.items;
                return s = s.concat(t), t.length == e.perPage ? request(i + 1) : s;
            });
        return request(1);
    }
}
function $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs(e, t, s, i) {
    const n = void 0 !== i;
    return n || void 0 !== s ? n ? (console.warn(e), t.body = Object.assign({}, t.body, s), t.query = Object.assign({}, t.query, i), t) : Object.assign(t, s) : t;
}
function $2b3a5afb4a111d4d$var$resetAutoRefresh(e) {
    e._resetAutoRefresh?.();
}
class $2b3a5afb4a111d4d$export$1b7d28e1ebf40328 extends $2b3a5afb4a111d4d$export$d8ebe4a1f8b281ca {
    constructor(e, t){
        super(e), this.collectionIdOrName = t;
    }
    get baseCrudPath() {
        return this.baseCollectionPath + "/records";
    }
    get baseCollectionPath() {
        return "/api/collections/" + encodeURIComponent(this.collectionIdOrName);
    }
    get isSuperusers() {
        return "_superusers" == this.collectionIdOrName || "_pbc_2773867675" == this.collectionIdOrName;
    }
    async subscribe(e, t, s) {
        if (!e) throw new Error("Missing topic.");
        if (!t) throw new Error("Missing subscription callback.");
        return this.client.realtime.subscribe(this.collectionIdOrName + "/" + e, t, s);
    }
    async unsubscribe(e) {
        return e ? this.client.realtime.unsubscribe(this.collectionIdOrName + "/" + e) : this.client.realtime.unsubscribeByPrefix(this.collectionIdOrName);
    }
    async getFullList(e, t) {
        if ("number" == typeof e) return super.getFullList(e, t);
        const s = Object.assign({}, e, t);
        return super.getFullList(s);
    }
    async getList(e = 1, t = 30, s) {
        return super.getList(e, t, s);
    }
    async getFirstListItem(e, t) {
        return super.getFirstListItem(e, t);
    }
    async getOne(e, t) {
        return super.getOne(e, t);
    }
    async create(e, t) {
        return super.create(e, t);
    }
    async update(e, t, s) {
        return super.update(e, t, s).then((e)=>{
            if (this.client.authStore.record?.id === e?.id && (this.client.authStore.record?.collectionId === this.collectionIdOrName || this.client.authStore.record?.collectionName === this.collectionIdOrName)) {
                let t = Object.assign({}, this.client.authStore.record.expand), s = Object.assign({}, this.client.authStore.record, e);
                t && (s.expand = Object.assign(t, e.expand)), this.client.authStore.save(this.client.authStore.token, s);
            }
            return e;
        });
    }
    async delete(e, t) {
        return super.delete(e, t).then((t)=>(!t || this.client.authStore.record?.id !== e || this.client.authStore.record?.collectionId !== this.collectionIdOrName && this.client.authStore.record?.collectionName !== this.collectionIdOrName || this.client.authStore.clear(), t));
    }
    authResponse(e) {
        const t = this.decode(e?.record || {});
        return this.client.authStore.save(e?.token, t), Object.assign({}, e, {
            token: e?.token || "",
            record: t
        });
    }
    async listAuthMethods(e) {
        return e = Object.assign({
            method: "GET",
            fields: "mfa,otp,password,oauth2"
        }, e), this.client.send(this.baseCollectionPath + "/auth-methods", e);
    }
    async authWithPassword(e, t, s) {
        let i;
        s = Object.assign({
            method: "POST",
            body: {
                identity: e,
                password: t
            }
        }, s), this.isSuperusers && (i = s.autoRefreshThreshold, delete s.autoRefreshThreshold, s.autoRefresh || $2b3a5afb4a111d4d$var$resetAutoRefresh(this.client));
        let n = await this.client.send(this.baseCollectionPath + "/auth-with-password", s);
        return n = this.authResponse(n), i && this.isSuperusers && function registerAutoRefresh(e, t, s, i) {
            $2b3a5afb4a111d4d$var$resetAutoRefresh(e);
            const n = e.beforeSend, r = e.authStore.record, o = e.authStore.onChange((t, s)=>{
                (!t || s?.id != r?.id || (s?.collectionId || r?.collectionId) && s?.collectionId != r?.collectionId) && $2b3a5afb4a111d4d$var$resetAutoRefresh(e);
            });
            e._resetAutoRefresh = function() {
                o(), e.beforeSend = n, delete e._resetAutoRefresh;
            }, e.beforeSend = async (r, o)=>{
                const a = e.authStore.token;
                if (o.query?.autoRefresh) return n ? n(r, o) : {
                    url: r,
                    sendOptions: o
                };
                let c = e.authStore.isValid;
                if (c && $2b3a5afb4a111d4d$export$b007d77a962aa175(e.authStore.token, t)) try {
                    await s();
                } catch (e) {
                    c = !1;
                }
                c || await i();
                const l = o.headers || {};
                for(let t in l)if ("authorization" == t.toLowerCase() && a == l[t] && e.authStore.token) {
                    l[t] = e.authStore.token;
                    break;
                }
                return o.headers = l, n ? n(r, o) : {
                    url: r,
                    sendOptions: o
                };
            };
        }(this.client, i, ()=>this.authRefresh({
                autoRefresh: !0
            }), ()=>this.authWithPassword(e, t, Object.assign({
                autoRefresh: !0
            }, s))), n;
    }
    async authWithOAuth2Code(e, t, s, i, n, r, o) {
        let a = {
            method: "POST",
            body: {
                provider: e,
                code: t,
                codeVerifier: s,
                redirectURL: i,
                createData: n
            }
        };
        return a = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of authWithOAuth2Code(provider, code, codeVerifier, redirectURL, createData?, body?, query?) is deprecated. Consider replacing it with authWithOAuth2Code(provider, code, codeVerifier, redirectURL, createData?, options?).", a, r, o), this.client.send(this.baseCollectionPath + "/auth-with-oauth2", a).then((e)=>this.authResponse(e));
    }
    authWithOAuth2(...e) {
        if (e.length > 1 || "string" == typeof e?.[0]) return console.warn("PocketBase: This form of authWithOAuth2() is deprecated and may get removed in the future. Please replace with authWithOAuth2Code() OR use the authWithOAuth2() realtime form as shown in https://pocketbase.io/docs/authentication/#oauth2-integration."), this.authWithOAuth2Code(e?.[0] || "", e?.[1] || "", e?.[2] || "", e?.[3] || "", e?.[4] || {}, e?.[5] || {}, e?.[6] || {});
        const t = e?.[0] || {};
        let s = null;
        t.urlCallback || (s = $2b3a5afb4a111d4d$var$openBrowserPopup(void 0));
        const i = new $2b3a5afb4a111d4d$export$94618cb2db738d0c(this.client);
        function cleanup() {
            s?.close(), i.unsubscribe();
        }
        const n = {}, r = t.requestKey;
        return r && (n.requestKey = r), this.listAuthMethods(n).then((e)=>{
            const n = e.oauth2.providers.find((e)=>e.name === t.provider);
            if (!n) throw new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2(new Error(`Missing or invalid provider "${t.provider}".`));
            const o = this.client.buildURL("/api/oauth2-redirect"), a = r ? this.client.cancelControllers?.[r] : void 0;
            return a && (a.signal.onabort = ()=>{
                cleanup();
            }), new Promise(async (e, r)=>{
                try {
                    await i.subscribe("@oauth2", async (s)=>{
                        const c = i.clientId;
                        try {
                            if (!s.state || c !== s.state) throw new Error("State parameters don't match.");
                            if (s.error || !s.code) throw new Error("OAuth2 redirect error or missing code: " + s.error);
                            const i = Object.assign({}, t);
                            delete i.provider, delete i.scopes, delete i.createData, delete i.urlCallback, a?.signal?.onabort && (a.signal.onabort = null);
                            const r = await this.authWithOAuth2Code(n.name, s.code, n.codeVerifier, o, t.createData, i);
                            e(r);
                        } catch (e) {
                            r(new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2(e));
                        }
                        cleanup();
                    });
                    const c = {
                        state: i.clientId
                    };
                    t.scopes?.length && (c.scope = t.scopes.join(" "));
                    const l = this._replaceQueryParams(n.authURL + o, c);
                    let h = t.urlCallback || function(e) {
                        s ? s.location.href = e : s = $2b3a5afb4a111d4d$var$openBrowserPopup(e);
                    };
                    await h(l);
                } catch (e) {
                    cleanup(), r(new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2(e));
                }
            });
        }).catch((e)=>{
            throw cleanup(), e;
        });
    }
    async authRefresh(e, t) {
        let s = {
            method: "POST"
        };
        return s = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of authRefresh(body?, query?) is deprecated. Consider replacing it with authRefresh(options?).", s, e, t), this.client.send(this.baseCollectionPath + "/auth-refresh", s).then((e)=>this.authResponse(e));
    }
    async requestPasswordReset(e, t, s) {
        let i = {
            method: "POST",
            body: {
                email: e
            }
        };
        return i = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of requestPasswordReset(email, body?, query?) is deprecated. Consider replacing it with requestPasswordReset(email, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-password-reset", i).then(()=>!0);
    }
    async confirmPasswordReset(e, t, s, i, n) {
        let r = {
            method: "POST",
            body: {
                token: e,
                password: t,
                passwordConfirm: s
            }
        };
        return r = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of confirmPasswordReset(token, password, passwordConfirm, body?, query?) is deprecated. Consider replacing it with confirmPasswordReset(token, password, passwordConfirm, options?).", r, i, n), this.client.send(this.baseCollectionPath + "/confirm-password-reset", r).then(()=>!0);
    }
    async requestVerification(e, t, s) {
        let i = {
            method: "POST",
            body: {
                email: e
            }
        };
        return i = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of requestVerification(email, body?, query?) is deprecated. Consider replacing it with requestVerification(email, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-verification", i).then(()=>!0);
    }
    async confirmVerification(e, t, s) {
        let i = {
            method: "POST",
            body: {
                token: e
            }
        };
        return i = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of confirmVerification(token, body?, query?) is deprecated. Consider replacing it with confirmVerification(token, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/confirm-verification", i).then(()=>{
            const t = $2b3a5afb4a111d4d$export$26ddc56bc995240a(e), s = this.client.authStore.record;
            return s && !s.verified && s.id === t.id && s.collectionId === t.collectionId && (s.verified = !0, this.client.authStore.save(this.client.authStore.token, s)), !0;
        });
    }
    async requestEmailChange(e, t, s) {
        let i = {
            method: "POST",
            body: {
                newEmail: e
            }
        };
        return i = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of requestEmailChange(newEmail, body?, query?) is deprecated. Consider replacing it with requestEmailChange(newEmail, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-email-change", i).then(()=>!0);
    }
    async confirmEmailChange(e, t, s, i) {
        let n = {
            method: "POST",
            body: {
                token: e,
                password: t
            }
        };
        return n = $2b3a5afb4a111d4d$var$normalizeLegacyOptionsArgs("This form of confirmEmailChange(token, password, body?, query?) is deprecated. Consider replacing it with confirmEmailChange(token, password, options?).", n, s, i), this.client.send(this.baseCollectionPath + "/confirm-email-change", n).then(()=>{
            const t = $2b3a5afb4a111d4d$export$26ddc56bc995240a(e), s = this.client.authStore.record;
            return s && s.id === t.id && s.collectionId === t.collectionId && this.client.authStore.clear(), !0;
        });
    }
    async listExternalAuths(e, t) {
        return this.client.collection("_externalAuths").getFullList(Object.assign({}, t, {
            filter: this.client.filter("recordRef = {:id}", {
                id: e
            })
        }));
    }
    async unlinkExternalAuth(e, t, s) {
        const i = await this.client.collection("_externalAuths").getFirstListItem(this.client.filter("recordRef = {:recordId} && provider = {:provider}", {
            recordId: e,
            provider: t
        }));
        return this.client.collection("_externalAuths").delete(i.id, s).then(()=>!0);
    }
    async requestOTP(e, t) {
        return t = Object.assign({
            method: "POST",
            body: {
                email: e
            }
        }, t), this.client.send(this.baseCollectionPath + "/request-otp", t);
    }
    async authWithOTP(e, t, s) {
        return s = Object.assign({
            method: "POST",
            body: {
                otpId: e,
                password: t
            }
        }, s), this.client.send(this.baseCollectionPath + "/auth-with-otp", s).then((e)=>this.authResponse(e));
    }
    async impersonate(e, t, s) {
        (s = Object.assign({
            method: "POST",
            body: {
                duration: t
            }
        }, s)).headers = s.headers || {}, s.headers.Authorization || (s.headers.Authorization = this.client.authStore.token);
        const i = new $2b3a5afb4a111d4d$export$2e2bcd8739ae039(this.client.baseURL, new $2b3a5afb4a111d4d$export$68a044b9d3f6e888, this.client.lang), n = await i.send(this.baseCollectionPath + "/impersonate/" + encodeURIComponent(e), s);
        return i.authStore.save(n?.token, this.decode(n?.record || {})), i;
    }
    _replaceQueryParams(e, t = {}) {
        let s = e, i = "";
        e.indexOf("?") >= 0 && (s = e.substring(0, e.indexOf("?")), i = e.substring(e.indexOf("?") + 1));
        const n = {}, r = i.split("&");
        for (const e of r){
            if ("" == e) continue;
            const t = e.split("=");
            n[decodeURIComponent(t[0].replace(/\+/g, " "))] = decodeURIComponent((t[1] || "").replace(/\+/g, " "));
        }
        for(let e in t)t.hasOwnProperty(e) && (null == t[e] ? delete n[e] : n[e] = t[e]);
        i = "";
        for(let e in n)n.hasOwnProperty(e) && ("" != i && (i += "&"), i += encodeURIComponent(e.replace(/%20/g, "+")) + "=" + encodeURIComponent(n[e].replace(/%20/g, "+")));
        return "" != i ? s + "?" + i : s;
    }
}
function $2b3a5afb4a111d4d$var$openBrowserPopup(e) {
    if ("undefined" == typeof window || !window?.open) throw new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2(new Error("Not in a browser context - please pass a custom urlCallback function."));
    let t = 1024, s = 768, i = window.innerWidth, n = window.innerHeight;
    t = t > i ? i : t, s = s > n ? n : s;
    let r = i / 2 - t / 2, o = n / 2 - s / 2;
    return window.open(e, "popup_window", "width=" + t + ",height=" + s + ",top=" + o + ",left=" + r + ",resizable,menubar=no");
}
class $2b3a5afb4a111d4d$export$133889e600929275 extends $2b3a5afb4a111d4d$export$d8ebe4a1f8b281ca {
    get baseCrudPath() {
        return "/api/collections";
    }
    async import(e, t = !1, s) {
        return s = Object.assign({
            method: "PUT",
            body: {
                collections: e,
                deleteMissing: t
            }
        }, s), this.client.send(this.baseCrudPath + "/import", s).then(()=>!0);
    }
    async getScaffolds(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send(this.baseCrudPath + "/meta/scaffolds", e);
    }
    async truncate(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e) + "/truncate", t).then(()=>!0);
    }
}
class $2b3a5afb4a111d4d$export$e2c5c1c0df6e287f extends $2b3a5afb4a111d4d$var$BaseService {
    async getList(e = 1, t = 30, s) {
        return (s = Object.assign({
            method: "GET"
        }, s)).query = Object.assign({
            page: e,
            perPage: t
        }, s.query), this.client.send("/api/logs", s);
    }
    async getOne(e, t) {
        if (!e) throw new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2({
            url: this.client.buildURL("/api/logs/"),
            status: 404,
            response: {
                code: 404,
                message: "Missing required log id.",
                data: {}
            }
        });
        return t = Object.assign({
            method: "GET"
        }, t), this.client.send("/api/logs/" + encodeURIComponent(e), t);
    }
    async getStats(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/logs/stats", e);
    }
}
class $2b3a5afb4a111d4d$export$4fba2293eb4aeaad extends $2b3a5afb4a111d4d$var$BaseService {
    async check(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/health", e);
    }
}
class $2b3a5afb4a111d4d$var$FileService extends $2b3a5afb4a111d4d$var$BaseService {
    getUrl(e, t, s = {}) {
        return console.warn("Please replace pb.files.getUrl() with pb.files.getURL()"), this.getURL(e, t, s);
    }
    getURL(e, t, s = {}) {
        if (!t || !e?.id || !e?.collectionId && !e?.collectionName) return "";
        const i = [];
        i.push("api"), i.push("files"), i.push(encodeURIComponent(e.collectionId || e.collectionName)), i.push(encodeURIComponent(e.id)), i.push(encodeURIComponent(t));
        let n = this.client.buildURL(i.join("/"));
        if (Object.keys(s).length) {
            !1 === s.download && delete s.download;
            const e = new URLSearchParams(s);
            n += (n.includes("?") ? "&" : "?") + e;
        }
        return n;
    }
    async getToken(e) {
        return e = Object.assign({
            method: "POST"
        }, e), this.client.send("/api/files/token", e).then((e)=>e?.token || "");
    }
}
class $2b3a5afb4a111d4d$var$BackupService extends $2b3a5afb4a111d4d$var$BaseService {
    async getFullList(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/backups", e);
    }
    async create(e, t) {
        return t = Object.assign({
            method: "POST",
            body: {
                name: e
            }
        }, t), this.client.send("/api/backups", t).then(()=>!0);
    }
    async upload(e, t) {
        return t = Object.assign({
            method: "POST",
            body: e
        }, t), this.client.send("/api/backups/upload", t).then(()=>!0);
    }
    async delete(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(`/api/backups/${encodeURIComponent(e)}`, t).then(()=>!0);
    }
    async restore(e, t) {
        return t = Object.assign({
            method: "POST"
        }, t), this.client.send(`/api/backups/${encodeURIComponent(e)}/restore`, t).then(()=>!0);
    }
    getDownloadUrl(e, t) {
        return console.warn("Please replace pb.backups.getDownloadUrl() with pb.backups.getDownloadURL()"), this.getDownloadURL(e, t);
    }
    getDownloadURL(e, t) {
        return this.client.buildURL(`/api/backups/${encodeURIComponent(t)}?token=${encodeURIComponent(e)}`);
    }
}
function $2b3a5afb4a111d4d$var$isFile(e) {
    return "undefined" != typeof Blob && e instanceof Blob || "undefined" != typeof File && e instanceof File || null !== e && "object" == typeof e && e.uri && ("undefined" != typeof navigator && "ReactNative" === navigator.product || "undefined" != typeof $parcel$global && $parcel$global.HermesInternal);
}
function $2b3a5afb4a111d4d$var$isFormData(e) {
    return e && ("FormData" === e.constructor.name || "undefined" != typeof FormData && e instanceof FormData);
}
function $2b3a5afb4a111d4d$var$hasFileField(e) {
    for(const t in e){
        const s = Array.isArray(e[t]) ? e[t] : [
            e[t]
        ];
        for (const e of s)if ($2b3a5afb4a111d4d$var$isFile(e)) return !0;
    }
    return !1;
}
class $2b3a5afb4a111d4d$export$c161353d28232608 extends $2b3a5afb4a111d4d$var$BaseService {
    constructor(){
        super(...arguments), this.requests = [], this.subs = {};
    }
    collection(e) {
        return this.subs[e] || (this.subs[e] = new $2b3a5afb4a111d4d$export$a17dc285df58a3a1(this.requests, e)), this.subs[e];
    }
    async send(e) {
        const t = new FormData, s = [];
        for(let e = 0; e < this.requests.length; e++){
            const i = this.requests[e];
            if (s.push({
                method: i.method,
                url: i.url,
                headers: i.headers,
                body: i.json
            }), i.files) for(let s in i.files){
                const n = i.files[s] || [];
                for (let i of n)t.append("requests." + e + "." + s, i);
            }
        }
        return t.append("@jsonPayload", JSON.stringify({
            requests: s
        })), e = Object.assign({
            method: "POST",
            body: t
        }, e), this.client.send("/api/batch", e);
    }
}
class $2b3a5afb4a111d4d$export$a17dc285df58a3a1 {
    constructor(e, t){
        this.requests = [], this.requests = e, this.collectionIdOrName = t;
    }
    upsert(e, t) {
        t = Object.assign({
            body: e || {}
        }, t);
        const s = {
            method: "PUT",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records"
        };
        this.prepareRequest(s, t), this.requests.push(s);
    }
    create(e, t) {
        t = Object.assign({
            body: e || {}
        }, t);
        const s = {
            method: "POST",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records"
        };
        this.prepareRequest(s, t), this.requests.push(s);
    }
    update(e, t, s) {
        s = Object.assign({
            body: t || {}
        }, s);
        const i = {
            method: "PATCH",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records/" + encodeURIComponent(e)
        };
        this.prepareRequest(i, s), this.requests.push(i);
    }
    delete(e, t) {
        t = Object.assign({}, t);
        const s = {
            method: "DELETE",
            url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records/" + encodeURIComponent(e)
        };
        this.prepareRequest(s, t), this.requests.push(s);
    }
    prepareRequest(e, t) {
        if ($2b3a5afb4a111d4d$export$d4eab50bd87f5014(t), e.headers = t.headers, e.json = {}, e.files = {}, void 0 !== t.query) {
            const s = $2b3a5afb4a111d4d$export$a2e7490059781fcf(t.query);
            s && (e.url += (e.url.includes("?") ? "&" : "?") + s);
        }
        for(const s in t.body){
            const i = t.body[s];
            if ($2b3a5afb4a111d4d$var$isFile(i)) e.files[s] = e.files[s] || [], e.files[s].push(i);
            else if (Array.isArray(i)) {
                const t = [], n = [];
                for (const e of i)$2b3a5afb4a111d4d$var$isFile(e) ? t.push(e) : n.push(e);
                if (t.length > 0 && t.length == i.length) {
                    e.files[s] = e.files[s] || [];
                    for (let i of t)e.files[s].push(i);
                } else if (e.json[s] = n, t.length > 0) {
                    let i = s;
                    s.startsWith("+") || s.endsWith("+") || (i += "+"), e.files[i] = e.files[i] || [];
                    for (let s of t)e.files[i].push(s);
                }
            } else e.json[s] = i;
        }
    }
}
class $2b3a5afb4a111d4d$export$2e2bcd8739ae039 {
    get baseUrl() {
        return this.baseURL;
    }
    set baseUrl(e) {
        this.baseURL = e;
    }
    constructor(e = "/", t, s = "en-US"){
        this.cancelControllers = {}, this.recordServices = {}, this.enableAutoCancellation = !0, this.baseURL = e, this.lang = s, t ? this.authStore = t : "undefined" != typeof window && window.Deno ? this.authStore = new $2b3a5afb4a111d4d$export$68a044b9d3f6e888 : this.authStore = new $2b3a5afb4a111d4d$export$6439a4b85bcd7f5d, this.collections = new $2b3a5afb4a111d4d$export$133889e600929275(this), this.files = new $2b3a5afb4a111d4d$var$FileService(this), this.logs = new $2b3a5afb4a111d4d$export$e2c5c1c0df6e287f(this), this.settings = new $2b3a5afb4a111d4d$var$SettingsService(this), this.realtime = new $2b3a5afb4a111d4d$export$94618cb2db738d0c(this), this.health = new $2b3a5afb4a111d4d$export$4fba2293eb4aeaad(this), this.backups = new $2b3a5afb4a111d4d$var$BackupService(this);
    }
    get admins() {
        return this.collection("_superusers");
    }
    createBatch() {
        return new $2b3a5afb4a111d4d$export$c161353d28232608(this);
    }
    collection(e) {
        return this.recordServices[e] || (this.recordServices[e] = new $2b3a5afb4a111d4d$export$1b7d28e1ebf40328(this, e)), this.recordServices[e];
    }
    autoCancellation(e) {
        return this.enableAutoCancellation = !!e, this;
    }
    cancelRequest(e) {
        return this.cancelControllers[e] && (this.cancelControllers[e].abort(), delete this.cancelControllers[e]), this;
    }
    cancelAllRequests() {
        for(let e in this.cancelControllers)this.cancelControllers[e].abort();
        return this.cancelControllers = {}, this;
    }
    filter(e, t) {
        if (!t) return e;
        for(let s in t){
            let i = t[s];
            switch(typeof i){
                case "boolean":
                case "number":
                    i = "" + i;
                    break;
                case "string":
                    i = "'" + i.replace(/'/g, "\\'") + "'";
                    break;
                default:
                    i = null === i ? "null" : i instanceof Date ? "'" + i.toISOString().replace("T", " ") + "'" : "'" + JSON.stringify(i).replace(/'/g, "\\'") + "'";
            }
            e = e.replaceAll("{:" + s + "}", i);
        }
        return e;
    }
    getFileUrl(e, t, s = {}) {
        return console.warn("Please replace pb.getFileUrl() with pb.files.getURL()"), this.files.getURL(e, t, s);
    }
    buildUrl(e) {
        return console.warn("Please replace pb.buildUrl() with pb.buildURL()"), this.buildURL(e);
    }
    buildURL(e) {
        let t = this.baseURL;
        return "undefined" == typeof window || !window.location || t.startsWith("https://") || t.startsWith("http://") || (t = window.location.origin?.endsWith("/") ? window.location.origin.substring(0, window.location.origin.length - 1) : window.location.origin || "", this.baseURL.startsWith("/") || (t += window.location.pathname || "/", t += t.endsWith("/") ? "" : "/"), t += this.baseURL), e && (t += t.endsWith("/") ? "" : "/", t += e.startsWith("/") ? e.substring(1) : e), t;
    }
    async send(e, t) {
        t = this.initSendOptions(e, t);
        let s = this.buildURL(e);
        if (this.beforeSend) {
            const e = Object.assign({}, await this.beforeSend(s, t));
            void 0 !== e.url || void 0 !== e.options ? (s = e.url || s, t = e.options || t) : Object.keys(e).length && (t = e, console?.warn && console.warn("Deprecated format of beforeSend return: please use `return { url, options }`, instead of `return options`."));
        }
        if (void 0 !== t.query) {
            const e = $2b3a5afb4a111d4d$export$a2e7490059781fcf(t.query);
            e && (s += (s.includes("?") ? "&" : "?") + e), delete t.query;
        }
        "application/json" == this.getHeader(t.headers, "Content-Type") && t.body && "string" != typeof t.body && (t.body = JSON.stringify(t.body));
        return (t.fetch || fetch)(s, t).then(async (e)=>{
            let s = {};
            try {
                s = await e.json();
            } catch (e) {}
            if (this.afterSend && (s = await this.afterSend(e, s, t)), e.status >= 400) throw new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2({
                url: e.url,
                status: e.status,
                data: s
            });
            return s;
        }).catch((e)=>{
            throw new $2b3a5afb4a111d4d$export$dcaf143e197b2cd2(e);
        });
    }
    initSendOptions(e, t) {
        if ((t = Object.assign({
            method: "GET"
        }, t)).body = function convertToFormDataIfNeeded(e) {
            if ("undefined" == typeof FormData || void 0 === e || "object" != typeof e || null === e || $2b3a5afb4a111d4d$var$isFormData(e) || !$2b3a5afb4a111d4d$var$hasFileField(e)) return e;
            const t = new FormData;
            for(const s in e){
                const i = e[s];
                if ("object" != typeof i || $2b3a5afb4a111d4d$var$hasFileField({
                    data: i
                })) {
                    const e = Array.isArray(i) ? i : [
                        i
                    ];
                    for (let i of e)t.append(s, i);
                } else {
                    let e = {};
                    e[s] = i, t.append("@jsonPayload", JSON.stringify(e));
                }
            }
            return t;
        }(t.body), $2b3a5afb4a111d4d$export$d4eab50bd87f5014(t), t.query = Object.assign({}, t.params, t.query), void 0 === t.requestKey && (!1 === t.$autoCancel || !1 === t.query.$autoCancel ? t.requestKey = null : (t.$cancelKey || t.query.$cancelKey) && (t.requestKey = t.$cancelKey || t.query.$cancelKey)), delete t.$autoCancel, delete t.query.$autoCancel, delete t.$cancelKey, delete t.query.$cancelKey, null !== this.getHeader(t.headers, "Content-Type") || $2b3a5afb4a111d4d$var$isFormData(t.body) || (t.headers = Object.assign({}, t.headers, {
            "Content-Type": "application/json"
        })), null === this.getHeader(t.headers, "Accept-Language") && (t.headers = Object.assign({}, t.headers, {
            "Accept-Language": this.lang
        })), this.authStore.token && null === this.getHeader(t.headers, "Authorization") && (t.headers = Object.assign({}, t.headers, {
            Authorization: this.authStore.token
        })), this.enableAutoCancellation && null !== t.requestKey) {
            const s = t.requestKey || (t.method || "GET") + e;
            delete t.requestKey, this.cancelRequest(s);
            const i = new AbortController;
            this.cancelControllers[s] = i, t.signal = i.signal;
        }
        return t;
    }
    getHeader(e, t) {
        e = e || {}, t = t.toLowerCase();
        for(let s in e)if (s.toLowerCase() == t) return e[s];
        return null;
    }
}
class $2b3a5afb4a111d4d$export$c94662ed41386ffd extends $2b3a5afb4a111d4d$export$68a044b9d3f6e888 {
    constructor(e){
        super(), this.queue = [], this.saveFunc = e.save, this.clearFunc = e.clear, this._enqueue(()=>this._loadInitial(e.initial));
    }
    save(e, t) {
        super.save(e, t);
        let s = "";
        try {
            s = JSON.stringify({
                token: e,
                record: t
            });
        } catch (e) {
            console.warn("AsyncAuthStore: failed to stringify the new state");
        }
        this._enqueue(()=>this.saveFunc(s));
    }
    clear() {
        super.clear(), this.clearFunc ? this._enqueue(()=>this.clearFunc()) : this._enqueue(()=>this.saveFunc(""));
    }
    async _loadInitial(e) {
        try {
            if (e = await e) {
                let t;
                "string" == typeof e ? t = JSON.parse(e) || {} : "object" == typeof e && (t = e), this.save(t.token || "", t.record || t.model || null);
            }
        } catch (e) {}
    }
    _enqueue(e) {
        this.queue.push(e), 1 == this.queue.length && this._dequeue();
    }
    _dequeue() {
        this.queue.length && this.queue[0]().finally(()=>{
            this.queue.shift(), this.queue.length && this._dequeue();
        });
    }
}


var $76db654e514e8d39$exports = {};
(function(self1) {
    var irrelevant = function(exports) {
        var global = typeof globalThis !== 'undefined' && globalThis || typeof self1 !== 'undefined' && self1 || typeof global !== 'undefined' && global;
        var support = {
            searchParams: 'URLSearchParams' in global,
            iterable: 'Symbol' in global && 'iterator' in Symbol,
            blob: 'FileReader' in global && 'Blob' in global && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in global,
            arrayBuffer: 'ArrayBuffer' in global
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports.DOMException = global.DOMException;
        try {
            new exports.DOMException();
        } catch (err) {
            exports.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports.DOMException.prototype = Object.create(Error.prototype);
            exports.DOMException.prototype.constructor = exports.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && global.location.href ? global.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!global.fetch) {
            global.fetch = fetch;
            global.Headers = Headers;
            global.Request = Request;
            global.Response = Response;
        }
        exports.Headers = Headers;
        exports.Request = Request;
        exports.Response = Response;
        exports.fetch = fetch;
        return exports;
    }({});
})(typeof self !== 'undefined' ? self : $76db654e514e8d39$exports);


/**
 * Logtail library options
 */ var $4559429c2cf1b332$export$243e62d78d3b544d;
(function(LogLevel) {
    // core log levels - available as functions
    LogLevel["Error"] = "error";
    LogLevel["Warn"] = "warn";
    LogLevel["Info"] = "info";
    LogLevel["Debug"] = "debug";
    // extra log levels - recognized when passed from logging frameworks
    LogLevel["Fatal"] = "fatal";
    LogLevel["Http"] = "http";
    LogLevel["Verbose"] = "verbose";
    LogLevel["Silly"] = "silly";
    LogLevel["Trace"] = "trace";
})($4559429c2cf1b332$export$243e62d78d3b544d || ($4559429c2cf1b332$export$243e62d78d3b544d = {}));


/*
 * Default buffer size
 */ const $bbb3034d5be4d3a9$var$DEFAULT_BUFFER_SIZE = 1000;
/*
 * Default flush timeout
 */ const $bbb3034d5be4d3a9$var$DEFAULT_FLUSH_TIMEOUT = 1000;
/*
 * Default retry count
 */ const $bbb3034d5be4d3a9$var$DEFAULT_RETRY_COUNT = 3;
/*
 * Default retry backoff
 */ const $bbb3034d5be4d3a9$var$DEFAULT_RETRY_BACKOFF = 100;
const $bbb3034d5be4d3a9$export$a8bbed3c2f27a07 = (log)=>JSON.stringify(log).length + 1;
function $bbb3034d5be4d3a9$export$2e2bcd8739ae039(size = $bbb3034d5be4d3a9$var$DEFAULT_BUFFER_SIZE, flushTimeout = $bbb3034d5be4d3a9$var$DEFAULT_FLUSH_TIMEOUT, retryCount = $bbb3034d5be4d3a9$var$DEFAULT_RETRY_COUNT, retryBackoff = $bbb3034d5be4d3a9$var$DEFAULT_RETRY_BACKOFF, sizeBytes = 0, calculateLogSizeBytes = $bbb3034d5be4d3a9$export$a8bbed3c2f27a07) {
    let timeout;
    let cb;
    let buffer = [];
    let bufferSizeBytes = 0;
    let retry = 0;
    // Wait until the minimum retry backoff time has passed before retrying
    let minRetryBackoff = 0;
    /*
     * Process then flush the list
     */ async function flush() {
        if (timeout) clearTimeout(timeout);
        timeout = null;
        const currentBuffer = buffer;
        const currentBufferSizeKB = bufferSizeBytes;
        buffer = [];
        bufferSizeBytes = 0;
        try {
            await cb(currentBuffer.map((d)=>d.log));
            currentBuffer.forEach((d)=>d.resolve(d.log));
            retry = 0;
        } catch (e) {
            if (retry < retryCount) {
                retry++;
                minRetryBackoff = Date.now() + retryBackoff;
                buffer = buffer.concat(currentBuffer);
                bufferSizeBytes += currentBufferSizeKB;
                await setupTimeout();
                return;
            }
            currentBuffer.map((d)=>d.reject(e));
            retry = 0;
        }
    }
    /*
     * Start timeout to flush
     */ async function setupTimeout() {
        if (timeout) return;
        return new Promise((resolve)=>{
            timeout = setTimeout(async function() {
                await flush();
                resolve();
            }, flushTimeout);
        });
    }
    /*
     * Batcher which takes a process function
     * @param fn - Any function to process list
     */ return {
        initPusher: function(fn) {
            cb = fn;
            /*
             * Pushes each log into list
             * @param log: ILogtailLog - Any object to push into list
             */ return async function(log) {
                return new Promise(async (resolve, reject)=>{
                    buffer.push({
                        log: log,
                        resolve: resolve,
                        reject: reject
                    });
                    // We can skip log size calculation if there is no max size set
                    if (sizeBytes > 0) bufferSizeBytes += calculateLogSizeBytes(log);
                    // If the buffer is full enough, flush it
                    // Unless we're still waiting for the minimum retry backoff time
                    const isBufferFullEnough = buffer.length >= size || sizeBytes > 0 && bufferSizeBytes >= sizeBytes;
                    if (isBufferFullEnough && Date.now() > minRetryBackoff) await flush();
                    else await setupTimeout();
                    return resolve;
                });
            };
        },
        flush: flush
    };
}

const $2bc9be1c9dfcbd32$var$RESOLUTION = 64;
function $2bc9be1c9dfcbd32$export$2e2bcd8739ae039(milliseconds, max, functionName = "The function") {
    if (milliseconds <= 0 || max <= 0) return (fn)=>fn;
    let callCounts = [
        0
    ];
    let lastErrorOutput = 0;
    let lastIntervalTime = Date.now();
    function updateCallCounts() {
        const now = Date.now();
        const intervalLength = milliseconds / $2bc9be1c9dfcbd32$var$RESOLUTION;
        if (now < lastIntervalTime + intervalLength) return;
        // Prepend callCounts with correct number of zeroes and keep its length to RESOLUTION at max
        const intervalCountSinceLast = Math.floor((now - lastIntervalTime) / intervalLength);
        callCounts = Array(Math.min(intervalCountSinceLast, $2bc9be1c9dfcbd32$var$RESOLUTION)).fill(0).concat(callCounts).slice(0, $2bc9be1c9dfcbd32$var$RESOLUTION);
        lastIntervalTime += intervalCountSinceLast * intervalLength;
    }
    function getTotalCallCount() {
        return callCounts.reduce((total, item)=>total + item);
    }
    function incrementCallCount() {
        callCounts[0]++;
    }
    return (fn)=>{
        return async (...args)=>{
            updateCallCounts();
            if (getTotalCallCount() < max) {
                incrementCallCount();
                return await fn(...args);
            }
            const now = Date.now();
            if (lastErrorOutput < now - milliseconds) {
                lastErrorOutput = now;
                console.error(`${functionName} was called more than ${max} times during last ${milliseconds}ms. Ignoring.`);
            }
        };
    };
}

/**
 * Queue, for FIFO access to arbitrary objects. Intended to be a faster
 * replacement for a Javascript array.
 */ class $46e0f55b1dbdacdb$export$2e2bcd8739ae039 {
    constructor(){
        /**
         * First node in the tree
         */ /**
         * Number of items in the queue
         */ this.length = 0;
    }
    /**
     * Pushes a value into the queue.
     * @param value - Any object to push into the queue
     */ push(value) {
        const node = {
            value: value
        };
        this.last = this.last ? this.last.next = node : this.first = node;
        this.length++;
    }
    /**
     * Remove a value from the start of the queue (FIFO) and return it
     */ shift() {
        if (this.first) {
            const { value: value } = this.first;
            this.first = this.first.next;
            if (!--this.length) this.last = undefined;
            return value;
        }
    }
}


function $cf2140ce505836d9$export$2e2bcd8739ae039(max) {
    // Current iteration cycle
    let current = 0;
    // Create a FIFO queue
    const queue = new (0, $46e0f55b1dbdacdb$export$2e2bcd8739ae039)();
    /**
     * Throttle function that throttles the passed func according to `max`
     * @param fn - async function to resolve
     */ function throttle(fn) {
        return async (...args)=>{
            return new Promise((resolve, reject)=>{
                /**
                 * Handler for resolving the Promise chain
                 */ async function handler() {
                    // Only resolve if the `max` hasn't been exhausted
                    if (current < max) {
                        // Increment the available slot size
                        current++;
                        try {
                            // Await the passed function here first, to determine if any
                            // errors are thrown, so they can be handled by our outside `reject`
                            resolve(await fn(...args));
                        } catch (e) {
                            reject(e);
                        }
                        // Since this has now resolved, make the slot available again
                        current--;
                        // If there are items waiting in the queue, resolve the next
                        // Promise
                        if (queue.length > 0) queue.shift()();
                    } else // The `max` has been exceeded - push onto the queue to wait
                    queue.push(handler);
                }
                // Return the async handler
                return handler();
            });
        };
    }
    // Return the throttle function
    return throttle;
}


var $e0bef6558f50ff3f$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
'use strict';
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
'use strict';
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup['-'.charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup['_'.charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
var $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    var buf = $24f87a6f86a8996f$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    var buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        var len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        var buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $24f87a6f86a8996f$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case 'base64':
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3caef5c332c7293f$export$6100ba28696e12de(buf);
    else return $3caef5c332c7293f$export$6100ba28696e12de(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $3caef5c332c7293f$export$d622b2ad8d90c771($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $e0bef6558f50ff3f$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
'use strict';
class $e0bef6558f50ff3f$var$NonError extends Error {
    constructor(message){
        super($e0bef6558f50ff3f$var$NonError._prepareSuperMessage(message));
        Object.defineProperty(this, 'name', {
            value: 'NonError',
            configurable: true,
            writable: true
        });
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e0bef6558f50ff3f$var$NonError);
    }
    static _prepareSuperMessage(message) {
        try {
            return JSON.stringify(message);
        } catch  {
            return String(message);
        }
    }
}
const $e0bef6558f50ff3f$var$commonProperties = [
    {
        property: 'name',
        enumerable: false
    },
    {
        property: 'message',
        enumerable: false
    },
    {
        property: 'stack',
        enumerable: false
    },
    {
        property: 'code',
        enumerable: true
    }
];
const $e0bef6558f50ff3f$var$isCalled = Symbol('.toJSON called');
const $e0bef6558f50ff3f$var$toJSON = (from)=>{
    from[$e0bef6558f50ff3f$var$isCalled] = true;
    const json = from.toJSON();
    delete from[$e0bef6558f50ff3f$var$isCalled];
    return json;
};
const $e0bef6558f50ff3f$var$destroyCircular = ({ from: from, seen: seen, to_: to_, forceEnumerable: forceEnumerable, maxDepth: maxDepth, depth: depth })=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    if (depth >= maxDepth) return to;
    if (typeof from.toJSON === 'function' && from[$e0bef6558f50ff3f$var$isCalled] !== true) return $e0bef6558f50ff3f$var$toJSON(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof $e0bef6558f50ff3f$require$Buffer === 'function' && $e0bef6558f50ff3f$require$Buffer.isBuffer(value)) {
            to[key] = '[object Buffer]';
            continue;
        }
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            depth++;
            to[key] = $e0bef6558f50ff3f$var$destroyCircular({
                from: from[key],
                seen: seen.slice(),
                forceEnumerable: forceEnumerable,
                maxDepth: maxDepth,
                depth: depth
            });
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const { property: property, enumerable: enumerable } of $e0bef6558f50ff3f$var$commonProperties)if (typeof from[property] === 'string') Object.defineProperty(to, property, {
        value: from[property],
        enumerable: forceEnumerable ? true : enumerable,
        configurable: true,
        writable: true
    });
    return to;
};
const $e0bef6558f50ff3f$var$serializeError = (value, options = {})=>{
    const { maxDepth: maxDepth = Number.POSITIVE_INFINITY } = options;
    if (typeof value === 'object' && value !== null) return $e0bef6558f50ff3f$var$destroyCircular({
        from: value,
        seen: [],
        forceEnumerable: true,
        maxDepth: maxDepth,
        depth: 0
    });
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $e0bef6558f50ff3f$var$deserializeError = (value, options = {})=>{
    const { maxDepth: maxDepth = Number.POSITIVE_INFINITY } = options;
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error(); // eslint-disable-line unicorn/error-message
        $e0bef6558f50ff3f$var$destroyCircular({
            from: value,
            seen: [],
            to_: newError,
            maxDepth: maxDepth,
            depth: 0
        });
        return newError;
    }
    return new $e0bef6558f50ff3f$var$NonError(value);
};
$e0bef6558f50ff3f$exports = {
    serializeError: $e0bef6558f50ff3f$var$serializeError,
    deserializeError: $e0bef6558f50ff3f$var$deserializeError
};


// Set default options for Logtail
const $700bc2d848aaed52$var$defaultOptions = {
    // Default sync endpoint (protocol + domain)
    endpoint: "https://in.logs.betterstack.com",
    // Maximum number of logs to sync in a single request to Better Stack
    batchSize: 1000,
    // Size of logs (in KiB) to trigger sync to Better Stack (0 to disable)
    batchSizeKiB: 0,
    // Max interval (in milliseconds) before a batch of logs proceeds to syncing
    batchInterval: 1000,
    // Maximum number of times to retry a failed sync request
    retryCount: 3,
    // Minimum number of milliseconds to wait before retrying a failed sync request
    retryBackoff: 100,
    // Maximum number of sync requests to make concurrently
    syncMax: 5,
    // Length of the checked window for logs burst protection in milliseconds (0 to disable)
    burstProtectionMilliseconds: 5000,
    // Maximum number of accepted logs in the specified time window (0 to disable)
    burstProtectionMax: 10000,
    // If true, errors when sending logs will be ignored
    // Has precedence over throwExceptions
    ignoreExceptions: false,
    // If true, errors when sending logs will result in a thrown exception
    throwExceptions: false,
    // Maximum depth (number of attribute levels) of a context object
    contextObjectMaxDepth: 50,
    // Produce a warn log when context object max depth is reached
    contextObjectMaxDepthWarn: true,
    // Produce a warning when circular reference is found in context object
    contextObjectCircularRefWarn: true,
    // If true, all logs will be sent to standard console output functions (console.info, console.warn, ...)
    sendLogsToConsoleOutput: false,
    // If true, all logs will be sent to Better Stack
    sendLogsToBetterStack: true,
    // Function to be used to calculate size of logs in bytes (to evaluate batchSizeLimitKiB)
    calculateLogSizeBytes: (0, $bbb3034d5be4d3a9$export$a8bbed3c2f27a07)
};
/**
 * Logtail core class for logging to the Better Stack service
 */ class $700bc2d848aaed52$var$Logtail {
    /* CONSTRUCTOR */ /**
     * Initializes a new Logtail instance
     *
     * @param sourceToken: string - Private source token for logging to Better Stack
     * @param options?: ILogtailOptions - Optionally specify Logtail options
     */ constructor(sourceToken, options){
        // Middleware
        this._middleware = [];
        // Number of logs logged
        this._countLogged = 0;
        // Number of logs successfully synced with Logtail
        this._countSynced = 0;
        // Number of logs that failed to be synced to Logtail
        this._countDropped = 0;
        // First, check we have a valid source token
        if (typeof sourceToken !== "string" || sourceToken === "") throw new Error("Logtail source token missing");
        // Store the source token, to use for syncing with Better Stack
        this._sourceToken = sourceToken;
        // Merge default and user options
        this._options = Object.assign(Object.assign({}, $700bc2d848aaed52$var$defaultOptions), options);
        // Create a throttler, for sync operations
        const throttle = (0, $cf2140ce505836d9$export$2e2bcd8739ae039)(this._options.syncMax);
        // Sync after throttling
        const throttler = throttle((logs)=>{
            return this._sync(logs);
        });
        // Burst protection for logging
        this._logBurstProtection = (0, $2bc9be1c9dfcbd32$export$2e2bcd8739ae039)(this._options.burstProtectionMilliseconds, this._options.burstProtectionMax, "Logging");
        this.log = this._logBurstProtection(this.log.bind(this));
        // Create a batcher, for aggregating logs by buffer size/interval
        const batcher = (0, $bbb3034d5be4d3a9$export$2e2bcd8739ae039)(this._options.batchSize, this._options.batchInterval, this._options.retryCount, this._options.retryBackoff, this._options.batchSizeKiB * 1024, this._options.calculateLogSizeBytes);
        this._batch = batcher.initPusher((logs)=>{
            return throttler(logs);
        });
        this._flush = batcher.flush;
    }
    /* PUBLIC METHODS */ /**
     * Flush batched logs to Logtail
     */ async flush() {
        return this._flush();
    }
    /**
     * Number of entries logged
     *
     * @returns number
     */ get logged() {
        return this._countLogged;
    }
    /**
     * Number of log entries synced with Better Stack
     *
     * @returns number
     */ get synced() {
        return this._countSynced;
    }
    /**
     * Number of entries dropped
     *
     * @returns number
     */ get dropped() {
        return this._countDropped;
    }
    /**
     * Log an entry, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async log(message, level = (0, $4559429c2cf1b332$export$243e62d78d3b544d).Info, context = {}) {
        // Wrap context in an object, if it's not already
        if (typeof context !== "object") {
            const wrappedContext = {
                extra: context
            };
            context = wrappedContext;
        }
        if (context instanceof Error) {
            const wrappedContext = {
                error: context
            };
            context = wrappedContext;
        }
        if (this._options.sendLogsToConsoleOutput) switch(level){
            case "debug":
                console.debug(message, context);
                break;
            case "info":
                console.info(message, context);
                break;
            case "warn":
                console.warn(message, context);
                break;
            case "error":
                console.error(message, context);
                break;
            default:
                console.log(`[${level.toUpperCase()}]`, message, context);
                break;
        }
        // Check that we have a sync function
        if (typeof this._sync !== "function") throw new Error("No Logtail logger sync function provided");
        // Increment log count
        this._countLogged++;
        // Start building the log message
        let log = Object.assign(Object.assign({
            // Implicit date timestamp
            dt: new Date(),
            level: // Explicit level
            level
        }, context), message instanceof Error ? (0, $e0bef6558f50ff3f$exports.serializeError)(message) : {
            message: message
        });
        let transformedLog = log;
        for (const middleware of this._middleware){
            let newTransformedLog = await middleware(transformedLog);
            if (newTransformedLog == null) // Don't push the log if it was filtered out in a middleware
            return transformedLog;
            transformedLog = newTransformedLog;
        }
        // Manually serialize the log data
        transformedLog = this.serialize(transformedLog, this._options.contextObjectMaxDepth);
        if (!this._options.sendLogsToBetterStack) // Return the resulting log before sending it
        return transformedLog;
        try {
            // Push the log through the batcher, and sync
            await this._batch(transformedLog);
            // Increment sync count
            this._countSynced++;
        } catch (e) {
            // Increment dropped count
            this._countDropped++;
            // Catch any errors - re-throw if `ignoreExceptions` == false
            if (!this._options.ignoreExceptions) {
                if (this._options.throwExceptions) throw e;
                else // Output to console
                console.error(e);
            }
        }
        // Return the resulting log
        return transformedLog;
    }
    serialize(value, maxDepth, visitedObjects = new WeakSet()) {
        if (value === null || typeof value === "boolean" || typeof value === "number" || typeof value === "string") return value;
        else if (value instanceof Date) {
            // Date instances can be invalid & toISOString() will fail
            if (isNaN(value.getTime())) return value.toString();
            return value.toISOString();
        } else if (value instanceof Error) return (0, $e0bef6558f50ff3f$exports.serializeError)(value);
        else if ((typeof value === "object" || Array.isArray(value)) && (maxDepth < 1 || visitedObjects.has(value))) {
            if (visitedObjects.has(value)) {
                if (this._options.contextObjectCircularRefWarn) console.warn(`[Logtail] Found a circular reference when serializing logs. Please do not use circular references in your logs.`);
                return "<omitted circular reference>";
            }
            if (this._options.contextObjectMaxDepthWarn) console.warn(`[Logtail] Max depth of ${this._options.contextObjectMaxDepth} reached when serializing logs. Please do not use excessive object depth in your logs.`);
            return `<omitted context beyond configured max depth: ${this._options.contextObjectMaxDepth}>`;
        } else if (Array.isArray(value)) {
            visitedObjects.add(value);
            const serializedArray = value.map((item)=>this.serialize(item, maxDepth - 1, visitedObjects));
            visitedObjects.delete(value);
            return serializedArray;
        } else if (typeof value === "object") {
            const serializedObject = {};
            visitedObjects.add(value);
            Object.entries(value).forEach((item)=>{
                const key = item[0];
                const value = item[1];
                const serializedValue = this.serialize(value, maxDepth - 1, visitedObjects);
                if (serializedValue !== undefined) serializedObject[key] = serializedValue;
            });
            visitedObjects.delete(value);
            return serializedObject;
        } else if (typeof value === "undefined") return undefined;
        else return `<omitted unserializable ${typeof value}>`;
    }
    /**
     *
     * Debug level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async debug(message, context = {}) {
        return this.log(message, (0, $4559429c2cf1b332$export$243e62d78d3b544d).Debug, context);
    }
    /**
     *
     * Info level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async info(message, context = {}) {
        return this.log(message, (0, $4559429c2cf1b332$export$243e62d78d3b544d).Info, context);
    }
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async warn(message, context = {}) {
        return this.log(message, (0, $4559429c2cf1b332$export$243e62d78d3b544d).Warn, context);
    }
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async error(message, context = {}) {
        return this.log(message, (0, $4559429c2cf1b332$export$243e62d78d3b544d).Error, context);
    }
    /**
     * Sets the sync method - i.e. the final step in the pipeline to get logs
     * over to Better Stack
     *
     * @param fn - Pipeline function to use as sync method
     */ setSync(fn) {
        this._sync = fn;
    }
    /**
     * Add a middleware function to the logging pipeline
     *
     * @param fn - Function to add to the log pipeline
     * @returns void
     */ use(fn) {
        this._middleware.push(fn);
    }
    /**
     * Remove a function from the pipeline
     *
     * @param fn - Pipeline function
     * @returns void
     */ remove(fn) {
        this._middleware = this._middleware.filter((p)=>p !== fn);
    }
}
class $700bc2d848aaed52$export$2e2bcd8739ae039 extends $700bc2d848aaed52$var$Logtail {
    async log(message, level = (0, $4559429c2cf1b332$export$243e62d78d3b544d).Info, context = {}) {
        return super.log(message, level, context);
    }
}


class $9d2630c38f025f69$export$5fefc2586e00a689 extends (0, $700bc2d848aaed52$export$2e2bcd8739ae039) {
    constructor(sourceToken, options){
        // After reaching 48KiB, the batch will get flushed automatically to avoid 64KiB body limit for keepalive requests
        super(sourceToken, Object.assign({
            batchSizeKiB: 48
        }, options));
        // Sync function
        const sync = async (logs)=>{
            const res = await fetch(this._options.endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${this._sourceToken}`
                },
                body: JSON.stringify(logs),
                keepalive: true
            });
            if (res.ok) return logs;
            /**
             * TODO: if status is 50x throw custom ServerError
             * to be used in retry logic
             */ throw new Error(res.statusText);
        };
        // Set the throttled sync function
        this.setSync(sync);
        this.configureFlushOnPageLeave();
    }
    /**
     * Override `Base` log to add browser-specific context
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Log context for passing structured data
     * @returns Promise<ILogtailLog> after syncing
     */ async log(message, level, context = {}) {
        // Wrap context in an object, if it's not already
        if (typeof context !== "object") {
            const wrappedContext = {
                extra: context
            };
            context = wrappedContext;
        }
        if (context instanceof Error) {
            const wrappedContext = {
                error: context
            };
            context = wrappedContext;
        }
        context = Object.assign(Object.assign({}, this.getCurrentContext()), context);
        return super.log(message, level, context);
    }
    getCurrentContext() {
        var _a, _b, _c;
        const context = {};
        if (typeof window !== "undefined") {
            context.url = (_a = window.location) === null || _a === void 0 ? void 0 : _a.href;
            context.device_pixel_ratio = window.devicePixelRatio;
            context.screen_width = (_b = window.screen) === null || _b === void 0 ? void 0 : _b.width;
            context.screen_height = (_c = window.screen) === null || _c === void 0 ? void 0 : _c.height;
            context.window_width = window.innerWidth;
            context.window_height = window.innerHeight;
        }
        if (typeof navigator !== "undefined") {
            context.user_locale = navigator.userLanguage || navigator.language;
            context.user_agent = navigator.userAgent;
        }
        return context;
    }
    configureFlushOnPageLeave() {
        if (typeof document === "undefined") return;
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "hidden") this.flush();
        });
    }
}


var $73f57b4fac3fed59$export$2e2bcd8739ae039 = (token)=>{
    if (token && token !== "debug") return new (0, $9d2630c38f025f69$export$5fefc2586e00a689)(token);
    else if (token && token === "debug") return console;
    else return {
        log: ()=>{},
        info: ()=>{},
        warn: ()=>{},
        error: ()=>{}
    };
};


const $0c3ba46f72f9e9de$var$pb = new (0, $2b3a5afb4a111d4d$export$2e2bcd8739ae039)("https://api.konsens.it");
const $0c3ba46f72f9e9de$var$logger = (0, $73f57b4fac3fed59$export$2e2bcd8739ae039)("rZjUn6befD8mShdVCqpvuABM");
function $0c3ba46f72f9e9de$export$2e2bcd8739ae039(output) {
    return async (incomingMessage)=>{
        switch(incomingMessage.tag){
            case "LogError":
                $0c3ba46f72f9e9de$var$logger.error("LogError", incomingMessage.value);
                break;
            case "GetQuestion":
                {
                    let response;
                    try {
                        response = await $0c3ba46f72f9e9de$var$pb.collection("questions").getOne(incomingMessage.value, {
                            fields: "id,title,phase,author,description,created,expiresAt,proposalsEndedAt,ratingEndedAt,phaseCodePublic,expand.proposals_via_questionId.id,expand.proposals_via_questionId.title,expand.proposals_via_questionId.description,expand.proposals_via_questionId.isExcluded,expand.proposals_via_questionId.questionId,expand.proposals_via_questionId.created,expand.ratings_via_questionId.proposalId,expand.ratings_via_questionId.author,expand.ratings_via_questionId.points,expand.ratings_via_questionId.created",
                            expand: "proposals_via_questionId,ratings_via_questionId"
                        });
                    } catch (error) {
                        if (error.status === 404 && error?.response?.message === "The requested resource wasn't found.") {
                            output("GoToNotFound");
                            break;
                        }
                        output("ReceivedError", error?.response?.message);
                        $0c3ba46f72f9e9de$var$logger.error("GetQuestion", {
                            id: incomingMessage.value,
                            error: error
                        });
                        break;
                    }
                    const { id: id, title: title, phase: phase, author: author, description: description, created: created, proposalsEndedAt: proposalsEndedAt, ratingEndedAt: ratingEndedAt, phaseCodePublic: phaseCodePublic, expand: expand } = response;
                    const expiresAt = $0c3ba46f72f9e9de$var$getExpiresAt(created);
                    const question = {
                        id: id,
                        title: title,
                        phase: phase,
                        author: author,
                        description: description || null,
                        createdAt: new Date(created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposalsEndedAt: proposalsEndedAt ? new Date(proposalsEndedAt).getTime() : null,
                        ratingEndedAt: ratingEndedAt ? new Date(ratingEndedAt).getTime() : null,
                        proposals: expand?.proposals_via_questionId?.map((proposal)=>({
                                id: proposal.id,
                                title: proposal.title,
                                description: proposal.description || null,
                                isExcluded: proposal.isExcluded,
                                questionId: proposal.questionId,
                                createdAt: new Date(proposal.created).getTime()
                            })) || [],
                        ratings: expand?.ratings_via_questionId?.map((rating)=>({
                                proposalId: rating.proposalId || "DEFAULT",
                                author: rating.author,
                                points: rating.points,
                                createdAt: new Date(rating.created).getTime()
                            })) || [],
                        phaseCodePublic: phaseCodePublic || null
                    };
                    output("ReceivedQuestion", question);
                    break;
                }
            case "PostNewQuestion":
                {
                    const { title: submittedTitle, author: submittedAuthor, description: submittedDescription, phaseCode: submittedPhaseCode } = incomingMessage.value;
                    let phaseCode;
                    let phaseCodePublic;
                    if (submittedPhaseCode) {
                        phaseCode = await $0c3ba46f72f9e9de$var$sha256(submittedPhaseCode);
                        phaseCodePublic = await $0c3ba46f72f9e9de$var$sha256(phaseCode);
                    }
                    const data = {
                        title: submittedTitle,
                        author: submittedAuthor,
                        description: submittedDescription,
                        phase: "PROPOSAL",
                        ...phaseCodePublic && {
                            phaseCodePublic: phaseCodePublic
                        }
                    };
                    let record;
                    try {
                        record = await $0c3ba46f72f9e9de$var$pb.collection("questions").create(data);
                        if (phaseCode) await $0c3ba46f72f9e9de$var$pb.collection("phasecodes").create({
                            phasecode: phaseCode,
                            questionId: record.id
                        });
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $0c3ba46f72f9e9de$var$logger.error("PostNewQuestion", {
                            error: error
                        });
                        break;
                    }
                    const expiresAt = $0c3ba46f72f9e9de$var$getExpiresAt(record.created);
                    const newQuestion = {
                        id: record.id,
                        title: record.title,
                        author: record.author,
                        description: record.description || null,
                        phase: record.phase,
                        createdAt: new Date(record.created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposals: [],
                        ratings: [],
                        phaseCodePublic: record.phaseCodePublic || null
                    };
                    output("ReceivedQuestion", newQuestion);
                    break;
                }
            case "PostNewProposal":
                {
                    const { value: { questionId: submittedQuestionId, title: submittedTitle, description: submittedDescription } } = incomingMessage;
                    const data = {
                        questionId: submittedQuestionId,
                        title: submittedTitle,
                        description: submittedDescription
                    };
                    let record;
                    try {
                        record = await $0c3ba46f72f9e9de$var$pb.collection("proposals").create(data);
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $0c3ba46f72f9e9de$var$logger.error("PostNewProposal", {
                            id: submittedQuestionId,
                            error: error
                        });
                        break;
                    }
                    const { id: id, title: title, description: description, isExcluded: isExcluded, created: created } = record;
                    const newProposal = {
                        id: id,
                        title: title,
                        isExcluded: isExcluded,
                        ...description && {
                            description: description
                        },
                        createdAt: new Date(created).getTime()
                    };
                    output("ReceivedPublishedProposal", newProposal);
                    break;
                }
            case "ExcludeProposal":
                {
                    const { proposalId: proposalId, isExcluded: isExcluded } = incomingMessage.value;
                    await $0c3ba46f72f9e9de$var$pb.collection("proposals").update(proposalId, {
                        isExcluded: isExcluded
                    });
                    break;
                }
            case "GoToRatingPhase":
                {
                    const { questionId: questionId, phaseCode: phaseCode } = incomingMessage.value;
                    let record;
                    try {
                        record = await $0c3ba46f72f9e9de$var$pb.collection("questions").update(questionId, {
                            phase: "RATING",
                            proposalsEndedAt: new Date()
                        }, {
                            fields: "id,title,phase,author,description,created,expiresAt,proposalsEndedAt,ratingEndedAt,phaseCodePublic,expand.proposals_via_questionId.id,expand.proposals_via_questionId.title,expand.proposals_via_questionId.description,expand.proposals_via_questionId.isExcluded,expand.proposals_via_questionId.questionId,expand.proposals_via_questionId.created,expand.ratings_via_questionId.proposalId,expand.ratings_via_questionId.author,expand.ratings_via_questionId.points,expand.ratings_via_questionId.created",
                            expand: "proposals_via_questionId,ratings_via_questionId",
                            headers: {
                                "X-Phase-Code": await $0c3ba46f72f9e9de$var$sha256(phaseCode) || ""
                            }
                        });
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $0c3ba46f72f9e9de$var$logger.error("GoToRatingPhase", {
                            id: questionId,
                            error: error
                        });
                        break;
                    }
                    const expiresAt = $0c3ba46f72f9e9de$var$getExpiresAt(record.created);
                    const updatedQuestion = {
                        id: record.id,
                        title: record.title,
                        author: record.author,
                        description: record.description || null,
                        phase: record.phase,
                        createdAt: new Date(record.created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposals: [],
                        ratings: [],
                        phaseCodePublic: record.phaseCodePublic || null,
                        proposalsEndedAt: record.proposalsEndedAt ? new Date(record.proposalsEndedAt).getTime() : null,
                        ratingEndedAt: record.ratingEndedAt ? new Date(record.ratingEndedAt).getTime() : null,
                        proposals: record.expand?.proposals_via_questionId?.map((proposal)=>({
                                ...proposal,
                                description: proposal.description || null,
                                createdAt: new Date(proposal.created).getTime()
                            })) || [],
                        ratings: record.expand?.ratings_via_questionId?.map((rating)=>({
                                ...rating,
                                proposalId: rating.proposalId ?? "DEFAULT",
                                createdAt: new Date(rating.created).getTime()
                            })) || []
                    };
                    output("ReceivedQuestion", updatedQuestion);
                    break;
                }
            case "PostRatings":
                {
                    const { questionId: questionId, author: author, ratings: ratings } = incomingMessage.value;
                    const batchRatings = $0c3ba46f72f9e9de$var$pb.createBatch();
                    for (const [proposalId, points] of ratings){
                        const data = {
                            author: author,
                            points: points,
                            proposalId: proposalId,
                            questionId: questionId
                        };
                        batchRatings.collection("ratings").create(data);
                    }
                    let result;
                    try {
                        result = await batchRatings.send();
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $0c3ba46f72f9e9de$var$logger.error("PostNewRatings", {
                            id: questionId,
                            error: error
                        });
                    }
                    const publishedRating = result.map((rating)=>({
                            ...rating.body,
                            proposalId: rating.body.proposalId ?? "DEFAULT",
                            createdAt: new Date(rating.body.created).getTime()
                        }));
                    output("ReceivedPublishedRating", publishedRating);
                    break;
                }
            case "GoToResultPhase":
                {
                    const { questionId: questionId, phaseCode: phaseCode } = incomingMessage.value;
                    let record;
                    try {
                        record = await $0c3ba46f72f9e9de$var$pb.collection("questions").update(questionId, {
                            phase: "RESULT",
                            ratingEndedAt: new Date()
                        }, {
                            fields: "id,title,phase,author,description,created,expiresAt,proposalsEndedAt,ratingEndedAt,phaseCodePublic,expand.proposals_via_questionId.id,expand.proposals_via_questionId.title,expand.proposals_via_questionId.description,expand.proposals_via_questionId.isExcluded,expand.proposals_via_questionId.questionId,expand.proposals_via_questionId.created,expand.ratings_via_questionId.proposalId,expand.ratings_via_questionId.author,expand.ratings_via_questionId.points,expand.ratings_via_questionId.created",
                            expand: "proposals_via_questionId,ratings_via_questionId",
                            headers: {
                                "X-Phase-Code": await $0c3ba46f72f9e9de$var$sha256(phaseCode) || ""
                            }
                        });
                    } catch (error) {
                        output("ReceivedError", error.message);
                        $0c3ba46f72f9e9de$var$logger.error("GoToResultPhase", {
                            id: questionId,
                            error: error
                        });
                        break;
                    }
                    const expiresAt = $0c3ba46f72f9e9de$var$getExpiresAt(record.created);
                    const updatedQuestion = {
                        id: record.id,
                        title: record.title,
                        author: record.author,
                        description: record.description || null,
                        phase: record.phase,
                        createdAt: new Date(record.created).getTime(),
                        expiresAt: new Date(expiresAt).getTime(),
                        proposals: [],
                        ratings: [],
                        phaseCodePublic: record.phaseCodePublic || null,
                        proposalsEndedAt: record.proposalsEndedAt ? new Date(record.proposalsEndedAt).getTime() : null,
                        ratingEndedAt: record.ratingEndedAt ? new Date(record.ratingEndedAt).getTime() : null,
                        proposals: record.expand?.proposals_via_questionId?.map((proposal)=>({
                                ...proposal,
                                description: proposal.description || null,
                                createdAt: new Date(proposal.created).getTime()
                            })) || [],
                        ratings: record.expand?.ratings_via_questionId?.map((rating)=>({
                                ...rating,
                                proposalId: rating.proposalId ?? "DEFAULT",
                                createdAt: new Date(rating.created).getTime()
                            })) || []
                    };
                    output("ReceivedQuestion", updatedQuestion);
                    break;
                }
            case "DeleteQuestion":
                {
                    const { questionId: questionId, phaseCode: phaseCode } = incomingMessage.value;
                    await $0c3ba46f72f9e9de$var$pb.collection("questions").delete(questionId, {
                        headers: {
                            "X-Phase-Code": await $0c3ba46f72f9e9de$var$sha256(phaseCode) || ""
                        }
                    });
                    break;
                }
            case "SubscribeToPhaseChanges":
                {
                    const questionId = incomingMessage.value;
                    await $0c3ba46f72f9e9de$var$pb.collection("questions").subscribe(questionId, async ({ record: record, action: action })=>{
                        if (action === "delete") output("QuestionDeleted");
                        else {
                            const sanitizedData = {
                                proposalsEndedAt: record.proposalsEndedAt ? new Date(record.proposalsEndedAt).getTime() : null,
                                ratingEndedAt: record.ratingEndedAt ? new Date(record.ratingEndedAt).getTime() : null
                            };
                            output("ReceivedPhaseChange", sanitizedData);
                        }
                    }, {
                        fields: "proposalsEndedAt, ratingEndedAt, expand.proposals_via_questionId.id, expand.proposals_via_questionId.title, expand.proposals_via_questionId.description, expand.proposals_via_questionId.isExcluded, expand.proposals_via_questionId.questionId, expand.proposals_via_questionId.created, expand.ratings_via_questionId.proposalId, expand.ratings_via_questionId.author, expand.ratings_via_questionId.points, expand.ratings_via_questionId.created",
                        expand: "proposals_via_questionId,ratings_via_questionId"
                    });
                    break;
                }
            case "SubscribeToNewProposals":
                {
                    const questionId = incomingMessage.value;
                    await $0c3ba46f72f9e9de$var$pb.collection("proposals").subscribe("*", async ({ record: record })=>{
                        try {
                            const proposals = await $0c3ba46f72f9e9de$var$pb.collection("questions").getOne(record.questionId, {
                                fields: "expand.proposals_via_questionId.id,expand.proposals_via_questionId.title,expand.proposals_via_questionId.description,expand.proposals_via_questionId.isExcluded,expand.proposals_via_questionId.questionId,expand.proposals_via_questionId.created",
                                expand: "proposals_via_questionId"
                            });
                            const updatedProposals = proposals.expand.proposals_via_questionId.map((proposal)=>({
                                    ...proposal,
                                    description: proposal.description || null,
                                    createdAt: new Date(proposal.created).getTime()
                                }));
                            output("ReceivedNewProposals", updatedProposals);
                        } catch (error) {
                            if (error.message.includes("autocancelled")) return;
                            console.error(error);
                        }
                    }, {
                        filter: `questionId="${questionId}"`
                    });
                    break;
                }
            case "SubscribeToNewRatings":
                {
                    const questionId = incomingMessage.value;
                    await $0c3ba46f72f9e9de$var$pb.collection("ratings").subscribe("*", async ({ record: record })=>{
                        try {
                            const ratings = await $0c3ba46f72f9e9de$var$pb.collection("questions").getOne(record.questionId, {
                                fields: "expand.ratings_via_questionId.proposalId,expand.ratings_via_questionId.author,expand.ratings_via_questionId.points,expand.ratings_via_questionId.created",
                                expand: "ratings_via_questionId"
                            });
                            const updatedRatings = ratings.expand.ratings_via_questionId.map((rating)=>({
                                    ...rating,
                                    proposalId: rating.proposalId ?? "DEFAULT",
                                    createdAt: new Date(rating.created).getTime()
                                }));
                            output("ReceivedNewRatings", updatedRatings);
                        } catch (error) {
                            if (error.message.includes("autocancelled")) return;
                            console.error(error);
                        }
                    }, {
                        filter: `questionId="${questionId}"`
                    });
                    break;
                }
            case "UnsubscribeFromPhaseChanges":
                $0c3ba46f72f9e9de$var$pb.collection("questions").unsubscribe(incomingMessage.value);
                break;
            case "UnsubscribeFromNewProposals":
                $0c3ba46f72f9e9de$var$pb.collection("proposals").unsubscribe("*");
                break;
            case "UnsubscribeFromNewRatings":
                $0c3ba46f72f9e9de$var$pb.collection("ratings").unsubscribe("*");
                break;
            case "HashPhaseCode":
                {
                    const text = incomingMessage.value;
                    const hash = await $0c3ba46f72f9e9de$var$sha256(await $0c3ba46f72f9e9de$var$sha256(text));
                    output("ReceivedHashedPhaseCode", hash);
                    break;
                }
            case "HashDeleteCode":
                {
                    const text = incomingMessage.value;
                    const hash = await $0c3ba46f72f9e9de$var$sha256(await $0c3ba46f72f9e9de$var$sha256(text));
                    output("ReceivedHashedDeleteCode", hash);
                    break;
                }
            default:
                $0c3ba46f72f9e9de$var$logger.error("JS received unkown message from Elm", incomingMessage);
        }
    };
}
async function $0c3ba46f72f9e9de$var$sha256(text) {
    if (typeof text !== "string") return null;
    try {
        const msgUint8 = new TextEncoder().encode(text);
        const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
        return hashHex;
    } catch (error) {
        return null;
    }
}
function $0c3ba46f72f9e9de$var$getExpiresAt(created) {
    const expiresAt = new Date(created);
    expiresAt.setDate(expiresAt.getDate() + 43);
    expiresAt.setUTCHours(0, 0, 0);
    return expiresAt;
}


var $e8f86c20c81918e6$exports = {};

$e8f86c20c81918e6$exports = (parcelRequire("aNJCr")).getBundleURL('EVgbq') + "konsens.b49e7e7e.svg";


const $b8f9b7833fa37166$var$app = (0, $09ec739d0d47b71c$exports.Elm).Main.init({
    flags: {
        seed: Date.now(),
        now: Math.round(Date.now()),
        url: window.location.href,
        copy: window.COPY,
        config: {
            appUrlEnglish: "https://lets.konsens.it",
            appUrlGerman: "https://mit.konsens.it",
            appUrlSpanish: "https://con.konsens.it",
            websiteUrl: "https://konsens.it/es",
            tinyteamUrl: "https://www.tinyteam.de",
            donateUrl: "https://paypal.me/konsens",
            feedbackFormUrl: "https://tally.so/embed/3yPklX?hideTitle=1&alignLeft=1",
            logoUrl: new URL($e8f86c20c81918e6$exports).href
        }
    },
    node: document.getElementById("app")
});
$b8f9b7833fa37166$var$app.ports.toJS.subscribe((0, $0c3ba46f72f9e9de$export$2e2bcd8739ae039)((tag, value)=>$b8f9b7833fa37166$var$app.ports.fromJS.send({
        tag: tag,
        value: value
    })));
$b8f9b7833fa37166$var$app.ports.selectText.subscribe((identifier)=>{
    document.querySelector(identifier).select();
});
$b8f9b7833fa37166$var$app.ports.copyToClipboard.subscribe(async ([elementId, text])=>{
    const button = document.getElementById(elementId);
    await navigator.clipboard.writeText(text);
    button.querySelector("div").classList.remove("opacity-0");
    button.querySelector("button").classList.add("opacity-0");
    setTimeout(()=>{
        button.querySelector("div").classList.add("opacity-0");
        button.querySelector("button").classList.remove("opacity-0");
    }, 2000);
});
$b8f9b7833fa37166$var$app.ports.showToast.subscribe(async (message)=>{
    const toast = document.getElementById("toast");
    if (message !== "") toast.lastElementChild.innerHTML = message;
    else toast.lastElementChild.innerHTML = "Sorry, someting went wrong. Please try again.";
    if (!toast.classList.contains("opacity-0")) return;
    toast.classList.remove("opacity-0", "-translate-y-1/2");
    setTimeout(()=>{
        toast.classList.add("opacity-0", "-translate-y-1/2");
    }, 5000);
});

$b8f9b7833fa37166$var$app.ports.pressedFoundErrorButton.subscribe(async (questionId)=>{
    await $b8f9b7833fa37166$var$loadExternalScript("https://tally.so/widgets/embed.js");
    const Bowser = await (parcelRequire("671Hv"));
    const { browser: browser, os: os } = Bowser.parse(window.navigator.userAgent);
    Tally.openPopup("nrje5l", {
        layout: "modal",
        width: 500,
        hideTitle: true,
        hiddenFields: {
            question_id: questionId,
            browser: [
                browser.name,
                browser.version
            ].join(" "),
            os: [
                os.name,
                os.versionName,
                os.version
            ].join(" ")
        }
    });
});
$b8f9b7833fa37166$var$app.ports.disableScrolling.subscribe((boolean)=>{
    document.body.classList.toggle("disable-scrolling", boolean);
});
$b8f9b7833fa37166$var$app.ports.updateUrl.subscribe((url)=>{
    if (url.startsWith("http")) window.location.href = url;
    else history.replaceState(null, "", url);
});
$b8f9b7833fa37166$var$app.ports.updateTitle.subscribe((title)=>{
    document.title = title + " | Let\u2019s konsens it!";
});
class $b8f9b7833fa37166$var$TextareaAutosize extends HTMLElement {
    connectedCallback() {
        const textarea = this.querySelector("textarea");
        if (textarea) (0, $55ac9bb4512a08c1$export$2e2bcd8739ae039)(textarea);
    }
}
customElements.define("textarea-autosize", $b8f9b7833fa37166$var$TextareaAutosize);
async function $b8f9b7833fa37166$var$loadExternalScript(url) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = url;
        script.onload = resolve;
        script.onerorr = reject;
        document.body.appendChild(script);
    });
}

})();
//# sourceMappingURL=index.04d1cd95.js.map
